// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"gAgdj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parameters", ()=>parameters);
parcelHelpers.export(exports, "decorators", ()=>decorators);
var _jsxRuntime = require("react/jsx-runtime");
var _page = require("@react-spectrum/s2/src/page");
var _theming = require("@storybook/theming");
var _storybookDarkMode = require("storybook-dark-mode");
var _tool = require("storybook-dark-mode/dist/esm/Tool");
var _previewApi = require("@storybook/preview-api");
var _addonDocs = require("@storybook/addon-docs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _provider = require("./custom-addons/provider");
var _globalCss = require("./global.css");
const channel = (0, _previewApi.addons).getChannel();
document.documentElement.dataset.colorScheme = (0, _tool.store)().current === 'dark' ? 'dark' : 'light';
channel.on((0, _storybookDarkMode.DARK_MODE_EVENT_NAME), (isDark)=>document.documentElement.dataset.colorScheme = isDark ? 'dark' : 'light');
/** @type { import('@storybook/react').Preview } */ const preview = {
    parameters: {
        actions: {
            argTypesRegex: "^on[A-Z].*"
        },
        controls: {
            matchers: {},
            exclude: [
                'key',
                'ref'
            ]
        },
        docs: {
            container: (props)=>{
                let [dark, setDark] = (0, _react.useState)((0, _tool.store)().current === 'dark');
                (0, _react.useEffect)(()=>{
                    channel.on((0, _storybookDarkMode.DARK_MODE_EVENT_NAME), setDark);
                    return ()=>channel.removeListener((0, _storybookDarkMode.DARK_MODE_EVENT_NAME), setDark);
                }, []);
                var style = getComputedStyle(document.body);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addonDocs.DocsContainer), {
                    ...props,
                    theme: {
                        ...dark ? (0, _theming.themes).dark : (0, _theming.themes).light,
                        appContentBg: style.getPropertyValue('--s2-container-bg').trim()
                    }
                });
            },
            source: {
                // code: null, // Will disable code button, and show "No code available"
                transform: (code, ctx)=>{
                    code = ctx.parameters.docs?.source?.originalSource ?? code;
                    code = code.replace(/ \{\.\.\.args\}/g, '');
                    if (/^(.*?) =>/.test(code)) {
                        code = code.replace(/^(.*?) => /, '');
                        code = code.replace(/^\s{2}(\s+)/gm, '$1');
                        code = code.replace(/\n\s{2}(.*)$/, '\n$1');
                    }
                    return code;
                }
            }
        },
        darkMode: {
            light: {
                ...(0, _theming.themes).light,
                brandTitle: 'React Spectrum - Spectrum 2 Preview',
                brandImage: new URL(require("89968e8b1b1b84ee")).toString()
            },
            dark: {
                ...(0, _theming.themes).dark,
                brandTitle: 'React Spectrum - Spectrum 2 Preview',
                brandImage: new URL(require("979418d68a95067a")).toString()
            }
        },
        options: {
            storySort: {
                order: [
                    'Intro',
                    'Style Macro',
                    'Workflow Icons',
                    'Illustrations',
                    'Migrating',
                    'Release Notes'
                ],
                method: 'alphabetical'
            }
        }
    },
    argTypes: {
        styles: {
            table: {
                category: 'Styles'
            },
            control: {
                disable: true
            }
        },
        UNSAFE_className: {
            table: {
                category: 'Styles'
            },
            control: {
                disable: true
            }
        },
        UNSAFE_style: {
            table: {
                category: 'Styles'
            },
            control: {
                disable: true
            }
        }
    }
};
const parameters = {
    a11y: {
        config: {
            rules: [
                {
                    id: 'aria-hidden-focus',
                    selector: 'body *:not([data-a11y-ignore="aria-hidden-focus"])'
                }
            ]
        }
    },
    layout: 'fullscreen'
};
const decorators = [
    (0, _provider.withProviderSwitcher)
];
exports.default = preview;

},{"react/jsx-runtime":"2JzhG","@react-spectrum/s2/src/page":"dJhgC","@storybook/theming":"bYlbs","storybook-dark-mode":"croao","storybook-dark-mode/dist/esm/Tool":"jEcoY","@storybook/preview-api":"uDWyg","@storybook/addon-docs":"fvBVU","react":"jEiK2","./custom-addons/provider":"3g9OG","./global.css":"gTbQg","89968e8b1b1b84ee":"1JbRX","979418d68a95067a":"16UVx","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"dJhgC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ undefined;

},{"0":"e20Zy"}],"e20Zy":[function() {},{}],"croao":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the current state of storybook's dark-mode
 */ parcelHelpers.export(exports, "useDarkMode", ()=>useDarkMode);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _addons = require("@storybook/addons");
var _constants = require("./constants");
var _tool = require("./Tool");
parcelHelpers.exportAll(_constants, exports);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useDarkMode() {
    var _React$useState = (0, _reactDefault.default).useState((0, _tool.store)().current === 'dark'), _React$useState2 = _slicedToArray(_React$useState, 2), isDark = _React$useState2[0], setIsDark = _React$useState2[1];
    (0, _reactDefault.default).useEffect(function() {
        var chan = (0, _addons.addons).getChannel();
        chan.on((0, _constants.DARK_MODE_EVENT_NAME), setIsDark);
        return function() {
            return chan.off((0, _constants.DARK_MODE_EVENT_NAME), setIsDark);
        };
    }, []);
    return isDark;
}

},{"react":"jEiK2","@storybook/addons":"l913U","./constants":"fs2pJ","./Tool":"jEcoY","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"l913U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "types", ()=>(0, _types.Addon_TypesEnum));
parcelHelpers.export(exports, "addons", ()=>(0, _managerApi.addons));
parcelHelpers.export(exports, "mockChannel", ()=>(0, _managerApi.mockChannel));
parcelHelpers.export(exports, "HooksContext", ()=>(0, _addons.HooksContext));
parcelHelpers.export(exports, "applyHooks", ()=>(0, _addons.applyHooks));
parcelHelpers.export(exports, "makeDecorator", ()=>(0, _addons.makeDecorator));
parcelHelpers.export(exports, "useArgs", ()=>(0, _addons.useArgs));
parcelHelpers.export(exports, "useCallback", ()=>(0, _addons.useCallback));
parcelHelpers.export(exports, "useChannel", ()=>(0, _addons.useChannel));
parcelHelpers.export(exports, "useEffect", ()=>(0, _addons.useEffect));
parcelHelpers.export(exports, "useGlobals", ()=>(0, _addons.useGlobals));
parcelHelpers.export(exports, "useMemo", ()=>(0, _addons.useMemo));
parcelHelpers.export(exports, "useParameter", ()=>(0, _addons.useParameter));
parcelHelpers.export(exports, "useReducer", ()=>(0, _addons.useReducer));
parcelHelpers.export(exports, "useRef", ()=>(0, _addons.useRef));
parcelHelpers.export(exports, "useState", ()=>(0, _addons.useState));
parcelHelpers.export(exports, "useStoryContext", ()=>(0, _addons.useStoryContext));
var _types = require("@storybook/types");
var _managerApi = require("@storybook/manager-api");
var _addons = require("@storybook/preview-api/dist/addons");

},{"@storybook/types":false,"@storybook/manager-api":"hiBwD","@storybook/preview-api/dist/addons":false,"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"h7DQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Addon_TypesEnum", ()=>Addon_TypesEnum);
var Addon_TypesEnum = ((Addon_TypesEnum2)=>(Addon_TypesEnum2.TAB = "tab", Addon_TypesEnum2.PANEL = "panel", Addon_TypesEnum2.TOOL = "tool", Addon_TypesEnum2.TOOLEXTRA = "toolextra", Addon_TypesEnum2.PREVIEW = "preview", Addon_TypesEnum2.experimental_PAGE = "page", Addon_TypesEnum2.experimental_SIDEBAR_BOTTOM = "sidebar-bottom", Addon_TypesEnum2.experimental_SIDEBAR_TOP = "sidebar-top", Addon_TypesEnum2.NOTES_ELEMENT = "notes-element", Addon_TypesEnum2))(Addon_TypesEnum || {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hiBwD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActiveTabs", ()=>ActiveTabs2);
parcelHelpers.export(exports, "Consumer", ()=>ManagerConsumer);
parcelHelpers.export(exports, "ManagerContext", ()=>ManagerContext);
parcelHelpers.export(exports, "Provider", ()=>ManagerProvider);
parcelHelpers.export(exports, "addons", ()=>addons);
parcelHelpers.export(exports, "combineParameters", ()=>combineParameters);
parcelHelpers.export(exports, "controlOrMetaKey", ()=>controlOrMetaKey);
parcelHelpers.export(exports, "controlOrMetaSymbol", ()=>controlOrMetaSymbol);
parcelHelpers.export(exports, "eventMatchesShortcut", ()=>eventMatchesShortcut);
parcelHelpers.export(exports, "eventToShortcut", ()=>eventToShortcut);
parcelHelpers.export(exports, "isMacLike", ()=>isMacLike);
parcelHelpers.export(exports, "isShortcutTaken", ()=>isShortcutTaken);
parcelHelpers.export(exports, "keyToSymbol", ()=>keyToSymbol);
parcelHelpers.export(exports, "merge", ()=>merge_default);
parcelHelpers.export(exports, "mockChannel", ()=>mockChannel);
parcelHelpers.export(exports, "optionOrAltSymbol", ()=>optionOrAltSymbol);
parcelHelpers.export(exports, "shortcutMatchesShortcut", ()=>shortcutMatchesShortcut);
parcelHelpers.export(exports, "shortcutToHumanString", ()=>shortcutToHumanString);
parcelHelpers.export(exports, "types", ()=>typesX);
parcelHelpers.export(exports, "useAddonState", ()=>useAddonState);
parcelHelpers.export(exports, "useArgTypes", ()=>useArgTypes);
parcelHelpers.export(exports, "useArgs", ()=>useArgs);
parcelHelpers.export(exports, "useChannel", ()=>useChannel);
parcelHelpers.export(exports, "useGlobalTypes", ()=>useGlobalTypes);
parcelHelpers.export(exports, "useGlobals", ()=>useGlobals);
parcelHelpers.export(exports, "useParameter", ()=>useParameter);
parcelHelpers.export(exports, "useSharedState", ()=>useSharedState);
parcelHelpers.export(exports, "useStoryPrepared", ()=>useStoryPrepared);
parcelHelpers.export(exports, "useStorybookApi", ()=>useStorybookApi);
parcelHelpers.export(exports, "useStorybookState", ()=>useStorybookState);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mergeWithJs = require("lodash/mergeWith.js");
var _mergeWithJsDefault = parcelHelpers.interopDefault(_mergeWithJs);
var _coreEvents = require("@storybook/core-events");
var _clientLogger = require("@storybook/client-logger");
var _store2 = require("store2");
var _store2Default = parcelHelpers.interopDefault(_store2);
var _telejson = require("telejson");
var _isEqualJs = require("lodash/isEqual.js");
var _isEqualJsDefault = parcelHelpers.interopDefault(_isEqualJs);
var _types = require("@storybook/types");
var _global = require("@storybook/global");
var _csf = require("@storybook/csf");
var _tsDedent = require("ts-dedent");
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var _countByJs = require("lodash/countBy.js");
var _countByJsDefault = parcelHelpers.interopDefault(_countByJs);
var _mapValuesJs = require("lodash/mapValues.js");
var _mapValuesJsDefault = parcelHelpers.interopDefault(_mapValuesJs);
var _pickJs = require("lodash/pick.js");
var _pickJsDefault = parcelHelpers.interopDefault(_pickJs);
var _dequal = require("dequal");
var _create = require("@storybook/theming/create");
var _router = require("@storybook/router");
var _channels = require("@storybook/channels");
var process = require("7a5dfb4803e68fc7");
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod)=>function() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: !0
    });
}, __copyProps = (to, from, except, desc)=>{
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from))!__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
        get: ()=>from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: !0
    }) : target, mod));
var require_constants = __commonJS({
    "../../node_modules/semver/internal/constants.js" (exports, module) {
        var SEMVER_SPEC_VERSION = "2.0.0", MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991, MAX_SAFE_COMPONENT_LENGTH = 16, MAX_SAFE_BUILD_LENGTH = 250, RELEASE_TYPES = [
            "major",
            "premajor",
            "minor",
            "preminor",
            "patch",
            "prepatch",
            "prerelease"
        ];
        module.exports = {
            MAX_LENGTH: 256,
            MAX_SAFE_COMPONENT_LENGTH,
            MAX_SAFE_BUILD_LENGTH,
            MAX_SAFE_INTEGER,
            RELEASE_TYPES,
            SEMVER_SPEC_VERSION,
            FLAG_INCLUDE_PRERELEASE: 1,
            FLAG_LOOSE: 2
        };
    }
});
var require_debug = __commonJS({
    "../../node_modules/semver/internal/debug.js" (exports, module) {
        var debug = (typeof process == "object" && process.env && undefined, ()=>{});
        module.exports = debug;
    }
});
var require_re = __commonJS({
    "../../node_modules/semver/internal/re.js" (exports, module) {
        var { MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH, MAX_LENGTH } = require_constants(), debug = require_debug();
        exports = module.exports = {};
        var re = exports.re = [], safeRe = exports.safeRe = [], src = exports.src = [], t = exports.t = {}, R = 0, LETTERDASHNUMBER = "[a-zA-Z0-9-]", safeRegexReplacements = [
            [
                "\\s",
                1
            ],
            [
                "\\d",
                MAX_LENGTH
            ],
            [
                LETTERDASHNUMBER,
                MAX_SAFE_BUILD_LENGTH
            ]
        ], makeSafeRegex = (value)=>{
            for (let [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
            return value;
        }, createToken = (name, value, isGlobal)=>{
            let safe = makeSafeRegex(value), index = R++;
            debug(name, index, value), t[name] = index, src[index] = value, re[index] = new RegExp(value, isGlobal ? "g" : void 0), safeRe[index] = new RegExp(safe, isGlobal ? "g" : void 0);
        };
        createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
        createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
        createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
        createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.(${src[t.NUMERICIDENTIFIER]})\\.(${src[t.NUMERICIDENTIFIER]})`);
        createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.(${src[t.NUMERICIDENTIFIERLOOSE]})\\.(${src[t.NUMERICIDENTIFIERLOOSE]})`);
        createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
        createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
        createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
        createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
        createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
        createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
        createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
        createToken("FULL", `^${src[t.FULLPLAIN]}$`);
        createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
        createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
        createToken("GTLT", "((?:<|>)?=?)");
        createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
        createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
        createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})(?:\\.(${src[t.XRANGEIDENTIFIER]})(?:\\.(${src[t.XRANGEIDENTIFIER]})(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?)?)?`);
        createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?)?)?`);
        createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
        createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
        createToken("COERCEPLAIN", `(^|[^\\d])(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}})(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?`);
        createToken("COERCE", `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
        createToken("COERCEFULL", src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?(?:${src[t.BUILD]})?(?:$|[^\\d])`);
        createToken("COERCERTL", src[t.COERCE], !0);
        createToken("COERCERTLFULL", src[t.COERCEFULL], !0);
        createToken("LONETILDE", "(?:~>?)");
        createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, !0);
        exports.tildeTrimReplace = "$1~";
        createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
        createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
        createToken("LONECARET", "(?:\\^)");
        createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, !0);
        exports.caretTrimReplace = "$1^";
        createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
        createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
        createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
        createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
        createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, !0);
        exports.comparatorTrimReplace = "$1$2$3";
        createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})\\s+-\\s+(${src[t.XRANGEPLAIN]})\\s*$`);
        createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})\\s+-\\s+(${src[t.XRANGEPLAINLOOSE]})\\s*$`);
        createToken("STAR", "(<|>)?=?\\s*\\*");
        createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
        createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
    }
});
var require_parse_options = __commonJS({
    "../../node_modules/semver/internal/parse-options.js" (exports, module) {
        var looseOption = Object.freeze({
            loose: !0
        }), emptyOpts = Object.freeze({}), parseOptions = (options)=>options ? typeof options != "object" ? looseOption : options : emptyOpts;
        module.exports = parseOptions;
    }
});
var require_identifiers = __commonJS({
    "../../node_modules/semver/internal/identifiers.js" (exports, module) {
        var numeric = /^[0-9]+$/, compareIdentifiers = (a, b)=>{
            let anum = numeric.test(a), bnum = numeric.test(b);
            return anum && bnum && (a = +a, b = +b), a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
        }, rcompareIdentifiers = (a, b)=>compareIdentifiers(b, a);
        module.exports = {
            compareIdentifiers,
            rcompareIdentifiers
        };
    }
});
var require_semver = __commonJS({
    "../../node_modules/semver/classes/semver.js" (exports, module) {
        var debug = require_debug(), { MAX_LENGTH, MAX_SAFE_INTEGER } = require_constants(), { safeRe: re, t } = require_re(), parseOptions = require_parse_options(), { compareIdentifiers } = require_identifiers(), SemVer = class _SemVer {
            constructor(version2, options){
                if (options = parseOptions(options), version2 instanceof _SemVer) {
                    if (version2.loose === !!options.loose && version2.includePrerelease === !!options.includePrerelease) return version2;
                    version2 = version2.version;
                } else if (typeof version2 != "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version2}".`);
                if (version2.length > MAX_LENGTH) throw new TypeError(`version is longer than ${MAX_LENGTH} characters`);
                debug("SemVer", version2, options), this.options = options, this.loose = !!options.loose, this.includePrerelease = !!options.includePrerelease;
                let m = version2.trim().match(options.loose ? re[t.LOOSE] : re[t.FULL]);
                if (!m) throw new TypeError(`Invalid Version: ${version2}`);
                if (this.raw = version2, this.major = +m[1], this.minor = +m[2], this.patch = +m[3], this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
                if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
                if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
                m[4] ? this.prerelease = m[4].split(".").map((id)=>{
                    if (/^[0-9]+$/.test(id)) {
                        let num = +id;
                        if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
                    }
                    return id;
                }) : this.prerelease = [], this.build = m[5] ? m[5].split(".") : [], this.format();
            }
            format() {
                return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
            }
            toString() {
                return this.version;
            }
            compare(other) {
                if (debug("SemVer.compare", this.version, this.options, other), !(other instanceof _SemVer)) {
                    if (typeof other == "string" && other === this.version) return 0;
                    other = new _SemVer(other, this.options);
                }
                return other.version === this.version ? 0 : this.compareMain(other) || this.comparePre(other);
            }
            compareMain(other) {
                return other instanceof _SemVer || (other = new _SemVer(other, this.options)), compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
            }
            comparePre(other) {
                if (other instanceof _SemVer || (other = new _SemVer(other, this.options)), this.prerelease.length && !other.prerelease.length) return -1;
                if (!this.prerelease.length && other.prerelease.length) return 1;
                if (!this.prerelease.length && !other.prerelease.length) return 0;
                let i = 0;
                do {
                    let a = this.prerelease[i], b = other.prerelease[i];
                    if (debug("prerelease compare", i, a, b), a === void 0 && b === void 0) return 0;
                    if (b === void 0) return 1;
                    if (a === void 0) return -1;
                    if (a === b) continue;
                    return compareIdentifiers(a, b);
                }while (++i);
            }
            compareBuild(other) {
                other instanceof _SemVer || (other = new _SemVer(other, this.options));
                let i = 0;
                do {
                    let a = this.build[i], b = other.build[i];
                    if (debug("prerelease compare", i, a, b), a === void 0 && b === void 0) return 0;
                    if (b === void 0) return 1;
                    if (a === void 0) return -1;
                    if (a === b) continue;
                    return compareIdentifiers(a, b);
                }while (++i);
            }
            inc(release, identifier, identifierBase) {
                switch(release){
                    case "premajor":
                        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", identifier, identifierBase);
                        break;
                    case "preminor":
                        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", identifier, identifierBase);
                        break;
                    case "prepatch":
                        this.prerelease.length = 0, this.inc("patch", identifier, identifierBase), this.inc("pre", identifier, identifierBase);
                        break;
                    case "prerelease":
                        this.prerelease.length === 0 && this.inc("patch", identifier, identifierBase), this.inc("pre", identifier, identifierBase);
                        break;
                    case "major":
                        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                        break;
                    case "minor":
                        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                        break;
                    case "patch":
                        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                        break;
                    case "pre":
                        {
                            let base = Number(identifierBase) ? 1 : 0;
                            if (!identifier && identifierBase === !1) throw new Error("invalid increment argument: identifier is empty");
                            if (this.prerelease.length === 0) this.prerelease = [
                                base
                            ];
                            else {
                                let i = this.prerelease.length;
                                for(; --i >= 0;)typeof this.prerelease[i] == "number" && (this.prerelease[i]++, i = -2);
                                if (i === -1) {
                                    if (identifier === this.prerelease.join(".") && identifierBase === !1) throw new Error("invalid increment argument: identifier already exists");
                                    this.prerelease.push(base);
                                }
                            }
                            if (identifier) {
                                let prerelease = [
                                    identifier,
                                    base
                                ];
                                identifierBase === !1 && (prerelease = [
                                    identifier
                                ]), compareIdentifiers(this.prerelease[0], identifier) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = prerelease) : this.prerelease = prerelease;
                            }
                            break;
                        }
                    default:
                        throw new Error(`invalid increment argument: ${release}`);
                }
                return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
            }
        };
        module.exports = SemVer;
    }
});
var require_parse = __commonJS({
    "../../node_modules/semver/functions/parse.js" (exports, module) {
        var SemVer = require_semver(), parse2 = (version2, options, throwErrors = !1)=>{
            if (version2 instanceof SemVer) return version2;
            try {
                return new SemVer(version2, options);
            } catch (er) {
                if (!throwErrors) return null;
                throw er;
            }
        };
        module.exports = parse2;
    }
});
var require_valid = __commonJS({
    "../../node_modules/semver/functions/valid.js" (exports, module) {
        var parse2 = require_parse(), valid = (version2, options)=>{
            let v = parse2(version2, options);
            return v ? v.version : null;
        };
        module.exports = valid;
    }
});
var require_clean = __commonJS({
    "../../node_modules/semver/functions/clean.js" (exports, module) {
        var parse2 = require_parse(), clean = (version2, options)=>{
            let s = parse2(version2.trim().replace(/^[=v]+/, ""), options);
            return s ? s.version : null;
        };
        module.exports = clean;
    }
});
var require_inc = __commonJS({
    "../../node_modules/semver/functions/inc.js" (exports, module) {
        var SemVer = require_semver(), inc = (version2, release, options, identifier, identifierBase)=>{
            typeof options == "string" && (identifierBase = identifier, identifier = options, options = void 0);
            try {
                return new SemVer(version2 instanceof SemVer ? version2.version : version2, options).inc(release, identifier, identifierBase).version;
            } catch  {
                return null;
            }
        };
        module.exports = inc;
    }
});
var require_diff = __commonJS({
    "../../node_modules/semver/functions/diff.js" (exports, module) {
        var parse2 = require_parse(), diff = (version1, version2)=>{
            let v1 = parse2(version1, null, !0), v2 = parse2(version2, null, !0), comparison = v1.compare(v2);
            if (comparison === 0) return null;
            let v1Higher = comparison > 0, highVersion = v1Higher ? v1 : v2, lowVersion = v1Higher ? v2 : v1, highHasPre = !!highVersion.prerelease.length;
            if (!!lowVersion.prerelease.length && !highHasPre) return !lowVersion.patch && !lowVersion.minor ? "major" : highVersion.patch ? "patch" : highVersion.minor ? "minor" : "major";
            let prefix = highHasPre ? "pre" : "";
            return v1.major !== v2.major ? prefix + "major" : v1.minor !== v2.minor ? prefix + "minor" : v1.patch !== v2.patch ? prefix + "patch" : "prerelease";
        };
        module.exports = diff;
    }
});
var require_major = __commonJS({
    "../../node_modules/semver/functions/major.js" (exports, module) {
        var SemVer = require_semver(), major = (a, loose)=>new SemVer(a, loose).major;
        module.exports = major;
    }
});
var require_minor = __commonJS({
    "../../node_modules/semver/functions/minor.js" (exports, module) {
        var SemVer = require_semver(), minor = (a, loose)=>new SemVer(a, loose).minor;
        module.exports = minor;
    }
});
var require_patch = __commonJS({
    "../../node_modules/semver/functions/patch.js" (exports, module) {
        var SemVer = require_semver(), patch = (a, loose)=>new SemVer(a, loose).patch;
        module.exports = patch;
    }
});
var require_prerelease = __commonJS({
    "../../node_modules/semver/functions/prerelease.js" (exports, module) {
        var parse2 = require_parse(), prerelease = (version2, options)=>{
            let parsed = parse2(version2, options);
            return parsed && parsed.prerelease.length ? parsed.prerelease : null;
        };
        module.exports = prerelease;
    }
});
var require_compare = __commonJS({
    "../../node_modules/semver/functions/compare.js" (exports, module) {
        var SemVer = require_semver(), compare = (a, b, loose)=>new SemVer(a, loose).compare(new SemVer(b, loose));
        module.exports = compare;
    }
});
var require_rcompare = __commonJS({
    "../../node_modules/semver/functions/rcompare.js" (exports, module) {
        var compare = require_compare(), rcompare = (a, b, loose)=>compare(b, a, loose);
        module.exports = rcompare;
    }
});
var require_compare_loose = __commonJS({
    "../../node_modules/semver/functions/compare-loose.js" (exports, module) {
        var compare = require_compare(), compareLoose = (a, b)=>compare(a, b, !0);
        module.exports = compareLoose;
    }
});
var require_compare_build = __commonJS({
    "../../node_modules/semver/functions/compare-build.js" (exports, module) {
        var SemVer = require_semver(), compareBuild = (a, b, loose)=>{
            let versionA = new SemVer(a, loose), versionB = new SemVer(b, loose);
            return versionA.compare(versionB) || versionA.compareBuild(versionB);
        };
        module.exports = compareBuild;
    }
});
var require_sort = __commonJS({
    "../../node_modules/semver/functions/sort.js" (exports, module) {
        var compareBuild = require_compare_build(), sort = (list, loose)=>list.sort((a, b)=>compareBuild(a, b, loose));
        module.exports = sort;
    }
});
var require_rsort = __commonJS({
    "../../node_modules/semver/functions/rsort.js" (exports, module) {
        var compareBuild = require_compare_build(), rsort = (list, loose)=>list.sort((a, b)=>compareBuild(b, a, loose));
        module.exports = rsort;
    }
});
var require_gt = __commonJS({
    "../../node_modules/semver/functions/gt.js" (exports, module) {
        var compare = require_compare(), gt = (a, b, loose)=>compare(a, b, loose) > 0;
        module.exports = gt;
    }
});
var require_lt = __commonJS({
    "../../node_modules/semver/functions/lt.js" (exports, module) {
        var compare = require_compare(), lt = (a, b, loose)=>compare(a, b, loose) < 0;
        module.exports = lt;
    }
});
var require_eq = __commonJS({
    "../../node_modules/semver/functions/eq.js" (exports, module) {
        var compare = require_compare(), eq = (a, b, loose)=>compare(a, b, loose) === 0;
        module.exports = eq;
    }
});
var require_neq = __commonJS({
    "../../node_modules/semver/functions/neq.js" (exports, module) {
        var compare = require_compare(), neq = (a, b, loose)=>compare(a, b, loose) !== 0;
        module.exports = neq;
    }
});
var require_gte = __commonJS({
    "../../node_modules/semver/functions/gte.js" (exports, module) {
        var compare = require_compare(), gte = (a, b, loose)=>compare(a, b, loose) >= 0;
        module.exports = gte;
    }
});
var require_lte = __commonJS({
    "../../node_modules/semver/functions/lte.js" (exports, module) {
        var compare = require_compare(), lte = (a, b, loose)=>compare(a, b, loose) <= 0;
        module.exports = lte;
    }
});
var require_cmp = __commonJS({
    "../../node_modules/semver/functions/cmp.js" (exports, module) {
        var eq = require_eq(), neq = require_neq(), gt = require_gt(), gte = require_gte(), lt = require_lt(), lte = require_lte(), cmp = (a, op, b, loose)=>{
            switch(op){
                case "===":
                    return typeof a == "object" && (a = a.version), typeof b == "object" && (b = b.version), a === b;
                case "!==":
                    return typeof a == "object" && (a = a.version), typeof b == "object" && (b = b.version), a !== b;
                case "":
                case "=":
                case "==":
                    return eq(a, b, loose);
                case "!=":
                    return neq(a, b, loose);
                case ">":
                    return gt(a, b, loose);
                case ">=":
                    return gte(a, b, loose);
                case "<":
                    return lt(a, b, loose);
                case "<=":
                    return lte(a, b, loose);
                default:
                    throw new TypeError(`Invalid operator: ${op}`);
            }
        };
        module.exports = cmp;
    }
});
var require_coerce = __commonJS({
    "../../node_modules/semver/functions/coerce.js" (exports, module) {
        var SemVer = require_semver(), parse2 = require_parse(), { safeRe: re, t } = require_re(), coerce = (version2, options)=>{
            if (version2 instanceof SemVer) return version2;
            if (typeof version2 == "number" && (version2 = String(version2)), typeof version2 != "string") return null;
            options = options || {};
            let match = null;
            if (!options.rtl) match = version2.match(options.includePrerelease ? re[t.COERCEFULL] : re[t.COERCE]);
            else {
                let coerceRtlRegex = options.includePrerelease ? re[t.COERCERTLFULL] : re[t.COERCERTL], next;
                for(; (next = coerceRtlRegex.exec(version2)) && (!match || match.index + match[0].length !== version2.length);)(!match || next.index + next[0].length !== match.index + match[0].length) && (match = next), coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
                coerceRtlRegex.lastIndex = -1;
            }
            if (match === null) return null;
            let major = match[2], minor = match[3] || "0", patch = match[4] || "0", prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : "", build = options.includePrerelease && match[6] ? `+${match[6]}` : "";
            return parse2(`${major}.${minor}.${patch}${prerelease}${build}`, options);
        };
        module.exports = coerce;
    }
});
var require_iterator = __commonJS({
    "../../node_modules/yallist/iterator.js" (exports, module) {
        module.exports = function(Yallist) {
            Yallist.prototype[Symbol.iterator] = function*() {
                for(let walker = this.head; walker; walker = walker.next)yield walker.value;
            };
        };
    }
});
var require_yallist = __commonJS({
    "../../node_modules/yallist/yallist.js" (exports, module) {
        module.exports = Yallist;
        Yallist.Node = Node;
        Yallist.create = Yallist;
        function Yallist(list) {
            var self = this;
            if (self instanceof Yallist || (self = new Yallist), self.tail = null, self.head = null, self.length = 0, list && typeof list.forEach == "function") list.forEach(function(item) {
                self.push(item);
            });
            else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
            return self;
        }
        Yallist.prototype.removeNode = function(node) {
            if (node.list !== this) throw new Error("removing node which does not belong to this list");
            var next = node.next, prev = node.prev;
            return next && (next.prev = prev), prev && (prev.next = next), node === this.head && (this.head = next), node === this.tail && (this.tail = prev), node.list.length--, node.next = null, node.prev = null, node.list = null, next;
        };
        Yallist.prototype.unshiftNode = function(node) {
            if (node !== this.head) {
                node.list && node.list.removeNode(node);
                var head = this.head;
                node.list = this, node.next = head, head && (head.prev = node), this.head = node, this.tail || (this.tail = node), this.length++;
            }
        };
        Yallist.prototype.pushNode = function(node) {
            if (node !== this.tail) {
                node.list && node.list.removeNode(node);
                var tail = this.tail;
                node.list = this, node.prev = tail, tail && (tail.next = node), this.tail = node, this.head || (this.head = node), this.length++;
            }
        };
        Yallist.prototype.push = function() {
            for(var i = 0, l = arguments.length; i < l; i++)push(this, arguments[i]);
            return this.length;
        };
        Yallist.prototype.unshift = function() {
            for(var i = 0, l = arguments.length; i < l; i++)unshift(this, arguments[i]);
            return this.length;
        };
        Yallist.prototype.pop = function() {
            if (this.tail) {
                var res = this.tail.value;
                return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, res;
            }
        };
        Yallist.prototype.shift = function() {
            if (this.head) {
                var res = this.head.value;
                return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, res;
            }
        };
        Yallist.prototype.forEach = function(fn, thisp) {
            thisp = thisp || this;
            for(var walker = this.head, i = 0; walker !== null; i++)fn.call(thisp, walker.value, i, this), walker = walker.next;
        };
        Yallist.prototype.forEachReverse = function(fn, thisp) {
            thisp = thisp || this;
            for(var walker = this.tail, i = this.length - 1; walker !== null; i--)fn.call(thisp, walker.value, i, this), walker = walker.prev;
        };
        Yallist.prototype.get = function(n) {
            for(var i = 0, walker = this.head; walker !== null && i < n; i++)walker = walker.next;
            if (i === n && walker !== null) return walker.value;
        };
        Yallist.prototype.getReverse = function(n) {
            for(var i = 0, walker = this.tail; walker !== null && i < n; i++)walker = walker.prev;
            if (i === n && walker !== null) return walker.value;
        };
        Yallist.prototype.map = function(fn, thisp) {
            thisp = thisp || this;
            for(var res = new Yallist, walker = this.head; walker !== null;)res.push(fn.call(thisp, walker.value, this)), walker = walker.next;
            return res;
        };
        Yallist.prototype.mapReverse = function(fn, thisp) {
            thisp = thisp || this;
            for(var res = new Yallist, walker = this.tail; walker !== null;)res.push(fn.call(thisp, walker.value, this)), walker = walker.prev;
            return res;
        };
        Yallist.prototype.reduce = function(fn, initial) {
            var acc, walker = this.head;
            if (arguments.length > 1) acc = initial;
            else if (this.head) walker = this.head.next, acc = this.head.value;
            else throw new TypeError("Reduce of empty list with no initial value");
            for(var i = 0; walker !== null; i++)acc = fn(acc, walker.value, i), walker = walker.next;
            return acc;
        };
        Yallist.prototype.reduceReverse = function(fn, initial) {
            var acc, walker = this.tail;
            if (arguments.length > 1) acc = initial;
            else if (this.tail) walker = this.tail.prev, acc = this.tail.value;
            else throw new TypeError("Reduce of empty list with no initial value");
            for(var i = this.length - 1; walker !== null; i--)acc = fn(acc, walker.value, i), walker = walker.prev;
            return acc;
        };
        Yallist.prototype.toArray = function() {
            for(var arr = new Array(this.length), i = 0, walker = this.head; walker !== null; i++)arr[i] = walker.value, walker = walker.next;
            return arr;
        };
        Yallist.prototype.toArrayReverse = function() {
            for(var arr = new Array(this.length), i = 0, walker = this.tail; walker !== null; i++)arr[i] = walker.value, walker = walker.prev;
            return arr;
        };
        Yallist.prototype.slice = function(from, to) {
            to = to || this.length, to < 0 && (to += this.length), from = from || 0, from < 0 && (from += this.length);
            var ret = new Yallist;
            if (to < from || to < 0) return ret;
            from < 0 && (from = 0), to > this.length && (to = this.length);
            for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
            for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
            return ret;
        };
        Yallist.prototype.sliceReverse = function(from, to) {
            to = to || this.length, to < 0 && (to += this.length), from = from || 0, from < 0 && (from += this.length);
            var ret = new Yallist;
            if (to < from || to < 0) return ret;
            from < 0 && (from = 0), to > this.length && (to = this.length);
            for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
            for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
            return ret;
        };
        Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
            start > this.length && (start = this.length - 1), start < 0 && (start = this.length + start);
            for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
            for(var ret = [], i = 0; walker && i < deleteCount; i++)ret.push(walker.value), walker = this.removeNode(walker);
            walker === null && (walker = this.tail), walker !== this.head && walker !== this.tail && (walker = walker.prev);
            for(var i = 0; i < nodes.length; i++)walker = insert(this, walker, nodes[i]);
            return ret;
        };
        Yallist.prototype.reverse = function() {
            for(var head = this.head, tail = this.tail, walker = head; walker !== null; walker = walker.prev){
                var p = walker.prev;
                walker.prev = walker.next, walker.next = p;
            }
            return this.head = tail, this.tail = head, this;
        };
        function insert(self, node, value) {
            var inserted = node === self.head ? new Node(value, null, node, self) : new Node(value, node, node.next, self);
            return inserted.next === null && (self.tail = inserted), inserted.prev === null && (self.head = inserted), self.length++, inserted;
        }
        function push(self, item) {
            self.tail = new Node(item, self.tail, null, self), self.head || (self.head = self.tail), self.length++;
        }
        function unshift(self, item) {
            self.head = new Node(item, null, self.head, self), self.tail || (self.tail = self.head), self.length++;
        }
        function Node(value, prev, next, list) {
            if (!(this instanceof Node)) return new Node(value, prev, next, list);
            this.list = list, this.value = value, prev ? (prev.next = this, this.prev = prev) : this.prev = null, next ? (next.prev = this, this.next = next) : this.next = null;
        }
        try {
            require_iterator()(Yallist);
        } catch  {}
    }
});
var require_lru_cache = __commonJS({
    "../../node_modules/semver/node_modules/lru-cache/index.js" (exports, module) {
        var Yallist = require_yallist(), MAX = Symbol("max"), LENGTH = Symbol("length"), LENGTH_CALCULATOR = Symbol("lengthCalculator"), ALLOW_STALE = Symbol("allowStale"), MAX_AGE = Symbol("maxAge"), DISPOSE = Symbol("dispose"), NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet"), LRU_LIST = Symbol("lruList"), CACHE = Symbol("cache"), UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet"), naiveLength = ()=>1, LRUCache = class {
            constructor(options){
                if (typeof options == "number" && (options = {
                    max: options
                }), options || (options = {}), options.max && (typeof options.max != "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
                this[MAX] = options.max || 1 / 0;
                let lc = options.length || naiveLength;
                if (this[LENGTH_CALCULATOR] = typeof lc != "function" ? naiveLength : lc, this[ALLOW_STALE] = options.stale || !1, options.maxAge && typeof options.maxAge != "number") throw new TypeError("maxAge must be a number");
                this[MAX_AGE] = options.maxAge || 0, this[DISPOSE] = options.dispose, this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || !1, this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || !1, this.reset();
            }
            set max(mL) {
                if (typeof mL != "number" || mL < 0) throw new TypeError("max must be a non-negative number");
                this[MAX] = mL || 1 / 0, trim(this);
            }
            get max() {
                return this[MAX];
            }
            set allowStale(allowStale) {
                this[ALLOW_STALE] = !!allowStale;
            }
            get allowStale() {
                return this[ALLOW_STALE];
            }
            set maxAge(mA) {
                if (typeof mA != "number") throw new TypeError("maxAge must be a non-negative number");
                this[MAX_AGE] = mA, trim(this);
            }
            get maxAge() {
                return this[MAX_AGE];
            }
            set lengthCalculator(lC) {
                typeof lC != "function" && (lC = naiveLength), lC !== this[LENGTH_CALCULATOR] && (this[LENGTH_CALCULATOR] = lC, this[LENGTH] = 0, this[LRU_LIST].forEach((hit)=>{
                    hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key), this[LENGTH] += hit.length;
                })), trim(this);
            }
            get lengthCalculator() {
                return this[LENGTH_CALCULATOR];
            }
            get length() {
                return this[LENGTH];
            }
            get itemCount() {
                return this[LRU_LIST].length;
            }
            rforEach(fn, thisp) {
                thisp = thisp || this;
                for(let walker = this[LRU_LIST].tail; walker !== null;){
                    let prev = walker.prev;
                    forEachStep(this, fn, walker, thisp), walker = prev;
                }
            }
            forEach(fn, thisp) {
                thisp = thisp || this;
                for(let walker = this[LRU_LIST].head; walker !== null;){
                    let next = walker.next;
                    forEachStep(this, fn, walker, thisp), walker = next;
                }
            }
            keys() {
                return this[LRU_LIST].toArray().map((k)=>k.key);
            }
            values() {
                return this[LRU_LIST].toArray().map((k)=>k.value);
            }
            reset() {
                this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length && this[LRU_LIST].forEach((hit)=>this[DISPOSE](hit.key, hit.value)), this[CACHE] = new Map, this[LRU_LIST] = new Yallist, this[LENGTH] = 0;
            }
            dump() {
                return this[LRU_LIST].map((hit)=>isStale(this, hit) ? !1 : {
                        k: hit.key,
                        v: hit.value,
                        e: hit.now + (hit.maxAge || 0)
                    }).toArray().filter((h)=>h);
            }
            dumpLru() {
                return this[LRU_LIST];
            }
            set(key, value, maxAge) {
                if (maxAge = maxAge || this[MAX_AGE], maxAge && typeof maxAge != "number") throw new TypeError("maxAge must be a number");
                let now = maxAge ? Date.now() : 0, len = this[LENGTH_CALCULATOR](value, key);
                if (this[CACHE].has(key)) {
                    if (len > this[MAX]) return del(this, this[CACHE].get(key)), !1;
                    let item = this[CACHE].get(key).value;
                    return this[DISPOSE] && (this[NO_DISPOSE_ON_SET] || this[DISPOSE](key, item.value)), item.now = now, item.maxAge = maxAge, item.value = value, this[LENGTH] += len - item.length, item.length = len, this.get(key), trim(this), !0;
                }
                let hit = new Entry(key, value, len, now, maxAge);
                return hit.length > this[MAX] ? (this[DISPOSE] && this[DISPOSE](key, value), !1) : (this[LENGTH] += hit.length, this[LRU_LIST].unshift(hit), this[CACHE].set(key, this[LRU_LIST].head), trim(this), !0);
            }
            has(key) {
                if (!this[CACHE].has(key)) return !1;
                let hit = this[CACHE].get(key).value;
                return !isStale(this, hit);
            }
            get(key) {
                return get2(this, key, !0);
            }
            peek(key) {
                return get2(this, key, !1);
            }
            pop() {
                let node = this[LRU_LIST].tail;
                return node ? (del(this, node), node.value) : null;
            }
            del(key) {
                del(this, this[CACHE].get(key));
            }
            load(arr) {
                this.reset();
                let now = Date.now();
                for(let l = arr.length - 1; l >= 0; l--){
                    let hit = arr[l], expiresAt = hit.e || 0;
                    if (expiresAt === 0) this.set(hit.k, hit.v);
                    else {
                        let maxAge = expiresAt - now;
                        maxAge > 0 && this.set(hit.k, hit.v, maxAge);
                    }
                }
            }
            prune() {
                this[CACHE].forEach((value, key)=>get2(this, key, !1));
            }
        }, get2 = (self, key, doUse)=>{
            let node = self[CACHE].get(key);
            if (node) {
                let hit = node.value;
                if (isStale(self, hit)) {
                    if (del(self, node), !self[ALLOW_STALE]) return;
                } else doUse && (self[UPDATE_AGE_ON_GET] && (node.value.now = Date.now()), self[LRU_LIST].unshiftNode(node));
                return hit.value;
            }
        }, isStale = (self, hit)=>{
            if (!hit || !hit.maxAge && !self[MAX_AGE]) return !1;
            let diff = Date.now() - hit.now;
            return hit.maxAge ? diff > hit.maxAge : self[MAX_AGE] && diff > self[MAX_AGE];
        }, trim = (self)=>{
            if (self[LENGTH] > self[MAX]) for(let walker = self[LRU_LIST].tail; self[LENGTH] > self[MAX] && walker !== null;){
                let prev = walker.prev;
                del(self, walker), walker = prev;
            }
        }, del = (self, node)=>{
            if (node) {
                let hit = node.value;
                self[DISPOSE] && self[DISPOSE](hit.key, hit.value), self[LENGTH] -= hit.length, self[CACHE].delete(hit.key), self[LRU_LIST].removeNode(node);
            }
        }, Entry = class {
            constructor(key, value, length, now, maxAge){
                this.key = key, this.value = value, this.length = length, this.now = now, this.maxAge = maxAge || 0;
            }
        }, forEachStep = (self, fn, node, thisp)=>{
            let hit = node.value;
            isStale(self, hit) && (del(self, node), self[ALLOW_STALE] || (hit = void 0)), hit && fn.call(thisp, hit.value, hit.key, self);
        };
        module.exports = LRUCache;
    }
});
var require_range = __commonJS({
    "../../node_modules/semver/classes/range.js" (exports, module) {
        var Range = class _Range {
            constructor(range, options){
                if (options = parseOptions(options), range instanceof _Range) return range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease ? range : new _Range(range.raw, options);
                if (range instanceof Comparator) return this.raw = range.value, this.set = [
                    [
                        range
                    ]
                ], this.format(), this;
                if (this.options = options, this.loose = !!options.loose, this.includePrerelease = !!options.includePrerelease, this.raw = range.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map((r)=>this.parseRange(r.trim())).filter((c)=>c.length), !this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
                if (this.set.length > 1) {
                    let first = this.set[0];
                    if (this.set = this.set.filter((c)=>!isNullSet(c[0])), this.set.length === 0) this.set = [
                        first
                    ];
                    else if (this.set.length > 1) {
                        for (let c of this.set)if (c.length === 1 && isAny(c[0])) {
                            this.set = [
                                c
                            ];
                            break;
                        }
                    }
                }
                this.format();
            }
            format() {
                return this.range = this.set.map((comps)=>comps.join(" ").trim()).join("||").trim(), this.range;
            }
            toString() {
                return this.range;
            }
            parseRange(range) {
                let memoKey = ((this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE)) + ":" + range, cached = cache.get(memoKey);
                if (cached) return cached;
                let loose = this.options.loose, hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
                range = range.replace(hr, hyphenReplace(this.options.includePrerelease)), debug("hyphen replace", range), range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace), debug("comparator trim", range), range = range.replace(re[t.TILDETRIM], tildeTrimReplace), debug("tilde trim", range), range = range.replace(re[t.CARETTRIM], caretTrimReplace), debug("caret trim", range);
                let rangeList = range.split(" ").map((comp)=>parseComparator(comp, this.options)).join(" ").split(/\s+/).map((comp)=>replaceGTE0(comp, this.options));
                loose && (rangeList = rangeList.filter((comp)=>(debug("loose invalid filter", comp, this.options), !!comp.match(re[t.COMPARATORLOOSE])))), debug("range list", rangeList);
                let rangeMap = new Map, comparators = rangeList.map((comp)=>new Comparator(comp, this.options));
                for (let comp of comparators){
                    if (isNullSet(comp)) return [
                        comp
                    ];
                    rangeMap.set(comp.value, comp);
                }
                rangeMap.size > 1 && rangeMap.has("") && rangeMap.delete("");
                let result = [
                    ...rangeMap.values()
                ];
                return cache.set(memoKey, result), result;
            }
            intersects(range, options) {
                if (!(range instanceof _Range)) throw new TypeError("a Range is required");
                return this.set.some((thisComparators)=>isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>rangeComparators.every((rangeComparator)=>thisComparator.intersects(rangeComparator, options)))));
            }
            test(version2) {
                if (!version2) return !1;
                if (typeof version2 == "string") try {
                    version2 = new SemVer(version2, this.options);
                } catch  {
                    return !1;
                }
                for(let i = 0; i < this.set.length; i++)if (testSet(this.set[i], version2, this.options)) return !0;
                return !1;
            }
        };
        module.exports = Range;
        var LRU = require_lru_cache(), cache = new LRU({
            max: 1e3
        }), parseOptions = require_parse_options(), Comparator = require_comparator(), debug = require_debug(), SemVer = require_semver(), { safeRe: re, t, comparatorTrimReplace, tildeTrimReplace, caretTrimReplace } = require_re(), { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = require_constants(), isNullSet = (c)=>c.value === "<0.0.0-0", isAny = (c)=>c.value === "", isSatisfiable = (comparators, options)=>{
            let result = !0, remainingComparators = comparators.slice(), testComparator = remainingComparators.pop();
            for(; result && remainingComparators.length;)result = remainingComparators.every((otherComparator)=>testComparator.intersects(otherComparator, options)), testComparator = remainingComparators.pop();
            return result;
        }, parseComparator = (comp, options)=>(debug("comp", comp, options), comp = replaceCarets(comp, options), debug("caret", comp), comp = replaceTildes(comp, options), debug("tildes", comp), comp = replaceXRanges(comp, options), debug("xrange", comp), comp = replaceStars(comp, options), debug("stars", comp), comp), isX = (id)=>!id || id.toLowerCase() === "x" || id === "*", replaceTildes = (comp, options)=>comp.trim().split(/\s+/).map((c)=>replaceTilde(c, options)).join(" "), replaceTilde = (comp, options)=>{
            let r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
            return comp.replace(r, (_, M, m, p, pr)=>{
                debug("tilde", comp, _, M, m, p, pr);
                let ret;
                return isX(M) ? ret = "" : isX(m) ? ret = `>=${M}.0.0 <${+M + 1}.0.0-0` : isX(p) ? ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0` : pr ? (debug("replaceTilde pr", pr), ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`) : ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`, debug("tilde return", ret), ret;
            });
        }, replaceCarets = (comp, options)=>comp.trim().split(/\s+/).map((c)=>replaceCaret(c, options)).join(" "), replaceCaret = (comp, options)=>{
            debug("caret", comp, options);
            let r = options.loose ? re[t.CARETLOOSE] : re[t.CARET], z = options.includePrerelease ? "-0" : "";
            return comp.replace(r, (_, M, m, p, pr)=>{
                debug("caret", comp, _, M, m, p, pr);
                let ret;
                return isX(M) ? ret = "" : isX(m) ? ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0` : isX(p) ? M === "0" ? ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0` : ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0` : pr ? (debug("replaceCaret pr", pr), M === "0" ? m === "0" ? ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0` : ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0` : ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`) : (debug("no pr"), M === "0" ? m === "0" ? ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0` : ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0` : ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`), debug("caret return", ret), ret;
            });
        }, replaceXRanges = (comp, options)=>(debug("replaceXRanges", comp, options), comp.split(/\s+/).map((c)=>replaceXRange(c, options)).join(" ")), replaceXRange = (comp, options)=>{
            comp = comp.trim();
            let r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
            return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
                debug("xRange", comp, ret, gtlt, M, m, p, pr);
                let xM = isX(M), xm = xM || isX(m), xp = xm || isX(p), anyX = xp;
                return gtlt === "=" && anyX && (gtlt = ""), pr = options.includePrerelease ? "-0" : "", xM ? gtlt === ">" || gtlt === "<" ? ret = "<0.0.0-0" : ret = "*" : gtlt && anyX ? (xm && (m = 0), p = 0, gtlt === ">" ? (gtlt = ">=", xm ? (M = +M + 1, m = 0, p = 0) : (m = +m + 1, p = 0)) : gtlt === "<=" && (gtlt = "<", xm ? M = +M + 1 : m = +m + 1), gtlt === "<" && (pr = "-0"), ret = `${gtlt + M}.${m}.${p}${pr}`) : xm ? ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0` : xp && (ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`), debug("xRange return", ret), ret;
            });
        }, replaceStars = (comp, options)=>(debug("replaceStars", comp, options), comp.trim().replace(re[t.STAR], "")), replaceGTE0 = (comp, options)=>(debug("replaceGTE0", comp, options), comp.trim().replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], "")), hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb)=>(isX(fM) ? from = "" : isX(fm) ? from = `>=${fM}.0.0${incPr ? "-0" : ""}` : isX(fp) ? from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}` : fpr ? from = `>=${from}` : from = `>=${from}${incPr ? "-0" : ""}`, isX(tM) ? to = "" : isX(tm) ? to = `<${+tM + 1}.0.0-0` : isX(tp) ? to = `<${tM}.${+tm + 1}.0-0` : tpr ? to = `<=${tM}.${tm}.${tp}-${tpr}` : incPr ? to = `<${tM}.${tm}.${+tp + 1}-0` : to = `<=${to}`, `${from} ${to}`.trim()), testSet = (set2, version2, options)=>{
            for(let i = 0; i < set2.length; i++)if (!set2[i].test(version2)) return !1;
            if (version2.prerelease.length && !options.includePrerelease) {
                for(let i = 0; i < set2.length; i++)if (debug(set2[i].semver), set2[i].semver !== Comparator.ANY && set2[i].semver.prerelease.length > 0) {
                    let allowed = set2[i].semver;
                    if (allowed.major === version2.major && allowed.minor === version2.minor && allowed.patch === version2.patch) return !0;
                }
                return !1;
            }
            return !0;
        };
    }
});
var require_comparator = __commonJS({
    "../../node_modules/semver/classes/comparator.js" (exports, module) {
        var ANY = Symbol("SemVer ANY"), Comparator = class _Comparator {
            static get ANY() {
                return ANY;
            }
            constructor(comp, options){
                if (options = parseOptions(options), comp instanceof _Comparator) {
                    if (comp.loose === !!options.loose) return comp;
                    comp = comp.value;
                }
                comp = comp.trim().split(/\s+/).join(" "), debug("comparator", comp, options), this.options = options, this.loose = !!options.loose, this.parse(comp), this.semver === ANY ? this.value = "" : this.value = this.operator + this.semver.version, debug("comp", this);
            }
            parse(comp) {
                let r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR], m = comp.match(r);
                if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
                this.operator = m[1] !== void 0 ? m[1] : "", this.operator === "=" && (this.operator = ""), m[2] ? this.semver = new SemVer(m[2], this.options.loose) : this.semver = ANY;
            }
            toString() {
                return this.value;
            }
            test(version2) {
                if (debug("Comparator.test", version2, this.options.loose), this.semver === ANY || version2 === ANY) return !0;
                if (typeof version2 == "string") try {
                    version2 = new SemVer(version2, this.options);
                } catch  {
                    return !1;
                }
                return cmp(version2, this.operator, this.semver, this.options);
            }
            intersects(comp, options) {
                if (!(comp instanceof _Comparator)) throw new TypeError("a Comparator is required");
                return this.operator === "" ? this.value === "" ? !0 : new Range(comp.value, options).test(this.value) : comp.operator === "" ? comp.value === "" ? !0 : new Range(this.value, options).test(comp.semver) : (options = parseOptions(options), options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0") || !options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && comp.operator.startsWith(">") || this.operator.startsWith("<") && comp.operator.startsWith("<") || this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=") || cmp(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<") || cmp(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")));
            }
        };
        module.exports = Comparator;
        var parseOptions = require_parse_options(), { safeRe: re, t } = require_re(), cmp = require_cmp(), debug = require_debug(), SemVer = require_semver(), Range = require_range();
    }
});
var require_satisfies = __commonJS({
    "../../node_modules/semver/functions/satisfies.js" (exports, module) {
        var Range = require_range(), satisfies = (version2, range, options)=>{
            try {
                range = new Range(range, options);
            } catch  {
                return !1;
            }
            return range.test(version2);
        };
        module.exports = satisfies;
    }
});
var require_to_comparators = __commonJS({
    "../../node_modules/semver/ranges/to-comparators.js" (exports, module) {
        var Range = require_range(), toComparators = (range, options)=>new Range(range, options).set.map((comp)=>comp.map((c)=>c.value).join(" ").trim().split(" "));
        module.exports = toComparators;
    }
});
var require_max_satisfying = __commonJS({
    "../../node_modules/semver/ranges/max-satisfying.js" (exports, module) {
        var SemVer = require_semver(), Range = require_range(), maxSatisfying = (versions, range, options)=>{
            let max = null, maxSV = null, rangeObj = null;
            try {
                rangeObj = new Range(range, options);
            } catch  {
                return null;
            }
            return versions.forEach((v)=>{
                rangeObj.test(v) && (!max || maxSV.compare(v) === -1) && (max = v, maxSV = new SemVer(max, options));
            }), max;
        };
        module.exports = maxSatisfying;
    }
});
var require_min_satisfying = __commonJS({
    "../../node_modules/semver/ranges/min-satisfying.js" (exports, module) {
        var SemVer = require_semver(), Range = require_range(), minSatisfying = (versions, range, options)=>{
            let min = null, minSV = null, rangeObj = null;
            try {
                rangeObj = new Range(range, options);
            } catch  {
                return null;
            }
            return versions.forEach((v)=>{
                rangeObj.test(v) && (!min || minSV.compare(v) === 1) && (min = v, minSV = new SemVer(min, options));
            }), min;
        };
        module.exports = minSatisfying;
    }
});
var require_min_version = __commonJS({
    "../../node_modules/semver/ranges/min-version.js" (exports, module) {
        var SemVer = require_semver(), Range = require_range(), gt = require_gt(), minVersion = (range, loose)=>{
            range = new Range(range, loose);
            let minver = new SemVer("0.0.0");
            if (range.test(minver) || (minver = new SemVer("0.0.0-0"), range.test(minver))) return minver;
            minver = null;
            for(let i = 0; i < range.set.length; ++i){
                let comparators = range.set[i], setMin = null;
                comparators.forEach((comparator)=>{
                    let compver = new SemVer(comparator.semver.version);
                    switch(comparator.operator){
                        case ">":
                            compver.prerelease.length === 0 ? compver.patch++ : compver.prerelease.push(0), compver.raw = compver.format();
                        case "":
                        case ">=":
                            (!setMin || gt(compver, setMin)) && (setMin = compver);
                            break;
                        case "<":
                        case "<=":
                            break;
                        default:
                            throw new Error(`Unexpected operation: ${comparator.operator}`);
                    }
                }), setMin && (!minver || gt(minver, setMin)) && (minver = setMin);
            }
            return minver && range.test(minver) ? minver : null;
        };
        module.exports = minVersion;
    }
});
var require_valid2 = __commonJS({
    "../../node_modules/semver/ranges/valid.js" (exports, module) {
        var Range = require_range(), validRange = (range, options)=>{
            try {
                return new Range(range, options).range || "*";
            } catch  {
                return null;
            }
        };
        module.exports = validRange;
    }
});
var require_outside = __commonJS({
    "../../node_modules/semver/ranges/outside.js" (exports, module) {
        var SemVer = require_semver(), Comparator = require_comparator(), { ANY } = Comparator, Range = require_range(), satisfies = require_satisfies(), gt = require_gt(), lt = require_lt(), lte = require_lte(), gte = require_gte(), outside = (version2, range, hilo, options)=>{
            version2 = new SemVer(version2, options), range = new Range(range, options);
            let gtfn, ltefn, ltfn, comp, ecomp;
            switch(hilo){
                case ">":
                    gtfn = gt, ltefn = lte, ltfn = lt, comp = ">", ecomp = ">=";
                    break;
                case "<":
                    gtfn = lt, ltefn = gte, ltfn = gt, comp = "<", ecomp = "<=";
                    break;
                default:
                    throw new TypeError('Must provide a hilo val of "<" or ">"');
            }
            if (satisfies(version2, range, options)) return !1;
            for(let i = 0; i < range.set.length; ++i){
                let comparators = range.set[i], high = null, low = null;
                if (comparators.forEach((comparator)=>{
                    comparator.semver === ANY && (comparator = new Comparator(">=0.0.0")), high = high || comparator, low = low || comparator, gtfn(comparator.semver, high.semver, options) ? high = comparator : ltfn(comparator.semver, low.semver, options) && (low = comparator);
                }), high.operator === comp || high.operator === ecomp || (!low.operator || low.operator === comp) && ltefn(version2, low.semver)) return !1;
                if (low.operator === ecomp && ltfn(version2, low.semver)) return !1;
            }
            return !0;
        };
        module.exports = outside;
    }
});
var require_gtr = __commonJS({
    "../../node_modules/semver/ranges/gtr.js" (exports, module) {
        var outside = require_outside(), gtr = (version2, range, options)=>outside(version2, range, ">", options);
        module.exports = gtr;
    }
});
var require_ltr = __commonJS({
    "../../node_modules/semver/ranges/ltr.js" (exports, module) {
        var outside = require_outside(), ltr = (version2, range, options)=>outside(version2, range, "<", options);
        module.exports = ltr;
    }
});
var require_intersects = __commonJS({
    "../../node_modules/semver/ranges/intersects.js" (exports, module) {
        var Range = require_range(), intersects = (r1, r2, options)=>(r1 = new Range(r1, options), r2 = new Range(r2, options), r1.intersects(r2, options));
        module.exports = intersects;
    }
});
var require_simplify = __commonJS({
    "../../node_modules/semver/ranges/simplify.js" (exports, module) {
        var satisfies = require_satisfies(), compare = require_compare();
        module.exports = (versions, range, options)=>{
            let set2 = [], first = null, prev = null, v = versions.sort((a, b)=>compare(a, b, options));
            for (let version2 of v)satisfies(version2, range, options) ? (prev = version2, first || (first = version2)) : (prev && set2.push([
                first,
                prev
            ]), prev = null, first = null);
            first && set2.push([
                first,
                null
            ]);
            let ranges = [];
            for (let [min, max] of set2)min === max ? ranges.push(min) : !max && min === v[0] ? ranges.push("*") : max ? min === v[0] ? ranges.push(`<=${max}`) : ranges.push(`${min} - ${max}`) : ranges.push(`>=${min}`);
            let simplified = ranges.join(" || "), original = typeof range.raw == "string" ? range.raw : String(range);
            return simplified.length < original.length ? simplified : range;
        };
    }
});
var require_subset = __commonJS({
    "../../node_modules/semver/ranges/subset.js" (exports, module) {
        var Range = require_range(), Comparator = require_comparator(), { ANY } = Comparator, satisfies = require_satisfies(), compare = require_compare(), subset = (sub, dom, options = {})=>{
            if (sub === dom) return !0;
            sub = new Range(sub, options), dom = new Range(dom, options);
            let sawNonNull = !1;
            OUTER: for (let simpleSub of sub.set){
                for (let simpleDom of dom.set){
                    let isSub = simpleSubset(simpleSub, simpleDom, options);
                    if (sawNonNull = sawNonNull || isSub !== null, isSub) continue OUTER;
                }
                if (sawNonNull) return !1;
            }
            return !0;
        }, minimumVersionWithPreRelease = [
            new Comparator(">=0.0.0-0")
        ], minimumVersion = [
            new Comparator(">=0.0.0")
        ], simpleSubset = (sub, dom, options)=>{
            if (sub === dom) return !0;
            if (sub.length === 1 && sub[0].semver === ANY) {
                if (dom.length === 1 && dom[0].semver === ANY) return !0;
                options.includePrerelease ? sub = minimumVersionWithPreRelease : sub = minimumVersion;
            }
            if (dom.length === 1 && dom[0].semver === ANY) {
                if (options.includePrerelease) return !0;
                dom = minimumVersion;
            }
            let eqSet = new Set, gt, lt;
            for (let c of sub)c.operator === ">" || c.operator === ">=" ? gt = higherGT(gt, c, options) : c.operator === "<" || c.operator === "<=" ? lt = lowerLT(lt, c, options) : eqSet.add(c.semver);
            if (eqSet.size > 1) return null;
            let gtltComp;
            if (gt && lt) {
                if (gtltComp = compare(gt.semver, lt.semver, options), gtltComp > 0) return null;
                if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
            }
            for (let eq of eqSet){
                if (gt && !satisfies(eq, String(gt), options) || lt && !satisfies(eq, String(lt), options)) return null;
                for (let c of dom)if (!satisfies(eq, String(c), options)) return !1;
                return !0;
            }
            let higher, lower, hasDomLT, hasDomGT, needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : !1, needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : !1;
            needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0 && (needDomLTPre = !1);
            for (let c of dom){
                if (hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=", hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=", gt) {
                    if (needDomGTPre && c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch && (needDomGTPre = !1), c.operator === ">" || c.operator === ">=") {
                        if (higher = higherGT(gt, c, options), higher === c && higher !== gt) return !1;
                    } else if (gt.operator === ">=" && !satisfies(gt.semver, String(c), options)) return !1;
                }
                if (lt) {
                    if (needDomLTPre && c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch && (needDomLTPre = !1), c.operator === "<" || c.operator === "<=") {
                        if (lower = lowerLT(lt, c, options), lower === c && lower !== lt) return !1;
                    } else if (lt.operator === "<=" && !satisfies(lt.semver, String(c), options)) return !1;
                }
                if (!c.operator && (lt || gt) && gtltComp !== 0) return !1;
            }
            return !(gt && hasDomLT && !lt && gtltComp !== 0 || lt && hasDomGT && !gt && gtltComp !== 0 || needDomGTPre || needDomLTPre);
        }, higherGT = (a, b, options)=>{
            if (!a) return b;
            let comp = compare(a.semver, b.semver, options);
            return comp > 0 ? a : comp < 0 || b.operator === ">" && a.operator === ">=" ? b : a;
        }, lowerLT = (a, b, options)=>{
            if (!a) return b;
            let comp = compare(a.semver, b.semver, options);
            return comp < 0 ? a : comp > 0 || b.operator === "<" && a.operator === "<=" ? b : a;
        };
        module.exports = subset;
    }
});
var require_semver2 = __commonJS({
    "../../node_modules/semver/index.js" (exports, module) {
        var internalRe = require_re(), constants = require_constants(), SemVer = require_semver(), identifiers = require_identifiers(), parse2 = require_parse(), valid = require_valid(), clean = require_clean(), inc = require_inc(), diff = require_diff(), major = require_major(), minor = require_minor(), patch = require_patch(), prerelease = require_prerelease(), compare = require_compare(), rcompare = require_rcompare(), compareLoose = require_compare_loose(), compareBuild = require_compare_build(), sort = require_sort(), rsort = require_rsort(), gt = require_gt(), lt = require_lt(), eq = require_eq(), neq = require_neq(), gte = require_gte(), lte = require_lte(), cmp = require_cmp(), coerce = require_coerce(), Comparator = require_comparator(), Range = require_range(), satisfies = require_satisfies(), toComparators = require_to_comparators(), maxSatisfying = require_max_satisfying(), minSatisfying = require_min_satisfying(), minVersion = require_min_version(), validRange = require_valid2(), outside = require_outside(), gtr = require_gtr(), ltr = require_ltr(), intersects = require_intersects(), simplifyRange = require_simplify(), subset = require_subset();
        module.exports = {
            parse: parse2,
            valid,
            clean,
            inc,
            diff,
            major,
            minor,
            patch,
            prerelease,
            compare,
            rcompare,
            compareLoose,
            compareBuild,
            sort,
            rsort,
            gt,
            lt,
            eq,
            neq,
            gte,
            lte,
            cmp,
            coerce,
            Comparator,
            Range,
            satisfies,
            toComparators,
            maxSatisfying,
            minSatisfying,
            minVersion,
            validRange,
            outside,
            gtr,
            ltr,
            intersects,
            simplifyRange,
            subset,
            SemVer,
            re: internalRe.re,
            src: internalRe.src,
            tokens: internalRe.t,
            SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
            RELEASE_TYPES: constants.RELEASE_TYPES,
            compareIdentifiers: identifiers.compareIdentifiers,
            rcompareIdentifiers: identifiers.rcompareIdentifiers
        };
    }
});
var createContext = ({ api, state })=>(0, _react.createContext)({
        api,
        state
    });
var store_setup_default = (_)=>{
    _.fn("set", function(key, data) {
        return _.set(this._area, this._in(key), (0, _telejson.stringify)(data, {
            maxDepth: 50
        }));
    }), _.fn("get", function(key, alt) {
        let value = _.get(this._area, this._in(key));
        return value !== null ? (0, _telejson.parse)(value) : alt || value;
    });
};
store_setup_default((0, _store2Default.default)._);
var STORAGE_KEY = "@storybook/manager/store";
function get(storage) {
    return storage.get(STORAGE_KEY) || {};
}
function set(storage, value) {
    return storage.set(STORAGE_KEY, value);
}
function update(storage, patch) {
    let previous = get(storage);
    return set(storage, {
        ...previous,
        ...patch
    });
}
var Store = class {
    constructor({ setState, getState }){
        this.upstreamSetState = setState, this.upstreamGetState = getState;
    }
    getInitialState(base) {
        return {
            ...base,
            ...get((0, _store2Default.default).local),
            ...get((0, _store2Default.default).session)
        };
    }
    getState() {
        return this.upstreamGetState();
    }
    async setState(inputPatch, cbOrOptions, inputOptions) {
        let callback, options;
        typeof cbOrOptions == "function" ? (callback = cbOrOptions, options = inputOptions) : options = cbOrOptions;
        let { persistence = "none" } = options || {}, patch = {}, delta = {};
        typeof inputPatch == "function" ? patch = (state)=>(delta = inputPatch(state), delta) : (patch = inputPatch, delta = patch);
        let newState = await new Promise((resolve)=>{
            this.upstreamSetState(patch, resolve);
        });
        if (persistence !== "none") {
            let storage = persistence === "session" ? (0, _store2Default.default).session : (0, _store2Default.default).local;
            await update(storage, delta);
        }
        return callback && callback(newState), newState;
    }
};
var merge_default = (a, b)=>(0, _mergeWithJsDefault.default)({}, a, b, (objValue, srcValue)=>{
        if (Array.isArray(srcValue) && Array.isArray(objValue)) return srcValue.forEach((s)=>{
            objValue.find((o)=>o === s || (0, _isEqualJsDefault.default)(o, s)) || objValue.push(s);
        }), objValue;
        if (Array.isArray(objValue)) return (0, _clientLogger.logger).log([
            "the types mismatch, picking",
            objValue
        ]), objValue;
    });
var main = (...additions)=>additions.reduce((acc, item)=>merge_default(acc, item), {}), initial_state_default = main;
var provider_exports = {};
__export(provider_exports, {
    init: ()=>init
});
var init = ({ provider, fullAPI })=>({
        api: provider.renderPreview ? {
            renderPreview: provider.renderPreview
        } : {},
        state: {},
        init: ()=>{
            provider.handleAPI(fullAPI);
        }
    });
var addons_exports = {};
__export(addons_exports, {
    ensurePanel: ()=>ensurePanel,
    init: ()=>init2
});
function ensurePanel(panels, selectedPanel, currentPanel) {
    let keys2 = Object.keys(panels);
    return keys2.indexOf(selectedPanel) >= 0 ? selectedPanel : keys2.length ? keys2[0] : currentPanel;
}
var init2 = ({ provider, store: store2, fullAPI })=>{
    let api = {
        getElements: (type)=>provider.getElements(type),
        getPanels: ()=>api.getElements((0, _types.Addon_TypesEnum).PANEL),
        getStoryPanels: ()=>{
            let allPanels = api.getElements((0, _types.Addon_TypesEnum).PANEL), { storyId } = store2.getState(), story = fullAPI.getData(storyId);
            if (!allPanels || !story || story.type !== "story") return allPanels;
            let { parameters } = story, filteredPanels = {};
            return Object.entries(allPanels).forEach(([id, panel])=>{
                let { paramKey } = panel;
                paramKey && parameters && parameters[paramKey] && parameters[paramKey].disable || (filteredPanels[id] = panel);
            }), filteredPanels;
        },
        getSelectedPanel: ()=>{
            let { selectedPanel } = store2.getState();
            return ensurePanel(api.getElements((0, _types.Addon_TypesEnum).PANEL), selectedPanel, selectedPanel);
        },
        setSelectedPanel: (panelName)=>{
            store2.setState({
                selectedPanel: panelName
            }, {
                persistence: "session"
            });
        },
        setAddonState (addonId, newStateOrMerger, options) {
            let nextState, { addons: existing } = store2.getState();
            return typeof newStateOrMerger == "function" ? nextState = newStateOrMerger(api.getAddonState(addonId)) : nextState = newStateOrMerger, store2.setState({
                addons: {
                    ...existing,
                    [addonId]: nextState
                }
            }, options).then(()=>api.getAddonState(addonId));
        },
        getAddonState: (addonId)=>store2.getState().addons[addonId] || globalThis?.STORYBOOK_ADDON_STATE[addonId]
    };
    return {
        api,
        state: {
            selectedPanel: ensurePanel(api.getElements((0, _types.Addon_TypesEnum).PANEL), store2.getState().selectedPanel),
            addons: {}
        }
    };
};
var channel_exports = {};
__export(channel_exports, {
    init: ()=>init3
});
var init3 = ({ provider })=>{
    let api = {
        getChannel: ()=>provider.channel,
        on: (type, handler)=>(provider.channel.on(type, handler), ()=>provider.channel.off(type, handler)),
        off: (type, handler)=>provider.channel.off(type, handler),
        once: (type, handler)=>provider.channel.once(type, handler),
        emit: (type, data, ...args)=>{
            data?.options?.target && data.options.target !== "storybook-preview-iframe" && !data.options.target.startsWith("storybook-ref-") && (data.options.target = data.options.target !== "storybook_internal" ? `storybook-ref-${data.options.target}` : "storybook-preview-iframe"), provider.channel.emit(type, data, ...args);
        },
        collapseAll: ()=>{
            api.emit((0, _coreEvents.STORIES_COLLAPSE_ALL), {});
        },
        expandAll: ()=>{
            api.emit((0, _coreEvents.STORIES_EXPAND_ALL));
        }
    };
    return {
        api,
        state: {}
    };
};
var notifications_exports = {};
__export(notifications_exports, {
    init: ()=>init4
});
var init4 = ({ store: store2 })=>{
    let api = {
        addNotification: (notification)=>{
            api.clearNotification(notification.id);
            let { notifications } = store2.getState();
            store2.setState({
                notifications: [
                    ...notifications,
                    notification
                ]
            });
        },
        clearNotification: (id)=>{
            let { notifications } = store2.getState();
            store2.setState({
                notifications: notifications.filter((n)=>n.id !== id)
            });
            let notification = notifications.find((n)=>n.id === id);
            notification && notification.onClear && notification.onClear({
                dismissed: !1
            });
        }
    };
    return {
        api,
        state: {
            notifications: []
        }
    };
};
var settings_exports = {};
__export(settings_exports, {
    init: ()=>init5
});
var init5 = ({ store: store2, navigate, fullAPI })=>{
    let isSettingsScreenActive = ()=>{
        let { path } = fullAPI.getUrlState();
        return !!(path || "").match(/^\/settings/);
    };
    return {
        state: {
            settings: {
                lastTrackedStoryId: null
            }
        },
        api: {
            closeSettings: ()=>{
                let { settings: { lastTrackedStoryId } } = store2.getState();
                lastTrackedStoryId ? fullAPI.selectStory(lastTrackedStoryId) : fullAPI.selectFirstStory();
            },
            changeSettingsTab: (path)=>{
                navigate(`/settings/${path}`);
            },
            isSettingsScreenActive,
            navigateToSettingsPage: async (path)=>{
                if (!isSettingsScreenActive()) {
                    let { settings, storyId } = store2.getState();
                    await store2.setState({
                        settings: {
                            ...settings,
                            lastTrackedStoryId: storyId
                        }
                    });
                }
                navigate(path);
            },
            retrieveSelection () {
                let { settings } = store2.getState();
                return settings.lastTrackedStoryId;
            },
            storeSelection: async ()=>{
                let { storyId, settings } = store2.getState();
                await store2.setState({
                    settings: {
                        ...settings,
                        lastTrackedStoryId: storyId
                    }
                });
            }
        }
    };
};
var stories_exports = {};
__export(stories_exports, {
    init: ()=>init7
});
var refs_exports = {};
__export(refs_exports, {
    defaultStoryMapper: ()=>defaultStoryMapper,
    getSourceType: ()=>getSourceType,
    init: ()=>init6
});
var TITLE_PATH_SEPARATOR = /\s*\/\s*/, denormalizeStoryParameters = ({ globalParameters, kindParameters, stories })=>(0, _mapValuesJsDefault.default)(stories, (storyData)=>({
            ...storyData,
            parameters: combineParameters(globalParameters, kindParameters[storyData.kind], storyData.parameters)
        })), transformSetStoriesStoryDataToStoriesHash = (data, options)=>transformStoryIndexToStoriesHash(transformSetStoriesStoryDataToPreparedStoryIndex(data), options), transformSetStoriesStoryDataToPreparedStoryIndex = (stories)=>({
        v: 4,
        entries: Object.entries(stories).reduce((acc, [id, story])=>{
            if (!story) return acc;
            let { docsOnly, fileName, ...parameters } = story.parameters, base = {
                title: story.kind,
                id,
                name: story.name,
                importPath: fileName
            };
            if (docsOnly) acc[id] = {
                type: "docs",
                tags: [
                    "stories-mdx"
                ],
                storiesImports: [],
                ...base
            };
            else {
                let { argTypes, args, initialArgs } = story;
                acc[id] = {
                    type: "story",
                    ...base,
                    parameters,
                    argTypes,
                    args,
                    initialArgs
                };
            }
            return acc;
        }, {})
    }), transformStoryIndexV2toV3 = (index)=>({
        v: 3,
        stories: Object.values(index.stories).reduce((acc, entry)=>(acc[entry.id] = {
                ...entry,
                title: entry.kind,
                name: entry.name || entry.story,
                importPath: entry.parameters.fileName || ""
            }, acc), {})
    }), transformStoryIndexV3toV4 = (index)=>{
    let countByTitle = (0, _countByJsDefault.default)(Object.values(index.stories), "title");
    return {
        v: 4,
        entries: Object.values(index.stories).reduce((acc, entry)=>{
            let type = "story";
            return (entry.parameters?.docsOnly || entry.name === "Page" && countByTitle[entry.title] === 1) && (type = "docs"), acc[entry.id] = {
                type,
                ...type === "docs" && {
                    tags: [
                        "stories-mdx"
                    ],
                    storiesImports: []
                },
                ...entry
            }, delete acc[entry.id].story, delete acc[entry.id].kind, acc;
        }, {})
    };
}, transformStoryIndexToStoriesHash = (input, { provider, docsOptions, filters, status })=>{
    if (!input.v) throw new Error("Composition: Missing stories.json version");
    let index = input;
    index = index.v === 2 ? transformStoryIndexV2toV3(index) : index, index = index.v === 3 ? transformStoryIndexV3toV4(index) : index, index;
    let entryValues = Object.values(index.entries).filter((entry)=>{
        let result = !0;
        return Object.values(filters).forEach((filter)=>{
            result !== !1 && (result = filter({
                ...entry,
                status: status[entry.id]
            }));
        }), result;
    }), { sidebar = {} } = provider.getConfig(), { showRoots, collapsedRoots = [], renderLabel } = sidebar, setShowRoots = typeof showRoots < "u", storiesHashOutOfOrder = entryValues.reduce((acc, item)=>{
        if (docsOptions.docsMode && item.type !== "docs") return acc;
        let { title } = item, groups = title.trim().split(TITLE_PATH_SEPARATOR), root = (!setShowRoots || showRoots) && groups.length > 1 ? [
            groups.shift()
        ] : [], names = [
            ...root,
            ...groups
        ], paths = names.reduce((list, name, idx)=>{
            let parent = idx > 0 && list[idx - 1], id = (0, _csf.sanitize)(parent ? `${parent}-${name}` : name);
            if (parent === id) throw new Error((0, _tsDedent.dedent)`
          Invalid part '${name}', leading to id === parentId ('${id}'), inside title '${title}'
          
          Did you create a path that uses the separator char accidentally, such as 'Vue <docs/>' where '/' is a separator char? See https://github.com/storybookjs/storybook/issues/6128
          `);
            return list.push(id), list;
        }, []);
        return paths.forEach((id, idx)=>{
            let childId = paths[idx + 1] || item.id;
            root.length && idx === 0 ? acc[id] = merge_default(acc[id] || {}, {
                type: "root",
                id,
                name: names[idx],
                depth: idx,
                renderLabel,
                startCollapsed: collapsedRoots.includes(id),
                children: [
                    childId
                ],
                isRoot: !0,
                isComponent: !1,
                isLeaf: !1
            }) : (!acc[id] || acc[id].type === "component") && idx === paths.length - 1 ? acc[id] = merge_default(acc[id] || {}, {
                type: "component",
                id,
                name: names[idx],
                parent: paths[idx - 1],
                depth: idx,
                renderLabel,
                ...childId && {
                    children: [
                        childId
                    ]
                },
                isRoot: !1,
                isComponent: !0,
                isLeaf: !1
            }) : acc[id] = merge_default(acc[id] || {}, {
                type: "group",
                id,
                name: names[idx],
                parent: paths[idx - 1],
                depth: idx,
                renderLabel,
                ...childId && {
                    children: [
                        childId
                    ]
                },
                isRoot: !1,
                isComponent: !1,
                isLeaf: !1
            });
        }), acc[item.id] = {
            type: "story",
            ...item,
            depth: paths.length,
            parent: paths[paths.length - 1],
            renderLabel,
            prepared: !!item.parameters,
            kind: item.title,
            isRoot: !1,
            isComponent: !1,
            isLeaf: !0
        }, acc;
    }, {});
    function addItem(acc, item) {
        return acc[item.id] || (acc[item.id] = item, (item.type === "root" || item.type === "group" || item.type === "component") && item.children.forEach((childId)=>addItem(acc, storiesHashOutOfOrder[childId]))), acc;
    }
    let orphanHash = Object.values(storiesHashOutOfOrder).filter((i)=>i.type !== "root" && !i.parent).reduce(addItem, {});
    return Object.values(storiesHashOutOfOrder).filter((i)=>i.type === "root").reduce(addItem, orphanHash);
}, addPreparedStories = (newHash, oldHash)=>oldHash ? Object.fromEntries(Object.entries(newHash).map(([id, newEntry])=>{
        let oldEntry = oldHash[id];
        return newEntry.type === "story" && oldEntry?.type === "story" && oldEntry.prepared ? [
            id,
            {
                ...oldEntry,
                ...newEntry,
                prepared: !0
            }
        ] : [
            id,
            newEntry
        ];
    })) : newHash, getComponentLookupList = (0, _memoizerificDefault.default)(1)((hash)=>Object.entries(hash).reduce((acc, i)=>{
        let value = i[1];
        return value.type === "component" && acc.push([
            ...value.children
        ]), acc;
    }, [])), getStoriesLookupList = (0, _memoizerificDefault.default)(1)((hash)=>Object.keys(hash).filter((k)=>[
            "story",
            "docs"
        ].includes(hash[k].type)));
var { location, fetch } = (0, _global.global), findFilename = /(\/((?:[^\/]+?)\.[^\/]+?)|\/)$/, getSourceType = (source, refId)=>{
    let { origin: localOrigin, pathname: localPathname } = location, { origin: sourceOrigin, pathname: sourcePathname } = new URL(source), localFull = `${localOrigin + localPathname}`.replace(findFilename, ""), sourceFull = `${sourceOrigin + sourcePathname}`.replace(findFilename, "");
    return localFull === sourceFull ? [
        "local",
        sourceFull
    ] : refId || source ? [
        "external",
        sourceFull
    ] : [
        null,
        null
    ];
}, defaultStoryMapper = (b, a)=>({
        ...a,
        kind: a.kind.replace("|", "/")
    }), addRefIds = (input, ref)=>Object.entries(input).reduce((acc, [id, item])=>({
            ...acc,
            [id]: {
                ...item,
                refId: ref.id
            }
        }), {});
async function handleRequest(request) {
    if (!request) return {};
    try {
        let response = await request;
        if (response === !1 || response === !0) throw new Error("Unexpected boolean response");
        if (!response.ok) throw new Error(`Unexpected response not OK: ${response.statusText}`);
        let json = await response.json();
        return json.entries || json.stories ? {
            storyIndex: json
        } : json;
    } catch (err) {
        return {
            indexError: err
        };
    }
}
var parseUrl = (url)=>{
    let credentialsRegex = /https?:\/\/(.+:.+)@/, cleanUrl = url, authorization, [, credentials] = url.match(credentialsRegex) || [];
    return credentials && (cleanUrl = url.replace(`${credentials}@`, ""), authorization = btoa(`${credentials}`)), {
        url: cleanUrl,
        authorization
    };
}, map = (input, ref, options)=>{
    let { storyMapper } = options;
    return storyMapper ? Object.entries(input).reduce((acc, [id, item])=>({
            ...acc,
            [id]: storyMapper(ref, item)
        }), {}) : input;
}, init6 = ({ store: store2, provider, singleStory, docsOptions = {} }, { runCheck = !0 } = {})=>{
    let api = {
        findRef: (source)=>{
            let refs2 = api.getRefs();
            return Object.values(refs2).find(({ url })=>url.match(source));
        },
        changeRefVersion: (id, url)=>{
            let { versions, title } = api.getRefs()[id], ref = {
                id,
                url,
                versions,
                title,
                index: {},
                expanded: !0
            };
            api.setRef(id, {
                ...ref,
                type: "unknown"
            }, !1), api.checkRef(ref);
        },
        changeRefState: (id, previewInitialized)=>{
            let { [id]: ref, ...updated } = api.getRefs();
            updated[id] = {
                ...ref,
                previewInitialized
            }, store2.setState({
                refs: updated
            });
        },
        checkRef: async (ref)=>{
            let { id, url, version: version2, type } = ref, isPublic = type === "server-checked", loadedData = {}, query = version2 ? `?version=${version2}` : "", credentials = isPublic ? "omit" : "include", urlParseResult = parseUrl(url), headers = {
                Accept: "application/json"
            };
            urlParseResult.authorization && Object.assign(headers, {
                Authorization: `Basic ${urlParseResult.authorization}`
            });
            let [indexResult, storiesResult] = await Promise.all([
                "index.json",
                "stories.json"
            ].map(async (file)=>handleRequest(fetch(`${urlParseResult.url}/${file}${query}`, {
                    headers,
                    credentials
                }))));
            if (!indexResult.indexError || !storiesResult.indexError) {
                let metadata = await handleRequest(fetch(`${urlParseResult.url}/metadata.json${query}`, {
                    headers,
                    credentials,
                    cache: "no-cache"
                }).catch(()=>!1));
                Object.assign(loadedData, {
                    ...indexResult.indexError ? storiesResult : indexResult,
                    ...!metadata.indexError && metadata
                });
            } else isPublic || (loadedData.indexError = {
                message: (0, _tsDedent.dedent)`
            Error: Loading of ref failed
              at fetch (lib/api/src/modules/refs.ts)

            URL: ${urlParseResult.url}

            We weren't able to load the above URL,
            it's possible a CORS error happened.

            Please check your dev-tools network tab.
          `
            });
            let versions = ref.versions && Object.keys(ref.versions).length ? ref.versions : loadedData.versions;
            await api.setRef(id, {
                id,
                url: urlParseResult.url,
                ...loadedData,
                ...versions ? {
                    versions
                } : {},
                type: loadedData.storyIndex ? "lazy" : "auto-inject"
            });
        },
        getRefs: ()=>{
            let { refs: refs2 = {} } = store2.getState();
            return refs2;
        },
        setRef: (id, { storyIndex, setStoriesData, ...rest }, ready = !1)=>{
            if (singleStory) return;
            let { storyMapper = defaultStoryMapper } = provider.getConfig(), ref = api.getRefs()[id], index;
            setStoriesData ? index = transformSetStoriesStoryDataToStoriesHash(map(setStoriesData, ref, {
                storyMapper
            }), {
                provider,
                docsOptions,
                filters: {},
                status: {}
            }) : storyIndex && (index = transformStoryIndexToStoriesHash(storyIndex, {
                provider,
                docsOptions,
                filters: {},
                status: {}
            })), index && (index = addRefIds(index, ref)), api.updateRef(id, {
                index,
                ...rest
            });
        },
        updateRef: (id, data)=>{
            let { [id]: ref, ...updated } = api.getRefs();
            updated[id] = {
                ...ref,
                ...data
            };
            let ordered = Object.keys(initialState).reduce((obj, key)=>(obj[key] = updated[key], obj), {});
            store2.setState({
                refs: ordered
            });
        }
    }, refs = !singleStory && (0, _global.global).REFS || {}, initialState = refs;
    return runCheck && Object.entries(refs).forEach(([id, ref])=>{
        api.checkRef({
            ...ref,
            stories: {}
        });
    }), {
        api,
        state: {
            refs: initialState
        }
    };
};
var getEventMetadata = (context, fullAPI)=>{
    let { source, refId, type } = context, [sourceType, sourceLocation] = getSourceType(source, refId), ref = refId && fullAPI.getRefs()[refId] ? fullAPI.getRefs()[refId] : fullAPI.findRef(sourceLocation), meta = {
        source,
        sourceType,
        sourceLocation,
        refId,
        ref,
        type
    };
    switch(!0){
        case typeof refId == "string":
        case sourceType === "local":
        case sourceType === "external":
            return meta;
        default:
            return (0, _clientLogger.logger).warn(`Received a ${type} frame that was not configured as a ref`), null;
    }
};
var { FEATURES, fetch: fetch2 } = (0, _global.global), STORY_INDEX_PATH = "./index.json", removedOptions = [
    "enableShortcuts",
    "theme",
    "showRoots"
];
function removeRemovedOptions(options) {
    if (!options || typeof options == "string") return options;
    let result = {
        ...options
    };
    return removedOptions.forEach((option)=>{
        option in result && delete result[option];
    }), result;
}
var init7 = ({ fullAPI, store: store2, navigate, provider, storyId: initialStoryId, viewMode: initialViewMode, docsOptions = {} })=>{
    let api = {
        storyId: (0, _csf.toId),
        getData: (storyId, refId)=>{
            let result = api.resolveStory(storyId, refId);
            if (result?.type === "story" || result?.type === "docs") return result;
        },
        isPrepared: (storyId, refId)=>{
            let data = api.getData(storyId, refId);
            return data ? data.type === "story" ? data.prepared : !0 : !1;
        },
        resolveStory: (storyId, refId)=>{
            let { refs, index } = store2.getState();
            return refId && !refs[refId] ? null : refId ? refs[refId].index ? refs[refId].index[storyId] : void 0 : index ? index[storyId] : void 0;
        },
        getCurrentStoryData: ()=>{
            let { storyId, refId } = store2.getState();
            return api.getData(storyId, refId);
        },
        getParameters: (storyIdOrCombo, parameterName)=>{
            let { storyId, refId } = typeof storyIdOrCombo == "string" ? {
                storyId: storyIdOrCombo,
                refId: void 0
            } : storyIdOrCombo, data = api.getData(storyId, refId);
            if ([
                "story",
                "docs"
            ].includes(data?.type)) {
                let { parameters } = data;
                if (parameters) return parameterName ? parameters[parameterName] : parameters;
            }
            return null;
        },
        getCurrentParameter: (parameterName)=>{
            let { storyId, refId } = store2.getState();
            return api.getParameters({
                storyId,
                refId
            }, parameterName) || void 0;
        },
        jumpToComponent: (direction)=>{
            let { index, storyId, refs, refId } = store2.getState();
            if (!api.getData(storyId, refId)) return;
            let hash = refId ? refs[refId].index || {} : index, result = api.findSiblingStoryId(storyId, hash, direction, !0);
            result && api.selectStory(result, void 0, {
                ref: refId
            });
        },
        jumpToStory: (direction)=>{
            let { index, storyId, refs, refId } = store2.getState(), story = api.getData(storyId, refId);
            if (!story) return;
            let hash = story.refId ? refs[story.refId].index : index, result = api.findSiblingStoryId(storyId, hash, direction, !1);
            result && api.selectStory(result, void 0, {
                ref: refId
            });
        },
        selectFirstStory: ()=>{
            let { index } = store2.getState(), firstStory = Object.keys(index).find((id)=>index[id].type === "story");
            if (firstStory) {
                api.selectStory(firstStory);
                return;
            }
            navigate("/");
        },
        selectStory: (titleOrId, name, options = {})=>{
            let { ref } = options, { storyId, index, refs } = store2.getState(), hash = ref ? refs[ref].index : index, kindSlug = storyId?.split("--", 2)[0];
            if (name) {
                if (titleOrId) {
                    let id = ref ? `${ref}_${(0, _csf.toId)(titleOrId, name)}` : (0, _csf.toId)(titleOrId, name);
                    if (hash[id]) api.selectStory(id, void 0, options);
                    else {
                        let entry = hash[(0, _csf.sanitize)(titleOrId)];
                        if (entry?.type === "component") {
                            let foundId = entry.children.find((childId)=>hash[childId].name === name);
                            foundId && api.selectStory(foundId, void 0, options);
                        }
                    }
                } else {
                    let id = (0, _csf.toId)(kindSlug, name);
                    api.selectStory(id, void 0, options);
                }
            } else {
                let entry = titleOrId ? hash[titleOrId] || hash[(0, _csf.sanitize)(titleOrId)] : hash[kindSlug];
                if (!entry) throw new Error(`Unknown id or title: '${titleOrId}'`);
                store2.setState({
                    settings: {
                        ...store2.getState().settings,
                        lastTrackedStoryId: entry.id
                    }
                });
                let leafEntry = api.findLeafEntry(hash, entry.id), fullId = leafEntry.refId ? `${leafEntry.refId}_${leafEntry.id}` : leafEntry.id;
                navigate(`/${leafEntry.type}/${fullId}`);
            }
        },
        findLeafEntry (index, storyId) {
            let entry = index[storyId];
            if (entry.type === "docs" || entry.type === "story") return entry;
            let childStoryId = entry.children[0];
            return api.findLeafEntry(index, childStoryId);
        },
        findLeafStoryId (index, storyId) {
            return api.findLeafEntry(index, storyId)?.id;
        },
        findSiblingStoryId (storyId, index, direction, toSiblingGroup) {
            if (toSiblingGroup) {
                let lookupList2 = getComponentLookupList(index), position2 = lookupList2.findIndex((i)=>i.includes(storyId));
                return position2 === lookupList2.length - 1 && direction > 0 || position2 === 0 && direction < 0 ? void 0 : lookupList2[position2 + direction] ? lookupList2[position2 + direction][0] : void 0;
            }
            let lookupList = getStoriesLookupList(index), position = lookupList.indexOf(storyId);
            if (!(position === lookupList.length - 1 && direction > 0) && !(position === 0 && direction < 0)) return lookupList[position + direction];
        },
        updateStoryArgs: (story, updatedArgs)=>{
            let { id: storyId, refId } = story;
            provider.channel.emit((0, _coreEvents.UPDATE_STORY_ARGS), {
                storyId,
                updatedArgs,
                options: {
                    target: refId
                }
            });
        },
        resetStoryArgs: (story, argNames)=>{
            let { id: storyId, refId } = story;
            provider.channel.emit((0, _coreEvents.RESET_STORY_ARGS), {
                storyId,
                argNames,
                options: {
                    target: refId
                }
            });
        },
        fetchIndex: async ()=>{
            try {
                let result = await fetch2(STORY_INDEX_PATH);
                if (result.status !== 200) throw new Error(await result.text());
                let storyIndex = await result.json();
                if (storyIndex.v < 3) {
                    (0, _clientLogger.logger).warn(`Skipping story index with version v${storyIndex.v}, awaiting SET_STORIES.`);
                    return;
                }
                await api.setIndex(storyIndex);
            } catch (err) {
                await store2.setState({
                    indexError: err
                });
            }
        },
        setIndex: async (input)=>{
            let { index: oldHash, status, filters } = store2.getState(), newHash = transformStoryIndexToStoriesHash(input, {
                provider,
                docsOptions,
                status,
                filters
            }), output = addPreparedStories(newHash, oldHash);
            await store2.setState({
                internal_index: input,
                index: output,
                indexError: void 0
            });
        },
        updateStory: async (storyId, update2, ref)=>{
            if (ref) {
                let { id: refId, index } = ref;
                index[storyId] = {
                    ...index[storyId],
                    ...update2
                }, await fullAPI.updateRef(refId, {
                    index
                });
            } else {
                let { index } = store2.getState();
                index[storyId] = {
                    ...index[storyId],
                    ...update2
                }, await store2.setState({
                    index
                });
            }
        },
        updateDocs: async (docsId, update2, ref)=>{
            if (ref) {
                let { id: refId, index } = ref;
                index[docsId] = {
                    ...index[docsId],
                    ...update2
                }, await fullAPI.updateRef(refId, {
                    index
                });
            } else {
                let { index } = store2.getState();
                index[docsId] = {
                    ...index[docsId],
                    ...update2
                }, await store2.setState({
                    index
                });
            }
        },
        setPreviewInitialized: async (ref)=>{
            ref ? fullAPI.updateRef(ref.id, {
                previewInitialized: !0
            }) : store2.setState({
                previewInitialized: !0
            });
        },
        experimental_updateStatus: async (id, input)=>{
            let { status, internal_index: index } = store2.getState(), newStatus = {
                ...status
            }, update2 = typeof input == "function" ? input(status) : input;
            Object.keys(update2).length !== 0 && (Object.entries(update2).forEach(([storyId, value])=>{
                newStatus[storyId] = {
                    ...newStatus[storyId] || {}
                }, value === null ? delete newStatus[storyId][id] : newStatus[storyId][id] = value, Object.keys(newStatus[storyId]).length === 0 && delete newStatus[storyId];
            }), await store2.setState({
                status: newStatus
            }, {
                persistence: "session"
            }), index && await api.setIndex(index));
        },
        experimental_setFilter: async (id, filterFunction)=>{
            let { internal_index: index } = store2.getState();
            await store2.setState({
                filters: {
                    ...store2.getState().filters,
                    [id]: filterFunction
                }
            }), await api.setIndex(index);
        }
    };
    provider.channel.on((0, _coreEvents.STORY_SPECIFIED), function({ storyId, viewMode }) {
        let { sourceType } = getEventMetadata(this, fullAPI);
        if (sourceType === "local") {
            let state = store2.getState(), isCanvasRoute = state.path === "/" || state.viewMode === "story" || state.viewMode === "docs", stateHasSelection = state.viewMode && state.storyId, stateSelectionDifferent = state.viewMode !== viewMode || state.storyId !== storyId, { type } = state.index[state.storyId] || {};
            isCanvasRoute && (stateHasSelection && stateSelectionDifferent && !(type === "root" || type === "component" || type === "group") ? provider.channel.emit((0, _coreEvents.SET_CURRENT_STORY), {
                storyId: state.storyId,
                viewMode: state.viewMode
            }) : stateSelectionDifferent && navigate(`/${viewMode}/${storyId}`));
        }
    }), provider.channel.on((0, _coreEvents.CURRENT_STORY_WAS_SET), function() {
        let { ref } = getEventMetadata(this, fullAPI);
        api.setPreviewInitialized(ref);
    }), provider.channel.on((0, _coreEvents.STORY_CHANGED), function() {
        let { sourceType } = getEventMetadata(this, fullAPI);
        if (sourceType === "local") {
            let options = api.getCurrentParameter("options");
            options && fullAPI.setOptions(removeRemovedOptions(options));
        }
    }), provider.channel.on((0, _coreEvents.STORY_PREPARED), function({ id, ...update2 }) {
        let { ref, sourceType } = getEventMetadata(this, fullAPI);
        if (api.updateStory(id, {
            ...update2,
            prepared: !0
        }, ref), !ref && !store2.getState().hasCalledSetOptions) {
            let { options } = update2.parameters;
            fullAPI.setOptions(removeRemovedOptions(options)), store2.setState({
                hasCalledSetOptions: !0
            });
        }
        if (sourceType === "local") {
            let { storyId, index, refId } = store2.getState(), toBePreloaded = Array.from(new Set([
                api.findSiblingStoryId(storyId, index, 1, !0),
                api.findSiblingStoryId(storyId, index, -1, !0)
            ])).filter(Boolean);
            provider.channel.emit((0, _coreEvents.PRELOAD_ENTRIES), {
                ids: toBePreloaded,
                options: {
                    target: refId
                }
            });
        }
    }), provider.channel.on((0, _coreEvents.DOCS_PREPARED), function({ id, ...update2 }) {
        let { ref } = getEventMetadata(this, fullAPI);
        api.updateStory(id, {
            ...update2,
            prepared: !0
        }, ref);
    }), provider.channel.on((0, _coreEvents.SET_INDEX), function(index) {
        let { ref } = getEventMetadata(this, fullAPI);
        if (ref) fullAPI.setRef(ref.id, {
            ...ref,
            storyIndex: index
        }, !0);
        else {
            api.setIndex(index);
            let options = api.getCurrentParameter("options");
            fullAPI.setOptions(removeRemovedOptions(options));
        }
    }), provider.channel.on((0, _coreEvents.SET_STORIES), function(data) {
        let { ref } = getEventMetadata(this, fullAPI), setStoriesData = data.v ? denormalizeStoryParameters(data) : data.stories;
        if (ref) fullAPI.setRef(ref.id, {
            ...ref,
            setStoriesData
        }, !0);
        else throw new Error("Cannot call SET_STORIES for local frame");
    }), provider.channel.on((0, _coreEvents.SELECT_STORY), function({ kind, title = kind, story, name = story, storyId, ...rest }) {
        let { ref } = getEventMetadata(this, fullAPI);
        ref ? fullAPI.selectStory(storyId || title, name, {
            ...rest,
            ref: ref.id
        }) : fullAPI.selectStory(storyId || title, name, rest);
    }), provider.channel.on((0, _coreEvents.STORY_ARGS_UPDATED), function({ storyId, args }) {
        let { ref } = getEventMetadata(this, fullAPI);
        api.updateStory(storyId, {
            args
        }, ref);
    }), provider.channel.on((0, _coreEvents.CONFIG_ERROR), function(err) {
        let { ref } = getEventMetadata(this, fullAPI);
        api.setPreviewInitialized(ref);
    }), provider.channel.on((0, _coreEvents.STORY_MISSING), function(err) {
        let { ref } = getEventMetadata(this, fullAPI);
        api.setPreviewInitialized(ref);
    }), provider.channel.on((0, _coreEvents.SET_CONFIG), ()=>{
        let config2 = provider.getConfig();
        config2?.sidebar?.filters && store2.setState({
            filters: {
                ...store2.getState().filters,
                ...config2?.sidebar?.filters
            }
        });
    });
    let config = provider.getConfig();
    return {
        api,
        state: {
            storyId: initialStoryId,
            viewMode: initialViewMode,
            hasCalledSetOptions: !1,
            previewInitialized: !1,
            status: {},
            filters: config?.sidebar?.filters || {}
        },
        init: async ()=>{
            FEATURES?.storyStoreV7 && (provider.channel.on((0, _coreEvents.STORY_INDEX_INVALIDATED), ()=>api.fetchIndex()), await api.fetchIndex());
        }
    };
};
var layout_exports = {};
__export(layout_exports, {
    ActiveTabs: ()=>ActiveTabs,
    focusableUIElements: ()=>focusableUIElements,
    init: ()=>init8
});
var { document } = (0, _global.global), ActiveTabs = {
    SIDEBAR: "sidebar",
    CANVAS: "canvas",
    ADDONS: "addons"
}, defaultState = {
    ui: {
        enableShortcuts: !0
    },
    layout: {
        initialActive: ActiveTabs.CANVAS,
        showToolbar: !0,
        isFullscreen: !1,
        showPanel: !0,
        showNav: !0,
        panelPosition: "bottom",
        showTabs: !0
    },
    selectedPanel: void 0,
    theme: (0, _create.create)()
}, focusableUIElements = {
    storySearchField: "storybook-explorer-searchfield",
    storyListMenu: "storybook-explorer-menu",
    storyPanelRoot: "storybook-panel-root"
}, init8 = ({ store: store2, provider, singleStory, fullAPI })=>{
    let api = {
        toggleFullscreen (toggled) {
            return store2.setState((state)=>{
                let { showNav } = state.layout, value = typeof toggled == "boolean" ? toggled : !state.layout.isFullscreen, shouldShowNav = showNav === !1 && value === !1;
                return {
                    layout: {
                        ...state.layout,
                        isFullscreen: value,
                        showNav: !singleStory && shouldShowNav ? !0 : showNav
                    }
                };
            }, {
                persistence: "session"
            });
        },
        togglePanel (toggled) {
            return store2.setState((state)=>{
                let { showNav, isFullscreen } = state.layout, value = typeof toggled < "u" ? toggled : !state.layout.showPanel, shouldToggleFullScreen = showNav === !1 && value === !1;
                return {
                    layout: {
                        ...state.layout,
                        showPanel: value,
                        isFullscreen: shouldToggleFullScreen ? !0 : isFullscreen
                    }
                };
            }, {
                persistence: "session"
            });
        },
        togglePanelPosition (position) {
            return typeof position < "u" ? store2.setState((state)=>({
                    layout: {
                        ...state.layout,
                        panelPosition: position
                    }
                }), {
                persistence: "permanent"
            }) : store2.setState((state)=>({
                    layout: {
                        ...state.layout,
                        panelPosition: state.layout.panelPosition === "right" ? "bottom" : "right"
                    }
                }), {
                persistence: "permanent"
            });
        },
        toggleNav (toggled) {
            return store2.setState((state)=>{
                if (singleStory) return {
                    layout: state.layout
                };
                let { showPanel, isFullscreen } = state.layout, showNav = typeof toggled < "u" ? toggled : !state.layout.showNav, shouldToggleFullScreen = showPanel === !1 && showNav === !1;
                return {
                    layout: {
                        ...state.layout,
                        showNav,
                        isFullscreen: shouldToggleFullScreen ? !0 : !showNav && isFullscreen
                    }
                };
            }, {
                persistence: "session"
            });
        },
        toggleToolbar (toggled) {
            return store2.setState((state)=>{
                let value = typeof toggled < "u" ? toggled : !state.layout.showToolbar;
                return {
                    layout: {
                        ...state.layout,
                        showToolbar: value
                    }
                };
            }, {
                persistence: "session"
            });
        },
        resetLayout () {
            return store2.setState((state)=>({
                    layout: {
                        ...state.layout,
                        showNav: !1,
                        showPanel: !1,
                        isFullscreen: !1
                    }
                }), {
                persistence: "session"
            });
        },
        focusOnUIElement (elementId, select) {
            if (!elementId) return;
            let element = document.getElementById(elementId);
            element && (element.focus(), select && element.select());
        },
        getInitialOptions () {
            let { theme, selectedPanel, ...options } = provider.getConfig();
            return {
                ...defaultState,
                layout: {
                    ...defaultState.layout,
                    ...(0, _pickJsDefault.default)(options, Object.keys(defaultState.layout)),
                    ...singleStory && {
                        showNav: !1
                    }
                },
                ui: {
                    ...defaultState.ui,
                    ...(0, _pickJsDefault.default)(options, Object.keys(defaultState.ui))
                },
                selectedPanel: selectedPanel || defaultState.selectedPanel,
                theme: theme || defaultState.theme
            };
        },
        setOptions: (options)=>{
            let { layout, ui, selectedPanel, theme } = store2.getState();
            if (options) {
                let updatedLayout = {
                    ...layout,
                    ...options.layout,
                    ...(0, _pickJsDefault.default)(options, Object.keys(layout)),
                    ...singleStory && {
                        showNav: !1
                    }
                }, updatedUi = {
                    ...ui,
                    ...options.ui,
                    ...(0, _pickJsDefault.default)(options, Object.keys(ui))
                }, updatedTheme = {
                    ...theme,
                    ...options.theme
                }, modification = {};
                (0, _dequal.dequal)(ui, updatedUi) || (modification.ui = updatedUi), (0, _dequal.dequal)(layout, updatedLayout) || (modification.layout = updatedLayout), options.selectedPanel && !(0, _dequal.dequal)(selectedPanel, options.selectedPanel) && (modification.selectedPanel = options.selectedPanel), Object.keys(modification).length && store2.setState(modification, {
                    persistence: "permanent"
                }), (0, _dequal.dequal)(theme, updatedTheme) || store2.setState({
                    theme: updatedTheme
                });
            }
        }
    }, persisted = (0, _pickJsDefault.default)(store2.getState(), "layout", "selectedPanel");
    return {
        api,
        state: merge_default(api.getInitialOptions(), persisted),
        init: ()=>{
            api.setOptions(merge_default(api.getInitialOptions(), persisted)), provider.channel.on((0, _coreEvents.SET_CONFIG), ()=>{
                api.setOptions(merge_default(api.getInitialOptions(), persisted));
            });
        }
    };
};
var shortcuts_exports = {};
__export(shortcuts_exports, {
    controlOrMetaKey: ()=>controlOrMetaKey2,
    defaultShortcuts: ()=>defaultShortcuts,
    init: ()=>init9,
    isMacLike: ()=>isMacLike2,
    keys: ()=>keys
});
var { navigator } = (0, _global.global), isMacLike = ()=>navigator && navigator.platform ? !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) : !1, controlOrMetaSymbol = ()=>isMacLike() ? "\u2318" : "ctrl", controlOrMetaKey = ()=>isMacLike() ? "meta" : "control", optionOrAltSymbol = ()=>isMacLike() ? "\u2325" : "alt", isShortcutTaken = (arr1, arr2)=>JSON.stringify(arr1) === JSON.stringify(arr2), eventToShortcut = (e)=>{
    if ([
        "Meta",
        "Alt",
        "Control",
        "Shift"
    ].includes(e.key)) return null;
    let keys2 = [];
    if (e.altKey && keys2.push("alt"), e.ctrlKey && keys2.push("control"), e.metaKey && keys2.push("meta"), e.shiftKey && keys2.push("shift"), e.key && e.key.length === 1 && e.key !== " ") {
        let key = e.key.toUpperCase(), code = e.code?.toUpperCase().replace("KEY", "").replace("DIGIT", "");
        code && code.length === 1 && code !== key ? keys2.push([
            key,
            code
        ]) : keys2.push(key);
    }
    return e.key === " " && keys2.push("space"), e.key === "Escape" && keys2.push("escape"), e.key === "ArrowRight" && keys2.push("ArrowRight"), e.key === "ArrowDown" && keys2.push("ArrowDown"), e.key === "ArrowUp" && keys2.push("ArrowUp"), e.key === "ArrowLeft" && keys2.push("ArrowLeft"), keys2.length > 0 ? keys2 : null;
}, shortcutMatchesShortcut = (inputShortcut, shortcut)=>!inputShortcut || !shortcut || (inputShortcut.join("").startsWith("shift/") && inputShortcut.shift(), inputShortcut.length !== shortcut.length) ? !1 : !inputShortcut.find((input, i)=>Array.isArray(input) ? !input.includes(shortcut[i]) : input !== shortcut[i]), eventMatchesShortcut = (e, shortcut)=>shortcutMatchesShortcut(eventToShortcut(e), shortcut), keyToSymbol = (key)=>key === "alt" ? optionOrAltSymbol() : key === "control" ? "\u2303" : key === "meta" ? "\u2318" : key === "shift" ? "\u21E7\u200B" : key === "Enter" || key === "Backspace" || key === "Esc" || key === "escape" ? "" : key === " " ? "SPACE" : key === "ArrowUp" ? "\u2191" : key === "ArrowDown" ? "\u2193" : key === "ArrowLeft" ? "\u2190" : key === "ArrowRight" ? "\u2192" : key.toUpperCase(), shortcutToHumanString = (shortcut)=>shortcut.map(keyToSymbol).join(" ");
var { navigator: navigator2, document: document2 } = (0, _global.global), isMacLike2 = ()=>navigator2 && navigator2.platform ? !!navigator2.platform.match(/(Mac|iPhone|iPod|iPad)/i) : !1, controlOrMetaKey2 = ()=>isMacLike2() ? "meta" : "control";
function keys(o) {
    return Object.keys(o);
}
var defaultShortcuts = Object.freeze({
    fullScreen: [
        "F"
    ],
    togglePanel: [
        "A"
    ],
    panelPosition: [
        "D"
    ],
    toggleNav: [
        "S"
    ],
    toolbar: [
        "T"
    ],
    search: [
        "/"
    ],
    focusNav: [
        "1"
    ],
    focusIframe: [
        "2"
    ],
    focusPanel: [
        "3"
    ],
    prevComponent: [
        "alt",
        "ArrowUp"
    ],
    nextComponent: [
        "alt",
        "ArrowDown"
    ],
    prevStory: [
        "alt",
        "ArrowLeft"
    ],
    nextStory: [
        "alt",
        "ArrowRight"
    ],
    shortcutsPage: [
        controlOrMetaKey2(),
        "shift",
        ","
    ],
    aboutPage: [
        ","
    ],
    escape: [
        "escape"
    ],
    collapseAll: [
        controlOrMetaKey2(),
        "shift",
        "ArrowUp"
    ],
    expandAll: [
        controlOrMetaKey2(),
        "shift",
        "ArrowDown"
    ],
    remount: [
        "alt",
        "R"
    ]
}), addonsShortcuts = {};
function focusInInput(event) {
    let target = event.target;
    return /input|textarea/i.test(target.tagName) || target.getAttribute("contenteditable") !== null;
}
var init9 = ({ store: store2, fullAPI, provider })=>{
    let api = {
        getShortcutKeys () {
            return store2.getState().shortcuts;
        },
        getDefaultShortcuts () {
            return {
                ...defaultShortcuts,
                ...api.getAddonsShortcutDefaults()
            };
        },
        getAddonsShortcuts () {
            return addonsShortcuts;
        },
        getAddonsShortcutLabels () {
            let labels = {};
            return Object.entries(api.getAddonsShortcuts()).forEach(([actionName, { label }])=>{
                labels[actionName] = label;
            }), labels;
        },
        getAddonsShortcutDefaults () {
            let defaults = {};
            return Object.entries(api.getAddonsShortcuts()).forEach(([actionName, { defaultShortcut }])=>{
                defaults[actionName] = defaultShortcut;
            }), defaults;
        },
        async setShortcuts (shortcuts) {
            return await store2.setState({
                shortcuts
            }, {
                persistence: "permanent"
            }), shortcuts;
        },
        async restoreAllDefaultShortcuts () {
            return api.setShortcuts(api.getDefaultShortcuts());
        },
        async setShortcut (action, value) {
            let shortcuts = api.getShortcutKeys();
            return await api.setShortcuts({
                ...shortcuts,
                [action]: value
            }), value;
        },
        async setAddonShortcut (addon, shortcut) {
            let shortcuts = api.getShortcutKeys();
            return await api.setShortcuts({
                ...shortcuts,
                [`${addon}-${shortcut.actionName}`]: shortcut.defaultShortcut
            }), addonsShortcuts[`${addon}-${shortcut.actionName}`] = shortcut, shortcut;
        },
        async restoreDefaultShortcut (action) {
            let defaultShortcut = api.getDefaultShortcuts()[action];
            return api.setShortcut(action, defaultShortcut);
        },
        handleKeydownEvent (event) {
            let shortcut = eventToShortcut(event), shortcuts = api.getShortcutKeys(), matchedFeature = keys(shortcuts).find((feature)=>shortcutMatchesShortcut(shortcut, shortcuts[feature]));
            matchedFeature && api.handleShortcutFeature(matchedFeature, event);
        },
        handleShortcutFeature (feature, event) {
            let { layout: { isFullscreen, showNav, showPanel }, ui: { enableShortcuts }, storyId } = store2.getState();
            if (enableShortcuts) switch(event?.preventDefault && event.preventDefault(), feature){
                case "escape":
                    isFullscreen ? fullAPI.toggleFullscreen() : showNav || fullAPI.toggleNav();
                    break;
                case "focusNav":
                    isFullscreen && fullAPI.toggleFullscreen(), showNav || fullAPI.toggleNav(), fullAPI.focusOnUIElement(focusableUIElements.storyListMenu);
                    break;
                case "search":
                    isFullscreen && fullAPI.toggleFullscreen(), showNav || fullAPI.toggleNav(), setTimeout(()=>{
                        fullAPI.focusOnUIElement(focusableUIElements.storySearchField, !0);
                    }, 0);
                    break;
                case "focusIframe":
                    {
                        let element = document2.getElementById("storybook-preview-iframe");
                        if (element) try {
                            element.contentWindow.focus();
                        } catch  {}
                        break;
                    }
                case "focusPanel":
                    isFullscreen && fullAPI.toggleFullscreen(), showPanel || fullAPI.togglePanel(), fullAPI.focusOnUIElement(focusableUIElements.storyPanelRoot);
                    break;
                case "nextStory":
                    fullAPI.jumpToStory(1);
                    break;
                case "prevStory":
                    fullAPI.jumpToStory(-1);
                    break;
                case "nextComponent":
                    fullAPI.jumpToComponent(1);
                    break;
                case "prevComponent":
                    fullAPI.jumpToComponent(-1);
                    break;
                case "fullScreen":
                    fullAPI.toggleFullscreen();
                    break;
                case "togglePanel":
                    isFullscreen && (fullAPI.toggleFullscreen(), fullAPI.resetLayout()), fullAPI.togglePanel();
                    break;
                case "toggleNav":
                    isFullscreen && (fullAPI.toggleFullscreen(), fullAPI.resetLayout()), fullAPI.toggleNav();
                    break;
                case "toolbar":
                    fullAPI.toggleToolbar();
                    break;
                case "panelPosition":
                    isFullscreen && fullAPI.toggleFullscreen(), showPanel || fullAPI.togglePanel(), fullAPI.togglePanelPosition();
                    break;
                case "aboutPage":
                    fullAPI.navigate("/settings/about");
                    break;
                case "shortcutsPage":
                    fullAPI.navigate("/settings/shortcuts");
                    break;
                case "collapseAll":
                    fullAPI.collapseAll();
                    break;
                case "expandAll":
                    fullAPI.expandAll();
                    break;
                case "remount":
                    fullAPI.emit((0, _coreEvents.FORCE_REMOUNT), {
                        storyId
                    });
                    break;
                default:
                    addonsShortcuts[feature].action();
                    break;
            }
        }
    }, { shortcuts: persistedShortcuts = defaultShortcuts } = store2.getState(), state = {
        shortcuts: keys(defaultShortcuts).reduce((acc, key)=>({
                ...acc,
                [key]: persistedShortcuts[key] || defaultShortcuts[key]
            }), defaultShortcuts)
    };
    return {
        api,
        state,
        init: ()=>{
            document2.addEventListener("keydown", (event)=>{
                focusInInput(event) || api.handleKeydownEvent(event);
            }), provider.channel.on((0, _coreEvents.PREVIEW_KEYDOWN), (data)=>{
                api.handleKeydownEvent(data.event);
            });
        }
    };
};
var url_exports = {};
__export(url_exports, {
    init: ()=>init10
});
var { window: globalWindow } = (0, _global.global), parseBoolean = (value)=>{
    if (value === "true" || value === "1") return !0;
    if (value === "false" || value === "0") return !1;
}, prevParams, initialUrlSupport = ({ state: { location: location2, path, viewMode, storyId: storyIdFromUrl }, singleStory })=>{
    let { full, panel, nav, shortcuts, addonPanel, tabs, path: queryPath, ...otherParams } = (0, _router.queryFromLocation)(location2), layout = {
        isFullscreen: parseBoolean(full),
        showNav: !singleStory && parseBoolean(nav),
        showPanel: parseBoolean(panel),
        panelPosition: [
            "right",
            "bottom"
        ].includes(panel) ? panel : void 0,
        showTabs: parseBoolean(tabs)
    }, ui = {
        enableShortcuts: parseBoolean(shortcuts)
    }, selectedPanel = addonPanel || void 0, storyId = storyIdFromUrl, customQueryParams = (0, _dequal.dequal)(prevParams, otherParams) ? prevParams : otherParams;
    return prevParams = customQueryParams, {
        viewMode,
        layout,
        ui,
        selectedPanel,
        location: location2,
        path,
        customQueryParams,
        storyId
    };
}, init10 = (moduleArgs)=>{
    let { store: store2, navigate, provider, fullAPI } = moduleArgs, navigateTo = (path, queryParams = {}, options = {})=>{
        let params = Object.entries(queryParams).filter(([, v])=>v).sort(([a], [b])=>a < b ? -1 : 1).map(([k, v])=>`${k}=${v}`), to = [
            path,
            ...params
        ].join("&");
        return navigate(to, options);
    }, api = {
        getQueryParam (key) {
            let { customQueryParams } = store2.getState();
            return customQueryParams ? customQueryParams[key] : void 0;
        },
        getUrlState () {
            let { path, customQueryParams, storyId, url, viewMode } = store2.getState();
            return {
                path,
                queryParams: customQueryParams,
                storyId,
                url,
                viewMode
            };
        },
        setQueryParams (input) {
            let { customQueryParams } = store2.getState(), queryParams = {}, update2 = {
                ...customQueryParams,
                ...Object.entries(input).reduce((acc, [key, value])=>(value !== null && (acc[key] = value), acc), queryParams)
            };
            (0, _dequal.dequal)(customQueryParams, update2) || (store2.setState({
                customQueryParams: update2
            }), provider.channel.emit((0, _coreEvents.UPDATE_QUERY_PARAMS), update2));
        },
        navigateUrl (url, options) {
            navigate(url, {
                plain: !0,
                ...options
            });
        }
    }, updateArgsParam = ()=>{
        let { path, queryParams, viewMode } = api.getUrlState();
        if (viewMode !== "story") return;
        let currentStory = fullAPI.getCurrentStoryData();
        if (currentStory?.type !== "story") return;
        let { args, initialArgs } = currentStory, argsString = (0, _router.buildArgsParam)(initialArgs, args);
        navigateTo(path, {
            ...queryParams,
            args: argsString
        }, {
            replace: !0
        }), api.setQueryParams({
            args: argsString
        });
    };
    provider.channel.on((0, _coreEvents.SET_CURRENT_STORY), ()=>updateArgsParam());
    let handleOrId;
    return provider.channel.on((0, _coreEvents.STORY_ARGS_UPDATED), ()=>{
        "requestIdleCallback" in globalWindow ? (handleOrId && globalWindow.cancelIdleCallback(handleOrId), handleOrId = globalWindow.requestIdleCallback(updateArgsParam, {
            timeout: 1e3
        })) : (handleOrId && clearTimeout(handleOrId), setTimeout(updateArgsParam, 100));
    }), provider.channel.on((0, _coreEvents.GLOBALS_UPDATED), ({ globals, initialGlobals })=>{
        let { path, queryParams } = api.getUrlState(), globalsString = (0, _router.buildArgsParam)(initialGlobals, globals);
        navigateTo(path, {
            ...queryParams,
            globals: globalsString
        }, {
            replace: !0
        }), api.setQueryParams({
            globals: globalsString
        });
    }), provider.channel.on((0, _coreEvents.NAVIGATE_URL), (url, options)=>{
        api.navigateUrl(url, options);
    }), {
        api,
        state: initialUrlSupport(moduleArgs)
    };
};
var versions_exports = {};
__export(versions_exports, {
    init: ()=>init11
});
var import_semver = __toESM(require_semver2());
var version = "7.6.20";
var { VERSIONCHECK } = (0, _global.global), getVersionCheckData = (0, _memoizerificDefault.default)(1)(()=>{
    try {
        return {
            ...JSON.parse(VERSIONCHECK).data || {}
        };
    } catch  {
        return {};
    }
}), init11 = ({ store: store2 })=>{
    let { dismissedVersionNotification } = store2.getState(), state = {
        versions: {
            current: {
                version
            },
            ...getVersionCheckData()
        },
        dismissedVersionNotification
    }, api = {
        getCurrentVersion: ()=>{
            let { versions: { current } } = store2.getState();
            return current;
        },
        getLatestVersion: ()=>{
            let { versions: { latest, next, current } } = store2.getState();
            return current && import_semver.default.prerelease(current.version) && next ? latest && import_semver.default.gt(latest.version, next.version) ? latest : next : latest;
        },
        versionUpdateAvailable: ()=>{
            let latest = api.getLatestVersion(), current = api.getCurrentVersion();
            if (latest) {
                if (!latest.version || !current.version) return !0;
                let actualCurrent = !!import_semver.default.prerelease(current.version) ? `${import_semver.default.major(current.version)}.${import_semver.default.minor(current.version)}.${import_semver.default.patch(current.version)}` : current.version, diff = import_semver.default.diff(actualCurrent, latest.version);
                return import_semver.default.gt(latest.version, actualCurrent) && diff !== "patch" && !diff.includes("pre");
            }
            return !1;
        }
    };
    return {
        init: async ()=>{
            let { versions = {} } = store2.getState(), { latest, next } = getVersionCheckData();
            await store2.setState({
                versions: {
                    ...versions,
                    latest,
                    next
                }
            });
        },
        state,
        api
    };
};
var whatsnew_exports = {};
__export(whatsnew_exports, {
    init: ()=>init12
});
var WHATS_NEW_NOTIFICATION_ID = "whats-new", init12 = ({ fullAPI, store: store2, provider })=>{
    let state = {
        whatsNewData: void 0
    };
    function setWhatsNewState(newState) {
        store2.setState({
            whatsNewData: newState
        }), state.whatsNewData = newState;
    }
    let api = {
        isWhatsNewUnread () {
            return state.whatsNewData?.status === "SUCCESS" && !state.whatsNewData.postIsRead;
        },
        whatsNewHasBeenRead () {
            state.whatsNewData?.status === "SUCCESS" && (setWhatsNewCache({
                lastReadPost: state.whatsNewData.url
            }), setWhatsNewState({
                ...state.whatsNewData,
                postIsRead: !0
            }), fullAPI.clearNotification(WHATS_NEW_NOTIFICATION_ID));
        },
        toggleWhatsNewNotifications () {
            state.whatsNewData?.status === "SUCCESS" && (setWhatsNewState({
                ...state.whatsNewData,
                disableWhatsNewNotifications: !state.whatsNewData.disableWhatsNewNotifications
            }), provider.channel.emit((0, _coreEvents.TOGGLE_WHATS_NEW_NOTIFICATIONS), {
                disableWhatsNewNotifications: state.whatsNewData.disableWhatsNewNotifications
            }));
        }
    };
    function getLatestWhatsNewPost() {
        return provider.channel.emit((0, _coreEvents.REQUEST_WHATS_NEW_DATA)), new Promise((resolve)=>provider.channel.once((0, _coreEvents.RESULT_WHATS_NEW_DATA), ({ data })=>resolve(data)));
    }
    function setWhatsNewCache(cache) {
        provider.channel.emit((0, _coreEvents.SET_WHATS_NEW_CACHE), cache);
    }
    return {
        init: async ()=>{
            if ((0, _global.global).CONFIG_TYPE !== "DEVELOPMENT") return;
            let whatsNewData = await getLatestWhatsNewPost();
            setWhatsNewState(whatsNewData);
            let urlState = fullAPI.getUrlState();
            !(urlState?.path === "/onboarding" || urlState.queryParams?.onboarding === "true") && whatsNewData.status === "SUCCESS" && !whatsNewData.disableWhatsNewNotifications && whatsNewData.showNotification && fullAPI.addNotification({
                id: WHATS_NEW_NOTIFICATION_ID,
                link: "/settings/whats-new",
                content: {
                    headline: whatsNewData.excerpt,
                    subHeadline: "Click to learn what's new in Storybook"
                },
                icon: {
                    name: "hearthollow"
                },
                onClear ({ dismissed }) {
                    dismissed && setWhatsNewCache({
                        lastDismissedPost: whatsNewData.url
                    });
                }
            });
        },
        state,
        api
    };
};
var globals_exports = {};
__export(globals_exports, {
    init: ()=>init13
});
var init13 = ({ store: store2, fullAPI, provider })=>{
    let api = {
        getGlobals () {
            return store2.getState().globals;
        },
        getGlobalTypes () {
            return store2.getState().globalTypes;
        },
        updateGlobals (newGlobals) {
            provider.channel.emit((0, _coreEvents.UPDATE_GLOBALS), {
                globals: newGlobals,
                options: {
                    target: "storybook-preview-iframe"
                }
            });
        }
    }, state = {
        globals: {},
        globalTypes: {}
    }, updateGlobals = (globals)=>{
        let currentGlobals = store2.getState()?.globals;
        (0, _dequal.dequal)(globals, currentGlobals) || store2.setState({
            globals
        });
    };
    return provider.channel.on((0, _coreEvents.GLOBALS_UPDATED), function({ globals }) {
        let { ref } = getEventMetadata(this, fullAPI);
        ref ? (0, _clientLogger.logger).warn("received a GLOBALS_UPDATED from a non-local ref. This is not currently supported.") : updateGlobals(globals);
    }), provider.channel.on((0, _coreEvents.SET_GLOBALS), function({ globals, globalTypes }) {
        let { ref } = getEventMetadata(this, fullAPI), currentGlobals = store2.getState()?.globals;
        ref ? Object.keys(globals).length > 0 && (0, _clientLogger.logger).warn("received globals from a non-local ref. This is not currently supported.") : store2.setState({
            globals,
            globalTypes
        }), currentGlobals && Object.keys(currentGlobals).length !== 0 && !(0, _dequal.dequal)(globals, currentGlobals) && api.updateGlobals(currentGlobals);
    }), {
        api,
        state
    };
};
function mockChannel() {
    let transport = {
        setHandler: ()=>{},
        send: ()=>{}
    };
    return new (0, _channels.Channel)({
        transport
    });
}
var AddonStore = class {
    constructor(){
        this.loaders = {};
        this.elements = {};
        this.config = {};
        this.getChannel = ()=>(this.channel || this.setChannel(mockChannel()), this.channel);
        this.getServerChannel = ()=>{
            if (!this.serverChannel) throw new Error("Accessing non-existent serverChannel");
            return this.serverChannel;
        };
        this.ready = ()=>this.promise;
        this.hasChannel = ()=>!!this.channel;
        this.hasServerChannel = ()=>!!this.serverChannel;
        this.setChannel = (channel)=>{
            this.channel = channel, this.resolve();
        };
        this.setServerChannel = (channel)=>{
            this.serverChannel = channel;
        };
        this.addPanel = (id, options)=>{
            this.add(id, {
                type: (0, _types.Addon_TypesEnum).PANEL,
                ...options
            });
        };
        this.setConfig = (value)=>{
            Object.assign(this.config, value), this.hasChannel() ? this.getChannel().emit((0, _coreEvents.SET_CONFIG), this.config) : this.ready().then((channel)=>{
                channel.emit((0, _coreEvents.SET_CONFIG), this.config);
            });
        };
        this.getConfig = ()=>this.config;
        this.register = (id, callback)=>{
            this.loaders[id] && (0, _clientLogger.logger).warn(`${id} was loaded twice, this could have bad side-effects`), this.loaders[id] = callback;
        };
        this.loadAddons = (api)=>{
            Object.values(this.loaders).forEach((value)=>value(api));
        };
        this.promise = new Promise((res)=>{
            this.resolve = ()=>res(this.getChannel());
        });
    }
    getElements(type) {
        return this.elements[type] || (this.elements[type] = {}), this.elements[type];
    }
    add(id, addon) {
        let { type } = addon, collection = this.getElements(type);
        collection[id] = {
            id,
            ...addon
        };
    }
}, KEY = "__STORYBOOK_ADDONS_MANAGER";
function getAddonsStore() {
    return (0, _global.global)[KEY] || ((0, _global.global)[KEY] = new AddonStore), (0, _global.global)[KEY];
}
var addons = getAddonsStore();
var { ActiveTabs: ActiveTabs2 } = layout_exports;
var ManagerContext = createContext({
    api: void 0,
    state: initial_state_default({})
}), combineParameters = (...parameterSets)=>(0, _mergeWithJsDefault.default)({}, ...parameterSets, (objValue, srcValue)=>{
        if (Array.isArray(srcValue)) return srcValue;
    }), ManagerProvider = class extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.api = {};
        this.initModules = ()=>{
            this.modules.forEach((module)=>{
                "init" in module && module.init();
            });
        };
        let { location: location2, path, refId, viewMode = props.docsOptions.docsMode ? "docs" : props.viewMode, singleStory, storyId, docsOptions, navigate } = props, store2 = new Store({
            getState: ()=>this.state,
            setState: (stateChange, callback)=>this.setState(stateChange, callback)
        }), routeData = {
            location: location2,
            path,
            viewMode,
            singleStory,
            storyId,
            refId
        }, optionsData = {
            docsOptions
        };
        this.state = store2.getInitialState(initial_state_default({
            ...routeData,
            ...optionsData
        }));
        let apiData = {
            navigate,
            store: store2,
            provider: props.provider
        };
        this.modules = [
            provider_exports,
            channel_exports,
            addons_exports,
            layout_exports,
            notifications_exports,
            settings_exports,
            shortcuts_exports,
            stories_exports,
            refs_exports,
            globals_exports,
            url_exports,
            versions_exports,
            whatsnew_exports
        ].map((m)=>m.init({
                ...routeData,
                ...optionsData,
                ...apiData,
                state: this.state,
                fullAPI: this.api
            }));
        let state = initial_state_default(this.state, ...this.modules.map((m)=>m.state)), api = Object.assign(this.api, {
            navigate
        }, ...this.modules.map((m)=>m.api));
        this.state = state, this.api = api;
    }
    static getDerivedStateFromProps(props, state) {
        return state.path !== props.path ? {
            ...state,
            location: props.location,
            path: props.path,
            refId: props.refId,
            viewMode: props.viewMode,
            storyId: props.storyId
        } : null;
    }
    shouldComponentUpdate(nextProps, nextState) {
        let prevState = this.state, prevProps = this.props;
        return prevState !== nextState || prevProps.path !== nextProps.path;
    }
    render() {
        let { children } = this.props, value = {
            state: this.state,
            api: this.api
        };
        return (0, _reactDefault.default).createElement(EffectOnMount, {
            effect: this.initModules
        }, (0, _reactDefault.default).createElement(ManagerContext.Provider, {
            value
        }, (0, _reactDefault.default).createElement(ManagerConsumer, null, children)));
    }
};
ManagerProvider.displayName = "Manager";
var EffectOnMount = ({ children, effect })=>((0, _reactDefault.default).useEffect(effect, []), children), defaultFilter = (c)=>c;
function ManagerConsumer({ filter = defaultFilter, children }) {
    let c = (0, _react.useContext)(ManagerContext), renderer = (0, _react.useRef)(children), filterer = (0, _react.useRef)(filter);
    if (typeof renderer.current != "function") return (0, _reactDefault.default).createElement((0, _react.Fragment), null, renderer.current);
    let data = filterer.current(c), l = (0, _react.useMemo)(()=>[
            ...Object.entries(data).reduce((acc, keyval)=>acc.concat(keyval), [])
        ], [
        c.state
    ]);
    return (0, _react.useMemo)(()=>{
        let Child = renderer.current;
        return (0, _reactDefault.default).createElement(Child, {
            ...data
        });
    }, l);
}
function useStorybookState() {
    let { state } = (0, _react.useContext)(ManagerContext);
    return {
        ...state,
        get storiesHash () {
            return (0, _clientLogger.deprecate)("state.storiesHash is deprecated, please use state.index"), this.index || {};
        },
        get storiesConfigured () {
            return (0, _clientLogger.deprecate)("state.storiesConfigured is deprecated, please use state.previewInitialized"), this.previewInitialized;
        },
        get storiesFailed () {
            return (0, _clientLogger.deprecate)("state.storiesFailed is deprecated, please use state.indexError"), this.indexError;
        }
    };
}
function useStorybookApi() {
    let { api } = (0, _react.useContext)(ManagerContext);
    return api;
}
function orDefault(fromStore, defaultState2) {
    return typeof fromStore > "u" ? defaultState2 : fromStore;
}
var useChannel = (eventMap, deps = [])=>{
    let api = useStorybookApi();
    return (0, _react.useEffect)(()=>(Object.entries(eventMap).forEach(([type, listener])=>api.on(type, listener)), ()=>{
            Object.entries(eventMap).forEach(([type, listener])=>api.off(type, listener));
        }), deps), api.emit;
};
function useStoryPrepared(storyId) {
    return useStorybookApi().isPrepared(storyId);
}
function useParameter(parameterKey, defaultValue) {
    let result = useStorybookApi().getCurrentParameter(parameterKey);
    return orDefault(result, defaultValue);
}
globalThis.STORYBOOK_ADDON_STATE = {};
var { STORYBOOK_ADDON_STATE } = globalThis;
function useSharedState(stateId, defaultState2) {
    let api = useStorybookApi(), existingState = api.getAddonState(stateId) || STORYBOOK_ADDON_STATE[stateId], state = orDefault(existingState, STORYBOOK_ADDON_STATE[stateId] ? STORYBOOK_ADDON_STATE[stateId] : defaultState2), quicksync = !1;
    state === defaultState2 && defaultState2 !== void 0 && (STORYBOOK_ADDON_STATE[stateId] = defaultState2, quicksync = !0), (0, _react.useEffect)(()=>{
        quicksync && api.setAddonState(stateId, defaultState2);
    }, [
        quicksync
    ]);
    let setState = async (s, options)=>{
        let result = await api.setAddonState(stateId, s, options);
        return STORYBOOK_ADDON_STATE[stateId] = result, result;
    }, allListeners = (0, _react.useMemo)(()=>{
        let stateChangeHandlers = {
            [`${0, _coreEvents.SHARED_STATE_CHANGED}-client-${stateId}`]: setState,
            [`${0, _coreEvents.SHARED_STATE_SET}-client-${stateId}`]: setState
        }, stateInitializationHandlers = {
            [(0, _coreEvents.SET_STORIES)]: async ()=>{
                let currentState = api.getAddonState(stateId);
                currentState ? (STORYBOOK_ADDON_STATE[stateId] = currentState, api.emit(`${(0, _coreEvents.SHARED_STATE_SET)}-manager-${stateId}`, currentState)) : STORYBOOK_ADDON_STATE[stateId] ? (await setState(STORYBOOK_ADDON_STATE[stateId]), api.emit(`${(0, _coreEvents.SHARED_STATE_SET)}-manager-${stateId}`, STORYBOOK_ADDON_STATE[stateId])) : defaultState2 !== void 0 && (await setState(defaultState2), STORYBOOK_ADDON_STATE[stateId] = defaultState2, api.emit(`${(0, _coreEvents.SHARED_STATE_SET)}-manager-${stateId}`, defaultState2));
            },
            [(0, _coreEvents.STORY_CHANGED)]: ()=>{
                let currentState = api.getAddonState(stateId);
                currentState !== void 0 && api.emit(`${(0, _coreEvents.SHARED_STATE_SET)}-manager-${stateId}`, currentState);
            }
        };
        return {
            ...stateChangeHandlers,
            ...stateInitializationHandlers
        };
    }, [
        stateId
    ]), emit = useChannel(allListeners);
    return [
        state,
        async (newStateOrMerger, options)=>{
            let result = await setState(newStateOrMerger, options);
            emit(`${(0, _coreEvents.SHARED_STATE_CHANGED)}-manager-${stateId}`, result);
        }
    ];
}
function useAddonState(addonId, defaultState2) {
    return useSharedState(addonId, defaultState2);
}
function useArgs() {
    let { getCurrentStoryData, updateStoryArgs, resetStoryArgs } = useStorybookApi(), data = getCurrentStoryData(), args = data?.type === "story" ? data.args : {}, updateArgs = (0, _react.useCallback)((newArgs)=>updateStoryArgs(data, newArgs), [
        data,
        updateStoryArgs
    ]), resetArgs = (0, _react.useCallback)((argNames)=>resetStoryArgs(data, argNames), [
        data,
        resetStoryArgs
    ]);
    return [
        args,
        updateArgs,
        resetArgs
    ];
}
function useGlobals() {
    let api = useStorybookApi();
    return [
        api.getGlobals(),
        api.updateGlobals
    ];
}
function useGlobalTypes() {
    return useStorybookApi().getGlobalTypes();
}
function useCurrentStory() {
    let { getCurrentStoryData } = useStorybookApi();
    return getCurrentStoryData();
}
function useArgTypes() {
    let current = useCurrentStory();
    return current?.type === "story" && current.argTypes || {};
}
var typesX = (0, _types.Addon_TypesEnum);

},{"7a5dfb4803e68fc7":"eG5no","react":"jEiK2","lodash/mergeWith.js":"aAf4o","@storybook/core-events":"ZHxpZ","@storybook/client-logger":"7OFBO","store2":"eLNoW","telejson":"fQ9bI","lodash/isEqual.js":"h4L3C","@storybook/types":"h7DQs","@storybook/global":"4g4co","@storybook/csf":"9PLwP","ts-dedent":"lKwH2","memoizerific":"aOMtb","lodash/countBy.js":"fV2yN","lodash/mapValues.js":"dFo84","lodash/pick.js":"FAjem","dequal":"i1mT7","@storybook/theming/create":"aBfoM","@storybook/router":"90UkO","@storybook/channels":"9dkSr","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"eG5no":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"aAf4o":[function(require,module,exports,__globalThis) {
var baseMerge = require("534a42b3db0d10f3"), createAssigner = require("1dd402ac842b0276");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
module.exports = mergeWith;

},{"534a42b3db0d10f3":"iYGWe","1dd402ac842b0276":"2mMsr"}],"iYGWe":[function(require,module,exports,__globalThis) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"enjqg","76e9fd6386317324":"fEg8O","e7dca58bcfe9c669":"cCTF2","4ea46d88599071ec":"bgv6y","c52c932be04280cc":"aI4dY","27adf66142f57b4b":"5cYT3","564385b2292facea":"dLczq"}],"fEg8O":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"gnpgU","7d9c95e1ffdd4f16":"5HrAW"}],"bgv6y":[function(require,module,exports,__globalThis) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"fEg8O","ec8e1b90277c5e12":"igTU3","4b1a2b5090faf247":"hTk4M","d7675bdf0a02bffc":"46bXb","1067a6f3f6bd5986":"guHLd","2238139506f6727b":"g4qrn","290c774b41e416bb":"dwcs0","f481819c40e5b527":"bm3KN","6532fda6a198015f":"bLdH1","7f306c94b573f977":"fZ818","32c89e763261c579":"aI4dY","ff359d315efefc4f":"dl7P5","61ce92c01fd411fe":"b5AGg","abfa8f7e72201edb":"dLczq","c54d414b219fa287":"dWD2V"}],"bm3KN":[function(require,module,exports,__globalThis) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"6YiMZ","639a4883b097af28":"kcpfl"}],"dLczq":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = safeGet;

},{}],"dWD2V":[function(require,module,exports,__globalThis) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"9JpIX","437a3e3814017158":"5cYT3"}],"2mMsr":[function(require,module,exports,__globalThis) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"asxKL","4f5832110eba92d3":"gBXp1"}],"asxKL":[function(require,module,exports,__globalThis) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"6d6HV","ff7d23ff2a2ea6f8":"3GWA5","a11d545e809d14f7":"gRnTJ"}],"gBXp1":[function(require,module,exports,__globalThis) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"5HrAW","616bc732534dffe0":"6YiMZ","e781332a36d1bd7":"lOS0l","c8548bf6929b8a5d":"aI4dY"}],"eLNoW":[function(require,module,exports,__globalThis) {
(function(window, define) {
    var _ = {
        version: "2.14.3",
        areas: {},
        apis: {},
        nsdelim: '.',
        // utilities
        inherit: function(api, o) {
            for(var p in api)if (!o.hasOwnProperty(p)) Object.defineProperty(o, p, Object.getOwnPropertyDescriptor(api, p));
            return o;
        },
        stringify: function(d, fn) {
            return d === undefined || typeof d === "function" ? d + '' : JSON.stringify(d, fn || _.replace);
        },
        parse: function(s, fn) {
            // if it doesn't parse, return as is
            try {
                return JSON.parse(s, fn || _.revive);
            } catch (e) {
                return s;
            }
        },
        // extension hooks
        fn: function(name, fn) {
            _.storeAPI[name] = fn;
            for(var api in _.apis)_.apis[api][name] = fn;
        },
        get: function(area, key) {
            return area.getItem(key);
        },
        set: function(area, key, string) {
            area.setItem(key, string);
        },
        remove: function(area, key) {
            area.removeItem(key);
        },
        key: function(area, i) {
            return area.key(i);
        },
        length: function(area) {
            return area.length;
        },
        clear: function(area) {
            area.clear();
        },
        // core functions
        Store: function(id, area, namespace) {
            var store = _.inherit(_.storeAPI, function(key, data, overwrite) {
                if (arguments.length === 0) return store.getAll();
                if (typeof data === "function") return store.transact(key, data, overwrite);
                 // fn=data, alt=overwrite
                if (data !== undefined) return store.set(key, data, overwrite);
                if (typeof key === "string" || typeof key === "number") return store.get(key);
                if (typeof key === "function") return store.each(key);
                if (!key) return store.clear();
                return store.setAll(key, data); // overwrite=data, data=key
            });
            store._id = id;
            try {
                var testKey = '__store2_test';
                area.setItem(testKey, 'ok');
                store._area = area;
                area.removeItem(testKey);
            } catch (e) {
                store._area = _.storage('fake');
            }
            store._ns = namespace || '';
            if (!_.areas[id]) _.areas[id] = store._area;
            if (!_.apis[store._ns + store._id]) _.apis[store._ns + store._id] = store;
            return store;
        },
        storeAPI: {
            // admin functions
            area: function(id, area) {
                var store = this[id];
                if (!store || !store.area) {
                    store = _.Store(id, area, this._ns); //new area-specific api in this namespace
                    if (!this[id]) this[id] = store;
                }
                return store;
            },
            namespace: function(namespace, singleArea, delim) {
                delim = delim || this._delim || _.nsdelim;
                if (!namespace) return this._ns ? this._ns.substring(0, this._ns.length - delim.length) : '';
                var ns = namespace, store = this[ns];
                if (!store || !store.namespace) {
                    store = _.Store(this._id, this._area, this._ns + ns + delim); //new namespaced api
                    store._delim = delim;
                    if (!this[ns]) this[ns] = store;
                    if (!singleArea) for(var name in _.areas)store.area(name, _.areas[name]);
                }
                return store;
            },
            isFake: function(force) {
                if (force) {
                    this._real = this._area;
                    this._area = _.storage('fake');
                } else if (force === false) this._area = this._real || this._area;
                return this._area.name === 'fake';
            },
            toString: function() {
                return 'store' + (this._ns ? '.' + this.namespace() : '') + '[' + this._id + ']';
            },
            // storage functions
            has: function(key) {
                if (this._area.has) return this._area.has(this._in(key)); //extension hook
                return !!(this._in(key) in this._area);
            },
            size: function() {
                return this.keys().length;
            },
            each: function(fn, fill) {
                for(var i = 0, m = _.length(this._area); i < m; i++){
                    var key = this._out(_.key(this._area, i));
                    if (key !== undefined) {
                        if (fn.call(this, key, this.get(key), fill) === false) break;
                    }
                    if (m > _.length(this._area)) {
                        m--;
                        i--;
                    } // in case of removeItem
                }
                return fill || this;
            },
            keys: function(fillList) {
                return this.each(function(k, v, list) {
                    list.push(k);
                }, fillList || []);
            },
            get: function(key, alt) {
                var s = _.get(this._area, this._in(key)), fn;
                if (typeof alt === "function") {
                    fn = alt;
                    alt = null;
                }
                return s !== null ? _.parse(s, fn) : alt != null ? alt : s;
            },
            getAll: function(fillObj) {
                return this.each(function(k, v, all) {
                    all[k] = v;
                }, fillObj || {});
            },
            transact: function(key, fn, alt) {
                var val = this.get(key, alt), ret = fn(val);
                this.set(key, ret === undefined ? val : ret);
                return this;
            },
            set: function(key, data, overwrite) {
                var d = this.get(key), replacer;
                if (d != null && overwrite === false) return data;
                if (typeof overwrite === "function") {
                    replacer = overwrite;
                    overwrite = undefined;
                }
                return _.set(this._area, this._in(key), _.stringify(data, replacer), overwrite) || d;
            },
            setAll: function(data, overwrite) {
                var changed, val;
                for(var key in data){
                    val = data[key];
                    if (this.set(key, val, overwrite) !== val) changed = true;
                }
                return changed;
            },
            add: function(key, data, replacer) {
                var d = this.get(key);
                if (d instanceof Array) data = d.concat(data);
                else if (d !== null) {
                    var type = typeof d;
                    if (type === typeof data && type === 'object') {
                        for(var k in data)d[k] = data[k];
                        data = d;
                    } else data = d + data;
                }
                _.set(this._area, this._in(key), _.stringify(data, replacer));
                return data;
            },
            remove: function(key, alt) {
                var d = this.get(key, alt);
                _.remove(this._area, this._in(key));
                return d;
            },
            clear: function() {
                if (!this._ns) _.clear(this._area);
                else this.each(function(k) {
                    _.remove(this._area, this._in(k));
                }, 1);
                return this;
            },
            clearAll: function() {
                var area = this._area;
                for(var id in _.areas)if (_.areas.hasOwnProperty(id)) {
                    this._area = _.areas[id];
                    this.clear();
                }
                this._area = area;
                return this;
            },
            // internal use functions
            _in: function(k) {
                if (typeof k !== "string") k = _.stringify(k);
                return this._ns ? this._ns + k : k;
            },
            _out: function(k) {
                return this._ns ? k && k.indexOf(this._ns) === 0 ? k.substring(this._ns.length) : undefined : k;
            }
        },
        storage: function(name) {
            return _.inherit(_.storageAPI, {
                items: {},
                name: name
            });
        },
        storageAPI: {
            length: 0,
            has: function(k) {
                return this.items.hasOwnProperty(k);
            },
            key: function(i) {
                var c = 0;
                for(var k in this.items){
                    if (this.has(k) && i === c++) return k;
                }
            },
            setItem: function(k, v) {
                if (!this.has(k)) this.length++;
                this.items[k] = v;
            },
            removeItem: function(k) {
                if (this.has(k)) {
                    delete this.items[k];
                    this.length--;
                }
            },
            getItem: function(k) {
                return this.has(k) ? this.items[k] : null;
            },
            clear: function() {
                for(var k in this.items)this.removeItem(k);
            }
        } // end _.storageAPI
    };
    var store = // safely set this up (throws error in IE10/32bit mode for local files)
    _.Store("local", function() {
        try {
            return localStorage;
        } catch (e) {}
    }());
    store.local = store; // for completeness
    store._ = _; // for extenders and debuggers...
    // safely setup store.session (throws exception in FF for file:/// urls)
    store.area("session", function() {
        try {
            return sessionStorage;
        } catch (e) {}
    }());
    store.area("page", _.storage("page"));
    if (typeof define === 'function' && define.amd !== undefined) define('store2', [], function() {
        return store;
    });
    else if (0, module.exports) module.exports = store;
    else {
        // expose the primary store fn to the global object and save conflicts
        if (window.store) _.conflict = window.store;
        window.store = store;
    }
})(this, this && this.define);

},{}],"h4L3C":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"b3sAT"}],"fV2yN":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("13cc5ed37dfe96e6"), createAggregator = require("24ab5b8b071f39");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var countBy = createAggregator(function(result, value, key) {
    if (hasOwnProperty.call(result, key)) ++result[key];
    else baseAssignValue(result, key, 1);
});
module.exports = countBy;

},{"13cc5ed37dfe96e6":"gnpgU","24ab5b8b071f39":"iVcsf"}],"iVcsf":[function(require,module,exports,__globalThis) {
var arrayAggregator = require("64738ab87169df22"), baseAggregator = require("d5eaf98cd48e9d0f"), baseIteratee = require("161d63ee0d95ee81"), isArray = require("3ebefba2225c8b9e");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
module.exports = createAggregator;

},{"64738ab87169df22":"gJfWM","d5eaf98cd48e9d0f":"1KFYR","161d63ee0d95ee81":"8o7Fu","3ebefba2225c8b9e":"dwcs0"}],"gJfWM":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = arrayAggregator;

},{}],"1KFYR":[function(require,module,exports,__globalThis) {
var baseEach = require("b2d4f581dd6625d8");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = baseAggregator;

},{"b2d4f581dd6625d8":"4MYFo"}],"4MYFo":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"fVTBe","f1e3fc84161ef3ec":"1037h"}],"1037h":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"6YiMZ"}],"aBfoM":[function(require,module,exports,__globalThis) {
module.exports = require("e98c47207ac2a2f6");

},{"e98c47207ac2a2f6":"9Ds1P"}],"9Ds1P":[function(require,module,exports,__globalThis) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: !0
    });
}, __copyProps = (to, from, except, desc)=>{
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from))!__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
        get: ()=>from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: !0
    }), mod);
var create_exports = {};
__export(create_exports, {
    create: ()=>create,
    themes: ()=>themes
});
module.exports = __toCommonJS(create_exports);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends.apply(this, arguments);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _setPrototypeOf(o, p) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o2, p2) {
        return o2.__proto__ = p2, o2;
    }, _setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype), subClass.prototype.constructor = subClass, _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o2) {
        return o2.__proto__ || Object.getPrototypeOf(o2);
    }, _getPrototypeOf(o);
}
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch  {
        return typeof fn == "function";
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch  {}
    return (_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o));
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map == "function" ? new Map : void 0;
    return _wrapNativeSuper = function(Class2) {
        if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
        if (typeof Class2 != "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache < "u") {
            if (_cache.has(Class2)) return _cache.get(Class2);
            _cache.set(Class2, Wrapper);
        }
        function Wrapper() {
            return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(Class2.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, Class2);
    }, _wrapNativeSuper(Class);
}
var ERRORS = {
    1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
    2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
    3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
    4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
    5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
    6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
    7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
    8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
    9: `Please provide a number of steps to the modularScale helper.

`,
    10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
    11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
    12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
    13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
    14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
    15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
    16: `You must provide a template to this method.

`,
    17: `You passed an unsupported selector state to this method.

`,
    18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
    19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
    20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
    21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    23: `fontFace expects a name of a font-family.

`,
    24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
    25: `fontFace expects localFonts to be an array.

`,
    26: `fontFace expects fileFormats to be an array.

`,
    27: `radialGradient requries at least 2 color-stops to properly render.

`,
    28: `Please supply a filename to retinaImage() as the first argument.

`,
    29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
    30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
    32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
    33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
    34: `borderRadius expects a radius value as a string or number as the second argument.

`,
    35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
    36: `Property must be a string value.

`,
    37: `Syntax Error at %s.

`,
    38: `Formula contains a function that needs parentheses at %s.

`,
    39: `Formula is missing closing parenthesis at %s.

`,
    40: `Formula has too many closing parentheses at %s.

`,
    41: `All values in a formula must have the same unit or be unitless.

`,
    42: `Please provide a number of steps to the modularScale helper.

`,
    43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
    44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
    45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
    46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
    47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
    48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
    49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
    50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
    51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
    52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
    53: `fontFace expects localFonts to be an array.

`,
    54: `fontFace expects fileFormats to be an array.

`,
    55: `fontFace expects a name of a font-family.

`,
    56: `linearGradient requries at least 2 color-stops to properly render.

`,
    57: `radialGradient requries at least 2 color-stops to properly render.

`,
    58: `Please supply a filename to retinaImage() as the first argument.

`,
    59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
    60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    61: `Property must be a string value.

`,
    62: `borderRadius expects a radius value as a string or number as the second argument.

`,
    63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
    64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
    65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
    66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
    67: `You must provide a template to this method.

`,
    68: `You passed an unsupported selector state to this method.

`,
    69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
    70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
    71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
    72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
    73: `Please provide a valid CSS variable.

`,
    74: `CSS variable not found and no default was provided.

`,
    75: `important requires a valid style object, got a %s instead.

`,
    76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
    77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
    78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0], b = [], c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    return b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    }), a;
}
var PolishedError = function(_Error) {
    _inheritsLoose(PolishedError2, _Error);
    function PolishedError2(code) {
        var _this;
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        _this = _Error.call(this, format.apply(void 0, [
            ERRORS[code]
        ].concat(args))) || this;
        return _assertThisInitialized(_this);
    }
    return PolishedError2;
}(_wrapNativeSuper(Error));
function colorToInt(color2) {
    return Math.round(color2 * 255);
}
function convertToInt(red, green, blue) {
    return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0 && (convert = convertToInt), saturation === 0) return convert(lightness, lightness, lightness);
    var huePrime = (hue % 360 + 360) % 360 / 60, chroma = (1 - Math.abs(2 * lightness - 1)) * saturation, secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1)), red = 0, green = 0, blue = 0;
    huePrime >= 0 && huePrime < 1 ? (red = chroma, green = secondComponent) : huePrime >= 1 && huePrime < 2 ? (red = secondComponent, green = chroma) : huePrime >= 2 && huePrime < 3 ? (green = chroma, blue = secondComponent) : huePrime >= 3 && huePrime < 4 ? (green = secondComponent, blue = chroma) : huePrime >= 4 && huePrime < 5 ? (red = secondComponent, blue = chroma) : huePrime >= 5 && huePrime < 6 && (red = chroma, blue = secondComponent);
    var lightnessModification = lightness - chroma / 2, finalRed = red + lightnessModification, finalGreen = green + lightnessModification, finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
function nameToHex(color2) {
    if (typeof color2 != "string") return color2;
    var normalizedColorName = color2.toLowerCase();
    return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color2;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/, hexRgbaRegex = /^#[a-fA-F0-9]{8}$/, reducedHexRegex = /^#[a-fA-F0-9]{3}$/, reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/, rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb(color2) {
    if (typeof color2 != "string") throw new PolishedError(3);
    var normalizedColor = nameToHex(color2);
    if (normalizedColor.match(hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match(hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha
        };
    }
    if (normalizedColor.match(reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match(reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10), saturation = parseInt("" + hslMatched[2], 10) / 100, lightness = parseInt("" + hslMatched[3], 10) / 100, rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")", hslRgbMatched = rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10), _saturation = parseInt("" + hslaMatched[2], 10) / 100, _lightness = parseInt("" + hslaMatched[3], 10) / 100, _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")", _hslRgbMatched = rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new PolishedError(5);
}
function rgbToHsl(color2) {
    var red = color2.red / 255, green = color2.green / 255, blue = color2.blue / 255, max = Math.max(red, green, blue), min = Math.min(red, green, blue), lightness = (max + min) / 2;
    if (max === min) return color2.alpha !== void 0 ? {
        hue: 0,
        saturation: 0,
        lightness,
        alpha: color2.alpha
    } : {
        hue: 0,
        saturation: 0,
        lightness
    };
    var hue, delta = max - min, saturation = lightness > .5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            hue = (red - green) / delta + 4;
            break;
    }
    return hue *= 60, color2.alpha !== void 0 ? {
        hue,
        saturation,
        lightness,
        alpha: color2.alpha
    } : {
        hue,
        saturation,
        lightness
    };
}
function parseToHsl(color2) {
    return rgbToHsl(parseToRgb(color2));
}
var reduceHexValue = function(value) {
    return value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6] ? "#" + value[1] + value[3] + value[5] : value;
}, reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color2) {
    return numberToHex(Math.round(color2 * 255));
}
function convertToHex(red, green, blue) {
    return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
    return hslToRgb(hue, saturation, lightness, convertToHex);
}
function hsl(value, saturation, lightness) {
    if (typeof value == "number" && typeof saturation == "number" && typeof lightness == "number") return hslToHex(value, saturation, lightness);
    if (typeof value == "object" && saturation === void 0 && lightness === void 0) return hslToHex(value.hue, value.saturation, value.lightness);
    throw new PolishedError(1);
}
function hsla(value, saturation, lightness, alpha) {
    if (typeof value == "number" && typeof saturation == "number" && typeof lightness == "number" && typeof alpha == "number") return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    if (typeof value == "object" && saturation === void 0 && lightness === void 0 && alpha === void 0) return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new PolishedError(2);
}
function rgb(value, green, blue) {
    if (typeof value == "number" && typeof green == "number" && typeof blue == "number") return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
    if (typeof value == "object" && green === void 0 && blue === void 0) return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
    throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue == "string" && typeof secondValue == "number") {
        var rgbValue = parseToRgb(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else {
        if (typeof firstValue == "number" && typeof secondValue == "number" && typeof thirdValue == "number" && typeof fourthValue == "number") return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
        if (typeof firstValue == "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    }
    throw new PolishedError(7);
}
var isRgb = function(color2) {
    return typeof color2.red == "number" && typeof color2.green == "number" && typeof color2.blue == "number" && (typeof color2.alpha != "number" || typeof color2.alpha > "u");
}, isRgba = function(color2) {
    return typeof color2.red == "number" && typeof color2.green == "number" && typeof color2.blue == "number" && typeof color2.alpha == "number";
}, isHsl = function(color2) {
    return typeof color2.hue == "number" && typeof color2.saturation == "number" && typeof color2.lightness == "number" && (typeof color2.alpha != "number" || typeof color2.alpha > "u");
}, isHsla = function(color2) {
    return typeof color2.hue == "number" && typeof color2.saturation == "number" && typeof color2.lightness == "number" && typeof color2.alpha == "number";
};
function toColorString(color2) {
    if (typeof color2 != "object") throw new PolishedError(8);
    if (isRgba(color2)) return rgba(color2);
    if (isRgb(color2)) return rgb(color2);
    if (isHsla(color2)) return hsla(color2);
    if (isHsl(color2)) return hsl(color2);
    throw new PolishedError(8);
}
function curried(f, length, acc) {
    return function() {
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
    };
}
function curry(f) {
    return curried(f, f.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
function darken(amount, color2) {
    if (color2 === "transparent") return color2;
    var hslColor = parseToHsl(color2);
    return toColorString(_extends({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
var curriedDarken = curry(darken), curriedDarken$1 = curriedDarken;
function lighten(amount, color2) {
    if (color2 === "transparent") return color2;
    var hslColor = parseToHsl(color2);
    return toColorString(_extends({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
var curriedLighten = curry(lighten), curriedLighten$1 = curriedLighten;
function transparentize(amount, color2) {
    if (color2 === "transparent") return color2;
    var parsedColor = parseToRgb(color2), alpha = typeof parsedColor.alpha == "number" ? parsedColor.alpha : 1, colorWithAlpha = _extends({}, parsedColor, {
        alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return rgba(colorWithAlpha);
}
var curriedTransparentize = curry(transparentize), curriedTransparentize$1 = curriedTransparentize;
var color = {
    primary: "#FF4785",
    secondary: "#029CFD",
    tertiary: "#FAFBFC",
    ancillary: "#22a699",
    orange: "#FC521F",
    gold: "#FFAE00",
    green: "#66BF3C",
    seafoam: "#37D5D3",
    purple: "#6F2CAC",
    ultraviolet: "#2A0481",
    lightest: "#FFFFFF",
    lighter: "#F7FAFC",
    light: "#EEF3F6",
    mediumlight: "#ECF4F9",
    medium: "#D9E8F2",
    mediumdark: "#73828C",
    dark: "#5C6870",
    darker: "#454E54",
    darkest: "#2E3438",
    border: "hsla(203, 50%, 30%, 0.15)",
    positive: "#66BF3C",
    negative: "#FF4400",
    warning: "#E69D00",
    critical: "#FFFFFF",
    defaultText: "#2E3438",
    inverseText: "#FFFFFF",
    positiveText: "#448028",
    negativeText: "#D43900",
    warningText: "#A15C20"
}, background = {
    app: "#F6F9FC",
    bar: color.lightest,
    content: color.lightest,
    preview: color.lightest,
    gridCellSize: 10,
    hoverable: curriedTransparentize$1(.9, color.secondary),
    positive: "#E1FFD4",
    negative: "#FEDED2",
    warning: "#FFF5CF",
    critical: "#FF4400"
}, typography = {
    fonts: {
        base: [
            '"Nunito Sans"',
            "-apple-system",
            '".SFNSText-Regular"',
            '"San Francisco"',
            "BlinkMacSystemFont",
            '"Segoe UI"',
            '"Helvetica Neue"',
            "Helvetica",
            "Arial",
            "sans-serif"
        ].join(", "),
        mono: [
            "ui-monospace",
            "Menlo",
            "Monaco",
            '"Roboto Mono"',
            '"Oxygen Mono"',
            '"Ubuntu Monospace"',
            '"Source Code Pro"',
            '"Droid Sans Mono"',
            '"Courier New"',
            "monospace"
        ].join(", ")
    },
    weight: {
        regular: 400,
        bold: 700
    },
    size: {
        s1: 12,
        s2: 14,
        s3: 16,
        m1: 20,
        m2: 24,
        m3: 28,
        l1: 32,
        l2: 40,
        l3: 48,
        code: 90
    }
};
var theme = {
    base: "light",
    colorPrimary: "#FF4785",
    colorSecondary: "#029CFD",
    appBg: background.app,
    appContentBg: color.lightest,
    appPreviewBg: color.lightest,
    appBorderColor: color.border,
    appBorderRadius: 4,
    fontBase: typography.fonts.base,
    fontCode: typography.fonts.mono,
    textColor: color.darkest,
    textInverseColor: color.lightest,
    textMutedColor: color.dark,
    barTextColor: color.mediumdark,
    barHoverColor: color.secondary,
    barSelectedColor: color.secondary,
    barBg: color.lightest,
    buttonBg: background.app,
    buttonBorder: color.medium,
    booleanBg: color.mediumlight,
    booleanSelectedBg: color.lightest,
    inputBg: color.lightest,
    inputBorder: color.border,
    inputTextColor: color.darkest,
    inputBorderRadius: 4
}, light_default = theme;
var theme2 = {
    base: "dark",
    colorPrimary: "#FF4785",
    colorSecondary: "#029CFD",
    appBg: "#222425",
    appContentBg: "#1B1C1D",
    appPreviewBg: color.lightest,
    appBorderColor: "rgba(255,255,255,.1)",
    appBorderRadius: 4,
    fontBase: typography.fonts.base,
    fontCode: typography.fonts.mono,
    textColor: "#C9CDCF",
    textInverseColor: "#222425",
    textMutedColor: "#798186",
    barTextColor: "#798186",
    barHoverColor: color.secondary,
    barSelectedColor: color.secondary,
    barBg: "#292C2E",
    buttonBg: "#222425",
    buttonBorder: "rgba(255,255,255,.1)",
    booleanBg: "#222425",
    booleanSelectedBg: "#2E3438",
    inputBg: "#1B1C1D",
    inputBorder: "rgba(255,255,255,.1)",
    inputTextColor: color.lightest,
    inputBorderRadius: 4
}, dark_default = theme2;
var import_global = require("b63b55668d9690ae"), import_client_logger = require("f7874f94e365327a"), { window: globalWindow } = import_global.global;
var isColorString = (color2)=>typeof color2 != "string" ? (import_client_logger.logger.warn(`Color passed to theme object should be a string. Instead ${color2}(${typeof color2}) was passed.`), !1) : !0, isValidColorForPolished = (color2)=>!/(gradient|var|calc)/.test(color2), applyPolished = (type, color2)=>type === "darken" ? rgba(`${curriedDarken$1(1, color2)}`, .95) : type === "lighten" ? rgba(`${curriedLighten$1(1, color2)}`, .95) : color2, colorFactory = (type)=>(color2)=>{
        if (!isColorString(color2) || !isValidColorForPolished(color2)) return color2;
        try {
            return applyPolished(type, color2);
        } catch  {
            return color2;
        }
    }, lightenColor = colorFactory("lighten"), darkenColor = colorFactory("darken"), getPreferredColorScheme = ()=>!globalWindow || !globalWindow.matchMedia ? "light" : globalWindow.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
var themes = {
    light: light_default,
    dark: dark_default,
    normal: light_default
}, preferredColorScheme = getPreferredColorScheme(), create = (vars = {
    base: preferredColorScheme
}, rest)=>{
    let inherit = {
        ...themes[preferredColorScheme],
        ...themes[vars.base] || {},
        ...vars,
        base: themes[vars.base] ? vars.base : preferredColorScheme
    };
    return {
        ...rest,
        ...inherit,
        barSelectedColor: vars.barSelectedColor || inherit.colorSecondary
    };
};

},{"b63b55668d9690ae":"4g4co","f7874f94e365327a":"7OFBO"}],"90UkO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEEPLY_EQUAL", ()=>(0, _chunk4TLWAHSCMjs.DEEPLY_EQUAL));
parcelHelpers.export(exports, "buildArgsParam", ()=>(0, _chunk4TLWAHSCMjs.buildArgsParam));
parcelHelpers.export(exports, "deepDiff", ()=>(0, _chunk4TLWAHSCMjs.deepDiff));
parcelHelpers.export(exports, "getMatch", ()=>(0, _chunk4TLWAHSCMjs.getMatch));
parcelHelpers.export(exports, "parsePath", ()=>(0, _chunk4TLWAHSCMjs.parsePath));
parcelHelpers.export(exports, "queryFromLocation", ()=>(0, _chunk4TLWAHSCMjs.queryFromLocation));
parcelHelpers.export(exports, "queryFromString", ()=>(0, _chunk4TLWAHSCMjs.queryFromString));
parcelHelpers.export(exports, "stringifyQuery", ()=>(0, _chunk4TLWAHSCMjs.stringifyQuery));
parcelHelpers.export(exports, "BaseLocationProvider", ()=>BaseLocationProvider);
parcelHelpers.export(exports, "Link", ()=>Link2);
parcelHelpers.export(exports, "Location", ()=>Location);
parcelHelpers.export(exports, "LocationProvider", ()=>LocationProvider);
parcelHelpers.export(exports, "Match", ()=>Match);
parcelHelpers.export(exports, "Route", ()=>Route2);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate2);
var _chunk4TLWAHSCMjs = require("./chunk-4TLWAHSC.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var global = arguments[3];
var scope = (()=>{
    let win;
    return typeof window < "u" ? win = window : typeof globalThis < "u" ? win = globalThis : typeof global < "u" ? win = global : typeof self < "u" ? win = self : win = {}, win;
})();
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends.apply(this, arguments);
}
var Action;
(function(Action2) {
    Action2.Pop = "POP", Action2.Push = "PUSH", Action2.Replace = "REPLACE";
})(Action || (Action = {}));
var readOnly = function(obj) {
    return Object.freeze(obj);
};
function warning(cond, message) {
    if (!cond) {
        typeof console < "u" && console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
var BeforeUnloadEventType = "beforeunload";
var PopStateEventType = "popstate";
function createBrowserHistory(options) {
    options === void 0 && (options = {});
    var _options = options, _options$window = _options.window, window2 = _options$window === void 0 ? document.defaultView : _options$window, globalHistory = window2.history;
    function getIndexAndLocation() {
        var _window$location = window2.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash, state = globalHistory.state || {};
        return [
            state.idx,
            readOnly({
                pathname,
                search,
                hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) blockers.call(blockedPopTx), blockedPopTx = null;
        else {
            var nextAction = Action.Pop, _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    delta && (blockedPopTx = {
                        action: nextAction,
                        location: nextLocation,
                        retry: function() {
                            go(delta * -1);
                        }
                    }, go(delta));
                } else warning(!1, "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window2.addEventListener(PopStateEventType, handlePop);
    var action = Action.Pop, _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1], listeners = createEvents(), blockers = createEvents();
    index == null && (index = 0, globalHistory.replaceState(_extends({}, globalHistory.state, {
        idx: index
    }), ""));
    function createHref(to) {
        return typeof to == "string" ? to : createPath(to);
    }
    function getNextLocation(to, state) {
        return state === void 0 && (state = null), readOnly(_extends({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to == "string" ? parsePath2(to) : to, {
            state,
            key: createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index2) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index2
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action2, location2, retry) {
        return !blockers.length || (blockers.call({
            action: action2,
            location: location2,
            retry
        }), !1);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0], location = _getIndexAndLocation3[1], listeners.call({
            action,
            location
        });
    }
    function push(to, state) {
        var nextAction = Action.Push, nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1];
            try {
                globalHistory.pushState(historyState, "", url);
            } catch  {
                window2.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = Action.Replace, nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1];
            globalHistory.replaceState(historyState, "", url), applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref,
        push,
        replace,
        go,
        back: function() {
            go(-1);
        },
        forward: function() {
            go(1);
        },
        listen: function(listener) {
            return listeners.push(listener);
        },
        block: function(blocker) {
            var unblock = blockers.push(blocker);
            return blockers.length === 1 && window2.addEventListener(BeforeUnloadEventType, promptBeforeUnload), function() {
                unblock(), blockers.length || window2.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
            };
        }
    };
    return history;
}
function promptBeforeUnload(event) {
    event.preventDefault(), event.returnValue = "";
}
function createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function(fn) {
            return handlers.push(fn), function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
function createPath(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    return search && search !== "?" && (pathname += search.charAt(0) === "?" ? search : "?" + search), hash && hash !== "#" && (pathname += hash.charAt(0) === "#" ? hash : "#" + hash), pathname;
}
function parsePath2(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        hashIndex >= 0 && (parsedPath.hash = path.substr(hashIndex), path = path.substr(0, hashIndex));
        var searchIndex = path.indexOf("?");
        searchIndex >= 0 && (parsedPath.search = path.substr(searchIndex), path = path.substr(0, searchIndex)), path && (parsedPath.pathname = path);
    }
    return parsedPath;
}
function invariant(cond, message) {
    if (!cond) throw new Error(message);
}
function warning2(cond, message) {
    if (!cond) {
        typeof console < "u" && console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
var NavigationContext = (0, _react.createContext)(null);
NavigationContext.displayName = "Navigation";
var LocationContext = (0, _react.createContext)(null);
LocationContext.displayName = "Location";
var RouteContext = (0, _react.createContext)({
    outlet: null,
    matches: []
});
RouteContext.displayName = "Route";
function Router(_ref3) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = Action.Pop, navigator, static: staticProp = !1 } = _ref3;
    useInRouterContext() && invariant(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = normalizePathname(basenameProp), navigationContext = (0, _react.useMemo)(()=>({
            basename,
            navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    typeof locationProp == "string" && (locationProp = parsePath2(locationProp));
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp, location = (0, _react.useMemo)(()=>{
        let trailingPathname = stripBasename(pathname, basename);
        return trailingPathname == null ? null : {
            pathname: trailingPathname,
            search,
            hash,
            state,
            key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    return warning2(location != null, '<Router basename="' + basename + '"> is not able to match the URL ' + ('"' + pathname + search + hash + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), location == null ? null : (0, _react.createElement)(NavigationContext.Provider, {
        value: navigationContext
    }, (0, _react.createElement)(LocationContext.Provider, {
        children,
        value: {
            location,
            navigationType
        }
    }));
}
function useHref(to) {
    useInRouterContext() || invariant(!1, "useHref() may be used only in the context of a <Router> component.");
    let { basename, navigator } = (0, _react.useContext)(NavigationContext), { hash, pathname, search } = useResolvedPath(to), joinedPathname = pathname;
    if (basename !== "/") {
        let toPathname = getToPathname(to), endsWithSlash = toPathname != null && toPathname.endsWith("/");
        joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : joinPaths([
            basename,
            pathname
        ]);
    }
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
function useInRouterContext() {
    return (0, _react.useContext)(LocationContext) != null;
}
function useLocation() {
    return useInRouterContext() || invariant(!1, "useLocation() may be used only in the context of a <Router> component."), (0, _react.useContext)(LocationContext).location;
}
function useNavigate() {
    useInRouterContext() || invariant(!1, "useNavigate() may be used only in the context of a <Router> component.");
    let { basename, navigator } = (0, _react.useContext)(NavigationContext), { matches } = (0, _react.useContext)(RouteContext), { pathname: locationPathname } = useLocation(), routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase)), activeRef = (0, _react.useRef)(!1);
    return (0, _react.useEffect)(()=>{
        activeRef.current = !0;
    }), (0, _react.useCallback)(function(to, options) {
        if (options === void 0 && (options = {}), warning2(activeRef.current, "You should call navigate() in a React.useEffect(), not when your component is first rendered."), !activeRef.current) return;
        if (typeof to == "number") {
            navigator.go(to);
            return;
        }
        let path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
        basename !== "/" && (path.pathname = joinPaths([
            basename,
            path.pathname
        ])), (options.replace ? navigator.replace : navigator.push)(path, options.state);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
}
function useResolvedPath(to) {
    let { matches } = (0, _react.useContext)(RouteContext), { pathname: locationPathname } = useLocation(), routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    return (0, _react.useMemo)(()=>resolveTo(to, JSON.parse(routePathnamesJson), locationPathname), [
        to,
        routePathnamesJson,
        locationPathname
    ]);
}
function resolvePath(to, fromPathname) {
    fromPathname === void 0 && (fromPathname = "/");
    let { pathname: toPathname, search = "", hash = "" } = typeof to == "string" ? parsePath2(to) : to;
    return {
        pathname: toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    return relativePath.split("/").forEach((segment)=>{
        segment === ".." ? segments.length > 1 && segments.pop() : segment !== "." && segments.push(segment);
    }), segments.length > 1 ? segments.join("/") : "/";
}
function resolveTo(toArg, routePathnames, locationPathname) {
    let to = typeof toArg == "string" ? parsePath2(toArg) : toArg, toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname, from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            for(; toSegments[0] === "..";)toSegments.shift(), routePathnameIndex -= 1;
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    return toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/") && (path.pathname += "/"), path;
}
function getToPathname(to) {
    return to === "" || to.pathname === "" ? "/" : typeof to == "string" ? parsePath2(to).pathname : to.pathname;
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let nextChar = pathname.charAt(basename.length);
    return nextChar && nextChar !== "/" ? null : pathname.slice(basename.length) || "/";
}
var joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/"), normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/"), normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search, normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
function _extends2() {
    return _extends2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.keys(source), key, i;
    for(i = 0; i < sourceKeys.length; i++)key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
    return target;
}
var _excluded = [
    "onClick",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to"
];
function BrowserRouter(_ref) {
    let { basename, children, window: window2 } = _ref, historyRef = (0, _react.useRef)();
    historyRef.current == null && (historyRef.current = createBrowserHistory({
        window: window2
    }));
    let history = historyRef.current, [state, setState] = (0, _react.useState)({
        action: history.action,
        location: history.location
    });
    return (0, _react.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]), (0, _react.createElement)(Router, {
        basename,
        children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var Link = (0, _react.forwardRef)(function(_ref3, ref) {
    let { onClick, reloadDocument, replace = !1, state, target, to } = _ref3, rest = _objectWithoutPropertiesLoose(_ref3, _excluded), href = useHref(to), internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target
    });
    function handleClick(event) {
        onClick && onClick(event), !event.defaultPrevented && !reloadDocument && internalOnClick(event);
    }
    return (0, _react.createElement)("a", _extends2({}, rest, {
        href,
        onClick: handleClick,
        ref,
        target
    }));
});
Link.displayName = "Link";
var NavLink = (0, _react.forwardRef)(function(_ref4, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = !1, className: classNameProp = "", end = !1, style: styleProp, to } = _ref4, rest = _objectWithoutPropertiesLoose(_ref4, _excluded2), location = useLocation(), path = useResolvedPath(to), locationPathname = location.pathname, toPathname = path.pathname;
    caseSensitive || (locationPathname = locationPathname.toLowerCase(), toPathname = toPathname.toLowerCase());
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/", ariaCurrent = isActive ? ariaCurrentProp : void 0, className;
    typeof classNameProp == "function" ? className = classNameProp({
        isActive
    }) : className = [
        classNameProp,
        isActive ? "active" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp == "function" ? styleProp({
        isActive
    }) : styleProp;
    return (0, _react.createElement)(Link, _extends2({}, rest, {
        "aria-current": ariaCurrent,
        className,
        ref,
        style,
        to
    }));
});
NavLink.displayName = "NavLink";
function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state } = _temp === void 0 ? {} : _temp, navigate = useNavigate(), location = useLocation(), path = useResolvedPath(to);
    return (0, _react.useCallback)((event)=>{
        if (event.button === 0 && (!target || target === "_self") && !isModifiedEvent(event)) {
            event.preventDefault();
            let replace = !!replaceProp || createPath(location) === createPath(path);
            navigate(to, {
                replace,
                state
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to
    ]);
}
var ToggleVisibility = ({ hidden, children })=>(0, _reactDefault.default).createElement("div", {
        hidden
    }, children);
var { document: document2 } = scope, getBase = ()=>`${document2.location.pathname}?`, useNavigate2 = ()=>{
    let navigate = useNavigate();
    return (0, _react.useCallback)((to, { plain, ...options } = {})=>{
        if (typeof to == "string" && to.startsWith("#")) {
            document2.location.hash = to;
            return;
        }
        if (typeof to == "string") {
            let target = plain ? to : `?path=${to}`;
            return navigate(target, options);
        }
        if (typeof to == "number") return navigate(to);
    }, []);
}, Link2 = ({ to, children, ...rest })=>(0, _reactDefault.default).createElement(Link, {
        to: `${getBase()}path=${to}`,
        ...rest
    }, children);
Link2.displayName = "QueryLink";
var Location = ({ children })=>{
    let location = useLocation(), { path, singleStory } = (0, _chunk4TLWAHSCMjs.queryFromString)(location.search), { viewMode, storyId, refId } = (0, _chunk4TLWAHSCMjs.parsePath)(path);
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children({
        path: path || "/",
        location,
        viewMode,
        storyId,
        refId,
        singleStory: singleStory === "true"
    }));
};
Location.displayName = "QueryLocation";
function Match({ children, path: targetPath, startsWith = !1 }) {
    return (0, _reactDefault.default).createElement(Location, null, ({ path: urlPath, ...rest })=>children({
            match: (0, _chunk4TLWAHSCMjs.getMatch)(urlPath, targetPath, startsWith),
            ...rest
        }));
}
Match.displayName = "QueryMatch";
function Route2(input) {
    let { children, hideOnly, ...rest } = input;
    return rest.startsWith === void 0 && (rest.startsWith = !1), (0, _reactDefault.default).createElement(Match, {
        ...rest
    }, ({ match })=>hideOnly ? (0, _reactDefault.default).createElement(ToggleVisibility, {
            hidden: !match
        }, children) : match ? children : null);
}
Route2.displayName = "Route";
var LocationProvider = (...args)=>BrowserRouter(...args), BaseLocationProvider = (...args)=>Router(...args);

},{"./chunk-4TLWAHSC.mjs":"6UsPh","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"6UsPh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEEPLY_EQUAL", ()=>DEEPLY_EQUAL);
parcelHelpers.export(exports, "buildArgsParam", ()=>buildArgsParam);
parcelHelpers.export(exports, "deepDiff", ()=>deepDiff);
parcelHelpers.export(exports, "getMatch", ()=>getMatch);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "queryFromLocation", ()=>queryFromLocation);
parcelHelpers.export(exports, "queryFromString", ()=>queryFromString);
parcelHelpers.export(exports, "stringifyQuery", ()=>stringifyQuery);
var _clientLogger = require("@storybook/client-logger");
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var _qs = require("qs");
var _qsDefault = parcelHelpers.interopDefault(_qs);
var global = arguments[3];
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod)=>function() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from))!__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
        get: ()=>from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: !0
    }) : target, mod));
var require_freeGlobal = __commonJS({
    "../../node_modules/lodash/_freeGlobal.js" (exports, module) {
        var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
        module.exports = freeGlobal;
    }
});
var require_root = __commonJS({
    "../../node_modules/lodash/_root.js" (exports, module) {
        var freeGlobal = require_freeGlobal(), freeSelf = typeof self == "object" && self && self.Object === Object && self, root = freeGlobal || freeSelf || Function("return this")();
        module.exports = root;
    }
});
var require_Symbol = __commonJS({
    "../../node_modules/lodash/_Symbol.js" (exports, module) {
        var root = require_root(), Symbol2 = root.Symbol;
        module.exports = Symbol2;
    }
});
var require_getRawTag = __commonJS({
    "../../node_modules/lodash/_getRawTag.js" (exports, module) {
        var Symbol2 = require_Symbol(), objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty, nativeObjectToString = objectProto.toString, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
        function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = void 0;
                var unmasked = !0;
            } catch  {}
            var result = nativeObjectToString.call(value);
            return unmasked && (isOwn ? value[symToStringTag] = tag : delete value[symToStringTag]), result;
        }
        module.exports = getRawTag;
    }
});
var require_objectToString = __commonJS({
    "../../node_modules/lodash/_objectToString.js" (exports, module) {
        var objectProto = Object.prototype, nativeObjectToString = objectProto.toString;
        function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        module.exports = objectToString;
    }
});
var require_baseGetTag = __commonJS({
    "../../node_modules/lodash/_baseGetTag.js" (exports, module) {
        var Symbol2 = require_Symbol(), getRawTag = require_getRawTag(), objectToString = require_objectToString(), nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
        function baseGetTag(value) {
            return value == null ? value === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }
        module.exports = baseGetTag;
    }
});
var require_overArg = __commonJS({
    "../../node_modules/lodash/_overArg.js" (exports, module) {
        function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        module.exports = overArg;
    }
});
var require_getPrototype = __commonJS({
    "../../node_modules/lodash/_getPrototype.js" (exports, module) {
        var overArg = require_overArg(), getPrototype = overArg(Object.getPrototypeOf, Object);
        module.exports = getPrototype;
    }
});
var require_isObjectLike = __commonJS({
    "../../node_modules/lodash/isObjectLike.js" (exports, module) {
        function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        module.exports = isObjectLike;
    }
});
var require_isPlainObject = __commonJS({
    "../../node_modules/lodash/isPlainObject.js" (exports, module) {
        var baseGetTag = require_baseGetTag(), getPrototype = require_getPrototype(), isObjectLike = require_isObjectLike(), objectTag = "[object Object]", funcProto = Function.prototype, objectProto = Object.prototype, funcToString = funcProto.toString, hasOwnProperty = objectProto.hasOwnProperty, objectCtorString = funcToString.call(Object);
        function isPlainObject2(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return !1;
            var proto = getPrototype(value);
            if (proto === null) return !0;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        module.exports = isPlainObject2;
    }
});
var has = Object.prototype.hasOwnProperty;
function find(iter, tar, key) {
    for (key of iter.keys())if (dequal(key, tar)) return key;
}
function dequal(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return !0;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) for(; len-- && dequal(foo[len], bar[len]););
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return !1;
            for (len of foo)if (tmp = len, tmp && typeof tmp == "object" && (tmp = find(bar, tmp), !tmp) || !bar.has(tmp)) return !1;
            return !0;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return !1;
            for (len of foo)if (tmp = len[0], tmp && typeof tmp == "object" && (tmp = find(bar, tmp), !tmp) || !dequal(len[1], bar.get(tmp))) return !1;
            return !0;
        }
        if (ctor === ArrayBuffer) foo = new Uint8Array(foo), bar = new Uint8Array(bar);
        else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) for(; len-- && foo.getInt8(len) === bar.getInt8(len););
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) for(; len-- && foo[len] === bar[len];);
            return len === -1;
        }
        if (!ctor || typeof foo == "object") {
            len = 0;
            for(ctor in foo)if (has.call(foo, ctor) && ++len && !has.call(bar, ctor) || !(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return !1;
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
var import_isPlainObject = __toESM(require_isPlainObject());
function dedent(templ) {
    for(var values = [], _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
    var strings = Array.from(typeof templ == "string" ? [
        templ
    ] : templ);
    strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, "");
    var indentLengths = strings.reduce(function(arr, str) {
        var matches = str.match(/\n([\t ]+|(?!\s).)/g);
        return matches ? arr.concat(matches.map(function(match) {
            var _a, _b;
            return (_b = (_a = match.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        })) : arr;
    }, []);
    if (indentLengths.length) {
        var pattern_1 = new RegExp(`
[	 ]{` + Math.min.apply(Math, indentLengths) + "}", "g");
        strings = strings.map(function(str) {
            return str.replace(pattern_1, `
`);
        });
    }
    strings[0] = strings[0].replace(/^\r?\n/, "");
    var string = strings[0];
    return values.forEach(function(value, i) {
        var endentations = string.match(/(?:^|\n)( *)$/), endentation = endentations ? endentations[1] : "", indentedValue = value;
        typeof value == "string" && value.includes(`
`) && (indentedValue = String(value).split(`
`).map(function(str, i2) {
            return i2 === 0 ? str : "" + endentation + str;
        }).join(`
`)), string += indentedValue + strings[i + 1];
    }), string;
}
var splitPathRegex = /\/([^/]+)\/(?:(.*)_)?([^/]+)?/, parsePath = (0, _memoizerificDefault.default)(1e3)((path)=>{
    let result = {
        viewMode: void 0,
        storyId: void 0,
        refId: void 0
    };
    if (path) {
        let [, viewMode, refId, storyId] = path.toLowerCase().match(splitPathRegex) || [];
        viewMode && Object.assign(result, {
            viewMode,
            storyId,
            refId
        });
    }
    return result;
}), DEEPLY_EQUAL = Symbol("Deeply equal"), deepDiff = (value, update)=>{
    if (typeof value != typeof update) return update;
    if (dequal(value, update)) return DEEPLY_EQUAL;
    if (Array.isArray(value) && Array.isArray(update)) {
        let res = update.reduce((acc, upd, index)=>{
            let diff = deepDiff(value[index], upd);
            return diff !== DEEPLY_EQUAL && (acc[index] = diff), acc;
        }, new Array(update.length));
        return update.length >= value.length ? res : res.concat(new Array(value.length - update.length).fill(void 0));
    }
    return (0, import_isPlainObject.default)(value) && (0, import_isPlainObject.default)(update) ? Object.keys({
        ...value,
        ...update
    }).reduce((acc, key)=>{
        let diff = deepDiff(value?.[key], update?.[key]);
        return diff === DEEPLY_EQUAL ? acc : Object.assign(acc, {
            [key]: diff
        });
    }, {}) : update;
}, VALIDATION_REGEXP = /^[a-zA-Z0-9 _-]*$/, NUMBER_REGEXP = /^-?[0-9]+(\.[0-9]+)?$/, HEX_REGEXP = /^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i, COLOR_REGEXP = /^(rgba?|hsla?)\(([0-9]{1,3}),\s?([0-9]{1,3})%?,\s?([0-9]{1,3})%?,?\s?([0-9](\.[0-9]{1,2})?)?\)$/i, validateArgs = (key = "", value)=>key === null || key === "" || !VALIDATION_REGEXP.test(key) ? !1 : value == null || value instanceof Date || typeof value == "number" || typeof value == "boolean" ? !0 : typeof value == "string" ? VALIDATION_REGEXP.test(value) || NUMBER_REGEXP.test(value) || HEX_REGEXP.test(value) || COLOR_REGEXP.test(value) : Array.isArray(value) ? value.every((v)=>validateArgs(key, v)) : (0, import_isPlainObject.default)(value) ? Object.entries(value).every(([k, v])=>validateArgs(k, v)) : !1, encodeSpecialValues = (value)=>value === void 0 ? "!undefined" : value === null ? "!null" : typeof value == "string" ? HEX_REGEXP.test(value) ? `!hex(${value.slice(1)})` : COLOR_REGEXP.test(value) ? `!${value.replace(/[\s%]/g, "")}` : value : typeof value == "boolean" ? `!${value}` : Array.isArray(value) ? value.map(encodeSpecialValues) : (0, import_isPlainObject.default)(value) ? Object.entries(value).reduce((acc, [key, val])=>Object.assign(acc, {
            [key]: encodeSpecialValues(val)
        }), {}) : value, QS_OPTIONS = {
    encode: !1,
    delimiter: ";",
    allowDots: !0,
    format: "RFC1738",
    serializeDate: (date)=>`!date(${date.toISOString()})`
}, buildArgsParam = (initialArgs, args)=>{
    let update = deepDiff(initialArgs, args);
    if (!update || update === DEEPLY_EQUAL) return "";
    let object = Object.entries(update).reduce((acc, [key, value])=>validateArgs(key, value) ? Object.assign(acc, {
            [key]: value
        }) : ((0, _clientLogger.once).warn(dedent`
      Omitted potentially unsafe URL args.

      More info: https://storybook.js.org/docs/react/writing-stories/args#setting-args-through-the-url
    `), acc), {});
    return (0, _qsDefault.default).stringify(encodeSpecialValues(object), QS_OPTIONS).replace(/ /g, "+").split(";").map((part)=>part.replace("=", ":")).join(";");
}, queryFromString = (0, _memoizerificDefault.default)(1e3)((s)=>s !== void 0 ? (0, _qsDefault.default).parse(s, {
        ignoreQueryPrefix: !0
    }) : {}), queryFromLocation = (location)=>queryFromString(location.search), stringifyQuery = (query)=>(0, _qsDefault.default).stringify(query, {
        addQueryPrefix: !0,
        encode: !1
    }), getMatch = (0, _memoizerificDefault.default)(1e3)((current, target, startsWith = !0)=>{
    if (startsWith) {
        if (typeof target != "string") throw new Error("startsWith only works with string targets");
        return current && current.startsWith(target) ? {
            path: current
        } : null;
    }
    let currentIsTarget = typeof target == "string" && current === target, matchTarget = current && target && current.match(target);
    return currentIsTarget || matchTarget ? {
        path: current
    } : null;
});

},{"@storybook/client-logger":"7OFBO","memoizerific":"aOMtb","qs":"iqIDC","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fs2pJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DARK_MODE_EVENT_NAME", ()=>DARK_MODE_EVENT_NAME);
parcelHelpers.export(exports, "UPDATE_DARK_MODE_EVENT_NAME", ()=>UPDATE_DARK_MODE_EVENT_NAME);
var DARK_MODE_EVENT_NAME = 'DARK_MODE';
var UPDATE_DARK_MODE_EVENT_NAME = 'UPDATE_DARK_MODE';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"jEcoY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefersDark", ()=>prefersDark);
parcelHelpers.export(exports, "updateStore", ()=>updateStore);
parcelHelpers.export(exports, "store", ()=>store);
/** A toolbar icon to toggle between dark and light themes in storybook */ parcelHelpers.export(exports, "DarkMode", ()=>DarkMode);
var _react = require("react");
var _global = require("@storybook/global");
var _theming = require("@storybook/theming");
var _components = require("@storybook/components");
var _coreEvents = require("@storybook/core-events");
var _managerApi = require("@storybook/manager-api");
var _fastDeepEqual = require("fast-deep-equal");
var _fastDeepEqualDefault = parcelHelpers.interopDefault(_fastDeepEqual);
var _constants = require("./constants");
var _sun = require("./icons/Sun");
var _moon = require("./icons/Moon");
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var _excluded = [
    "current",
    "stylePreview"
];
var _window$matchMedia;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var _ref = (0, _global.global), document = _ref.document, window = _ref.window;
var modes = [
    'light',
    'dark'
];
var STORAGE_KEY = 'sb-addon-themes-3';
var prefersDark = (_window$matchMedia = window.matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(window, '(prefers-color-scheme: dark)');
var defaultParams = {
    classTarget: 'body',
    dark: (0, _theming.themes).dark,
    darkClass: [
        'dark'
    ],
    light: (0, _theming.themes).light,
    lightClass: [
        'light'
    ],
    stylePreview: false,
    userHasExplicitlySetTheTheme: false
};
var updateStore = function updateStore(newStore) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(newStore));
};
/** Add the light/dark class to an element */ var toggleDarkClass = function toggleDarkClass(el, _ref2) {
    var current = _ref2.current, _ref2$darkClass = _ref2.darkClass, darkClass = _ref2$darkClass === void 0 ? defaultParams.darkClass : _ref2$darkClass, _ref2$lightClass = _ref2.lightClass, lightClass = _ref2$lightClass === void 0 ? defaultParams.lightClass : _ref2$lightClass;
    if (current === 'dark') {
        var _el$classList, _el$classList2;
        (_el$classList = el.classList).remove.apply(_el$classList, _toConsumableArray(arrayify(lightClass)));
        (_el$classList2 = el.classList).add.apply(_el$classList2, _toConsumableArray(arrayify(darkClass)));
    } else {
        var _el$classList3, _el$classList4;
        (_el$classList3 = el.classList).remove.apply(_el$classList3, _toConsumableArray(arrayify(darkClass)));
        (_el$classList4 = el.classList).add.apply(_el$classList4, _toConsumableArray(arrayify(lightClass)));
    }
};
/** Coerce a string to a single item array, or return an array as-is */ var arrayify = function arrayify(classes) {
    var arr = [];
    return arr.concat(classes).map(function(item) {
        return item;
    });
};
/** Update the preview iframe class */ var updatePreview = function updatePreview(store) {
    var _iframe$contentWindow;
    var iframe = document.getElementById('storybook-preview-iframe');
    if (!iframe) return;
    var iframeDocument = iframe.contentDocument || ((_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 ? void 0 : _iframe$contentWindow.document);
    var target = iframeDocument === null || iframeDocument === void 0 ? void 0 : iframeDocument.querySelector(store.classTarget);
    if (!target) return;
    toggleDarkClass(target, store);
};
/** Update the manager iframe class */ var updateManager = function updateManager(store) {
    var manager = document.querySelector(store.classTarget);
    if (!manager) return;
    toggleDarkClass(manager, store);
};
var store = function store() {
    var userTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var storedItem = window.localStorage.getItem(STORAGE_KEY);
    if (typeof storedItem === 'string') {
        var stored = JSON.parse(storedItem);
        if (userTheme) {
            if (userTheme.dark && !(0, _fastDeepEqualDefault.default)(stored.dark, userTheme.dark)) {
                stored.dark = userTheme.dark;
                updateStore(stored);
            }
            if (userTheme.light && !(0, _fastDeepEqualDefault.default)(stored.light, userTheme.light)) {
                stored.light = userTheme.light;
                updateStore(stored);
            }
        }
        return stored;
    }
    return _objectSpread(_objectSpread({}, defaultParams), userTheme);
};
// On initial load, set the dark mode class on the manager
// This is needed if you're using mostly CSS overrides to styles the storybook
// Otherwise the default theme is set in src/preset/manager.tsx
updateManager(store());
function DarkMode(_ref3) {
    var api = _ref3.api;
    var _React$useState = _react.useState(prefersDark.matches), _React$useState2 = _slicedToArray(_React$useState, 2), isDark = _React$useState2[0], setDark = _React$useState2[1];
    var darkModeParams = (0, _managerApi.useParameter)('darkMode', {});
    var defaultMode = darkModeParams.current, stylePreview = darkModeParams.stylePreview, params = _objectWithoutProperties(darkModeParams, _excluded);
    var channel = api.getChannel();
    // Save custom themes on init
    var userHasExplicitlySetTheTheme = _react.useMemo(function() {
        return store(params).userHasExplicitlySetTheTheme;
    }, [
        params
    ]);
    /** Set the theme in storybook, update the local state, and emit an event */ var setMode = _react.useCallback(function(mode) {
        var currentStore = store();
        api.setOptions({
            theme: currentStore[mode]
        });
        setDark(mode === 'dark');
        api.getChannel().emit((0, _constants.DARK_MODE_EVENT_NAME), mode === 'dark');
        updateManager(currentStore);
        if (stylePreview) updatePreview(currentStore);
    }, [
        api,
        stylePreview
    ]);
    /** Update the theme settings in localStorage, react, and storybook */ var updateMode = _react.useCallback(function(mode) {
        var currentStore = store();
        var current = mode || (currentStore.current === 'dark' ? 'light' : 'dark');
        updateStore(_objectSpread(_objectSpread({}, currentStore), {}, {
            current: current
        }));
        setMode(current);
    }, [
        setMode
    ]);
    /** Update the theme based on the color preference */ function prefersDarkUpdate(event) {
        if (userHasExplicitlySetTheTheme || defaultMode) return;
        updateMode(event.matches ? 'dark' : 'light');
    }
    /** Render the current theme */ var renderTheme = _react.useCallback(function() {
        var _store = store(), _store$current = _store.current, current = _store$current === void 0 ? 'light' : _store$current;
        setMode(current);
    }, [
        setMode
    ]);
    /** Handle the user event and side effects */ var handleIconClick = function handleIconClick() {
        updateMode();
        var currentStore = store();
        updateStore(_objectSpread(_objectSpread({}, currentStore), {}, {
            userHasExplicitlySetTheTheme: true
        }));
    };
    /** When storybook params change update the stored themes */ _react.useEffect(function() {
        var currentStore = store();
        // Ensure we use the stores `current` value first to persist
        // themeing between page loads and story changes.
        updateStore(_objectSpread(_objectSpread(_objectSpread({}, currentStore), darkModeParams), {}, {
            current: currentStore.current || darkModeParams.current
        }));
        renderTheme();
    }, [
        darkModeParams,
        renderTheme
    ]);
    _react.useEffect(function() {
        channel.on((0, _coreEvents.STORY_CHANGED), renderTheme);
        channel.on((0, _coreEvents.SET_STORIES), renderTheme);
        channel.on((0, _coreEvents.DOCS_RENDERED), renderTheme);
        prefersDark.addListener(prefersDarkUpdate);
        return function() {
            channel.removeListener((0, _coreEvents.STORY_CHANGED), renderTheme);
            channel.removeListener((0, _coreEvents.SET_STORIES), renderTheme);
            channel.removeListener((0, _coreEvents.DOCS_RENDERED), renderTheme);
            prefersDark.removeListener(prefersDarkUpdate);
        };
    });
    _react.useEffect(function() {
        channel.on((0, _constants.UPDATE_DARK_MODE_EVENT_NAME), updateMode);
        return function() {
            channel.removeListener((0, _constants.UPDATE_DARK_MODE_EVENT_NAME), updateMode);
        };
    });
    // Storybook's first render doesn't have the global user params loaded so we
    // need the effect to run whenever defaultMode is updated
    _react.useEffect(function() {
        // If a users has set the mode this is respected
        if (userHasExplicitlySetTheTheme) return;
        if (defaultMode) updateMode(defaultMode);
        else if (prefersDark.matches) updateMode('dark');
    }, [
        defaultMode,
        updateMode,
        userHasExplicitlySetTheTheme
    ]);
    return /*#__PURE__*/ _react.createElement((0, _components.IconButton), {
        key: "dark-mode",
        title: isDark ? 'Change theme to light mode' : 'Change theme to dark mode',
        onClick: handleIconClick
    }, isDark ? /*#__PURE__*/ _react.createElement((0, _sun.Sun), null) : /*#__PURE__*/ _react.createElement((0, _moon.Moon), null));
}
exports.default = DarkMode;

},{"react":"jEiK2","@storybook/global":"4g4co","@storybook/theming":"bYlbs","@storybook/components":"2BItW","@storybook/core-events":"ZHxpZ","@storybook/manager-api":"hiBwD","fast-deep-equal":"7wZBg","./constants":"fs2pJ","./icons/Sun":"5mtk5","./icons/Moon":"aYQTm","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7wZBg":[function(require,module,exports,__globalThis) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"5mtk5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sun", ()=>Sun);
var _react = require("react");
function Sun() {
    return /*#__PURE__*/ _react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        viewBox: "0 0 129 129",
        enableBackground: "new 0 0 129 129",
        style: {
            fill: 'currentColor'
        }
    }, /*#__PURE__*/ _react.createElement("g", null, /*#__PURE__*/ _react.createElement("path", {
        d: "m64.5,92.6c15.5,0 28-12.6 28-28s-12.6-28-28-28-28,12.6-28,28 12.5,28 28,28zm0-47.9c11,0 19.9,8.9 19.9,19.9 0,11-8.9,19.9-19.9,19.9s-19.9-8.9-19.9-19.9c0-11 8.9-19.9 19.9-19.9z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "m68.6,23.6v-12.9c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1v12.9c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "m60.4,105.6v12.9c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1v-12.9c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "m96.4,38.5l9.1-9.1c1.6-1.6 1.6-4.2 0-5.8-1.6-1.6-4.2-1.6-5.8,0l-9.1,9.1c-1.6,1.6-1.6,4.2 0,5.8 0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "m23.5,105.6c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l9.1-9.1c1.6-1.6 1.6-4.2 0-5.8-1.6-1.6-4.2-1.6-5.8,0l-9.1,9.1c-1.6,1.6-1.6,4.2 0,5.8z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "m122.5,64.6c0-2.3-1.8-4.1-4.1-4.1h-12.9c-2.3,0-4.1,1.8-4.1,4.1 0,2.3 1.8,4.1 4.1,4.1h12.9c2.2,1.42109e-14 4.1-1.8 4.1-4.1z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "m10.6,68.7h12.9c2.3,0 4.1-1.8 4.1-4.1 0-2.3-1.8-4.1-4.1-4.1h-12.9c-2.3,0-4.1,1.8-4.1,4.1 0,2.3 1.9,4.1 4.1,4.1z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "m102.6,106.8c1,0 2.1-0.4 2.9-1.2 1.6-1.6 1.6-4.2 0-5.8l-9.1-9.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l9.1,9.1c0.8,0.8 1.9,1.2 2.9,1.2z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "m38.4,38.5c1.6-1.6 1.6-4.2 0-5.8l-9.1-9.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l9.1,9.1c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2z"
    })));
}

},{"react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"aYQTm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Moon", ()=>Moon);
var _react = require("react");
function Moon() {
    return /*#__PURE__*/ _react.createElement("svg", {
        version: "1.1",
        id: "Capa_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 438.277 438.277",
        style: {
            fill: 'currentColor',
            height: 13
        }
    }, /*#__PURE__*/ _react.createElement("path", {
        d: "M428.756,300.104c-0.664-3.81-2.334-7.047-4.996-9.713c-5.9-5.903-12.752-7.142-20.554-3.716   c-20.937,9.708-42.641,14.558-65.097,14.558c-28.171,0-54.152-6.94-77.943-20.838c-23.791-13.894-42.631-32.736-56.525-56.53   c-13.899-23.793-20.844-49.773-20.844-77.945c0-21.888,4.333-42.683,12.991-62.384c8.66-19.7,21.176-36.973,37.543-51.82   c6.283-5.898,7.713-12.752,4.287-20.557c-3.236-7.801-9.041-11.511-17.415-11.132c-29.121,1.141-56.72,7.664-82.797,19.556   C111.33,31.478,88.917,47.13,70.168,66.548c-18.747,19.414-33.595,42.399-44.54,68.95c-10.942,26.553-16.416,54.39-16.416,83.511   c0,29.694,5.806,58.054,17.416,85.082c11.613,27.028,27.218,50.344,46.824,69.949c19.604,19.599,42.92,35.207,69.951,46.822   c27.028,11.607,55.384,17.415,85.075,17.415c42.64,0,81.987-11.563,118.054-34.69c36.069-23.124,63.05-54.006,80.944-92.645   C429,307.519,429.427,303.906,428.756,300.104z M306.565,384.168c-24.646,11.711-50.676,17.562-78.087,17.562   c-24.743,0-48.39-4.853-70.947-14.558c-22.554-9.705-41.971-22.695-58.246-38.972c-16.271-16.272-29.259-35.686-38.97-58.241   c-9.707-22.556-14.561-46.203-14.561-70.948c0-40.922,12.135-77.466,36.403-109.636c24.266-32.165,55.531-53.959,93.788-65.379   c-19.795,31.405-29.694,65.379-29.694,101.926c0,34.644,8.564,66.715,25.697,96.223c17.128,29.499,40.446,52.811,69.95,69.948   c29.499,17.129,61.565,25.694,96.211,25.694c10.656,0,21.129-0.855,31.408-2.57C352.199,356.155,331.21,372.472,306.565,384.168z"
    }));
}

},{"react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fvBVU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocsRenderer", ()=>(0, _chunkHLWAVYOIMjs.DocsRenderer));
var _chunkHLWAVYOIMjs = require("./chunk-HLWAVYOI.mjs");
var _blocks = require("@storybook/blocks");
parcelHelpers.exportAll(_blocks, exports);

},{"./chunk-HLWAVYOI.mjs":"pmSw0","@storybook/blocks":"7OB19","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"pmSw0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocsRenderer", ()=>DocsRenderer);
parcelHelpers.export(exports, "defaultComponents", ()=>defaultComponents);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDomShim = require("@storybook/react-dom-shim");
var _blocks = require("@storybook/blocks");
var defaultComponents = {
    code: (0, _blocks.CodeOrSourceMdx),
    a: (0, _blocks.AnchorMdx),
    ...(0, _blocks.HeadersMdx)
}, ErrorBoundary = class extends (0, _react.Component) {
    constructor(){
        super(...arguments);
        this.state = {
            hasError: !1
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: !0
        };
    }
    componentDidCatch(err) {
        let { showException } = this.props;
        showException(err);
    }
    render() {
        let { hasError } = this.state, { children } = this.props;
        return hasError ? null : (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    }
}, DocsRenderer = class {
    constructor(){
        this.render = async (context, docsParameter, element)=>{
            let components = {
                ...defaultComponents,
                ...docsParameter?.components
            }, TDocs = (0, _blocks.Docs);
            return new Promise((resolve, reject)=>{
                require("dd9c47df4c78f88f").then(({ MDXProvider })=>(0, _reactDomShim.renderElement)((0, _reactDefault.default).createElement(ErrorBoundary, {
                        showException: reject,
                        key: Math.random()
                    }, (0, _reactDefault.default).createElement(MDXProvider, {
                        components
                    }, (0, _reactDefault.default).createElement(TDocs, {
                        context,
                        docsParameter
                    }))), element)).then(()=>resolve());
            });
        }, this.unmount = (element)=>{
            (0, _reactDomShim.unmountElement)(element);
        };
    }
};

},{"react":"jEiK2","@storybook/react-dom-shim":"cN71e","@storybook/blocks":"7OB19","dd9c47df4c78f88f":"2gE6f","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cN71e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderElement", ()=>renderElement);
parcelHelpers.export(exports, "unmountElement", ()=>unmountElement);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var nodes = new Map, WithCallback = ({ callback, children })=>{
    let once = (0, _react.useRef)();
    return (0, _react.useLayoutEffect)(()=>{
        once.current !== callback && (once.current = callback, callback());
    }, [
        callback
    ]), children;
}, renderElement = async (node, el)=>{
    let root = await getReactRoot(el);
    return new Promise((resolve)=>{
        root.render((0, _reactDefault.default).createElement(WithCallback, {
            callback: ()=>resolve(null)
        }, node));
    });
}, unmountElement = (el, shouldUseNewRootApi)=>{
    let root = nodes.get(el);
    root && (root.unmount(), nodes.delete(el));
}, getReactRoot = async (el)=>{
    let root = nodes.get(el);
    return root || (root = (0, _clientDefault.default).createRoot(el), nodes.set(el, root)), root;
};

},{"react":"jEiK2","react-dom/client":"18oA0","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"18oA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_clientJs);
var _clientJs = require("react-dom/client.js");
parcelHelpers.exportAll(_clientJs, exports);

},{"react-dom/client.js":"9MtVF","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9MtVF":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
exports.createRoot = function(c, o) {
    i.usingClientEntryPoint = true;
    try {
        return m.createRoot(c, o);
    } finally{
        i.usingClientEntryPoint = false;
    }
};
exports.hydrateRoot = function(c, h, o) {
    i.usingClientEntryPoint = true;
    try {
        return m.hydrateRoot(c, h, o);
    } finally{
        i.usingClientEntryPoint = false;
    }
};

},{"aaccff5d309d9239":"a0ZmT"}],"2gE6f":[function(require,module,exports,__globalThis) {
module.exports = require("3d383fbc7e355ad7")(require("99dc3e140527ed53").resolve("ky9uo")).then(()=>module.bundle.root('5erN3'));

},{"3d383fbc7e355ad7":"bvDWj","99dc3e140527ed53":"kK08P"}],"3g9OG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withProviderSwitcher", ()=>withProviderSwitcher);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _previewApi = require("@storybook/preview-api");
// Importing from src so that HMR works.
// Without this, all HMR updates will bubble through the index.ts and up 
// to the root instead of stopping at the story files.
var _provider = require("@react-spectrum/s2/src/Provider");
document.body.style.margin = '0';
const providerValuesFromUrl = Object.entries((0, _previewApi.getQueryParams)()).reduce((acc, [k, v])=>{
    if (k.includes('providerSwitcher-')) return {
        ...acc,
        [k.replace('providerSwitcher-', '')]: v
    };
    return acc;
}, {});
function ProviderUpdater(props) {
    let [localeValue, setLocale] = (0, _react.useState)(providerValuesFromUrl.locale || undefined);
    (0, _react.useEffect)(()=>{
        let channel = (0, _previewApi.addons).getChannel();
        let providerUpdate = (event)=>{
            setLocale(event.locale);
        };
        channel.on('provider/updated', providerUpdate);
        channel.emit('rsp/ready-for-update');
        return ()=>{
            channel.removeListener('provider/updated', providerUpdate);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _provider.Provider), {
        locale: localeValue,
        children: props.children
    });
}
const withProviderSwitcher = (0, _previewApi.makeDecorator)({
    name: 'withProviderSwitcher',
    parameterName: 'providerSwitcher',
    wrapper: (getStory, context, { options, parameters })=>{
        options = {
            ...options,
            ...parameters
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderUpdater, {
            options: options,
            context: context,
            children: getStory(context)
        });
    }
});

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@storybook/preview-api":"uDWyg","@react-spectrum/s2/src/Provider":"hIsCH","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hIsCH":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSchemeContext", ()=>ColorSchemeContext);
parcelHelpers.export(exports, "Provider", ()=>Provider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _runtime = require("../style/runtime");
const ColorSchemeContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Provider(props) {
    let result = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderInner, {
        ...props
    });
    let parentColorScheme = (0, _react.useContext)(ColorSchemeContext);
    let colorScheme = props.colorScheme || parentColorScheme;
    if (colorScheme !== parentColorScheme) result = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeContext.Provider, {
        value: colorScheme,
        children: result
    });
    if (props.locale) result = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.I18nProvider), {
        locale: props.locale,
        children: result
    });
    if (props.router) result = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.RouterProvider), {
        ...props.router,
        children: result
    });
    return result;
}
undefined;
let providerStyles = function anonymous(props) {
    let rules = " .";
    if (props.colorScheme === "dark") rules += ' _Bb';
    else if (props.colorScheme === "light") rules += ' _Ba';
    else if (props.colorScheme === "light dark") rules += ' _Bc';
    else rules += ' _B-10jn6wd';
    if (props.background === "layer-2") rules += ' -_1de2x0q_b-______x';
    else if (props.background === "layer-1") rules += ' -_1de2x0q_b-e';
    else if (props.background === "base") rules += ' -_1de2x0q_b-d';
    if (props.background === "layer-2") rules += ' b-1de2x0q';
    else if (props.background === "layer-1") rules += ' b-1de2x0q';
    else if (props.background === "base") rules += ' b-1de2x0q';
    return rules;
};
function ProviderInner(props) {
    let { elementType: Element = 'div', UNSAFE_style, UNSAFE_className = '', styles, children, background, colorScheme } = props;
    let { locale, direction } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
        lang: locale,
        dir: direction,
        style: UNSAFE_style,
        className: UNSAFE_className + (0, _runtime.mergeStyles)(styles, providerStyles({
            background,
            colorScheme
        })),
        children: children
    });
}

},{"0":"2YCuu","1":"k7PpT","react/jsx-runtime":"2JzhG","react":"jEiK2","react-aria-components":"8nuKL","../style/runtime":"dzhKB","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2YCuu":[function() {},{}],"k7PpT":[function() {},{}],"gTbQg":[function() {},{}],"1JbRX":[function(require,module,exports,__globalThis) {
module.exports = require("520d4175af2c4656").getBundleURL('6VRlG') + "logo.7718c6df.svg";

},{"520d4175af2c4656":"kMf2L"}],"16UVx":[function(require,module,exports,__globalThis) {
module.exports = require("f6bc9c42569f8c59").getBundleURL('6VRlG') + "logo-dark.ba5147f0.svg";

},{"f6bc9c42569f8c59":"kMf2L"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.7365b51a.js.map
